var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoolveticaCrammedRgRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Thu Apr  4 10:45:56 2019\n By Aleksey,,,\n(c) 1999-2019 Typodermic Fonts Inc.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "CoolveticaCrammedRg-Regular",
    horizAdvX: 181
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Coolvetica Crammed Rg",
    fontWeight: 400,
    fontStretch: "ultra-condensed",
    unitsPerEm: 1000,
    panose1: "2 11 6 8 3 6 2 2 0 4",
    ascent: 767,
    descent: -233,
    xHeight: 486,
    capHeight: 664,
    bbox: "-174 -234 315 846",
    underlineThickness: 20,
    underlinePosition: -163,
    unicodeRange: "U+0017-E006"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 148,
    d: "M45 0q-33 0 -33 30v603q0 31 33 31h58q33 0 33 -31v-603q0 -30 -33 -30h-58zM113 633q0 9 -10 9h-58q-11 0 -11 -9v-603q0 -10 11 -10h58q10 0 10 10v603z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 148,
    d: "M45 0q-33 0 -33 30v603q0 31 33 31h58q33 0 33 -31v-603q0 -30 -33 -30h-58zM113 633q0 9 -10 9h-58q-11 0 -11 -9v-603q0 -10 11 -10h58q10 0 10 10v603z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0017",
    horizAdvX: 60
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 60
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 91,
    d: "M17 0v82h55v-82h-55zM26 157q-4 33 -7 67.5t-3 71.5v368h58v-350q0 -42 -2.5 -81t-7.5 -76h-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 131,
    d: "M12 478zM12 478v194h42v-194h-42zM76 478v194h42v-194h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 197,
    d: "M29 0l10 219h-26l3 37h24l8 160h-27l3 37h26l10 211h38l-10 -211h31l10 211h38l-10 -211h27l-4 -37h-25l-8 -160h29l-4 -37h-26l-10 -219h-38l10 219h-30l-10 -219h-39zM79 256h30l8 160h-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 192,
    d: "M74 -60v67q-62 9 -62 85v107h52v-114q0 -30 28 -30q16 0 22 8t6 21v164q0 16 -3.5 24.5t-9.5 14.5q-14 14 -30.5 23t-33.5 25q-13 13 -21.5 29.5t-8.5 39.5v170q0 32 11.5 55.5t49.5 27.5v73h42v-75q30 -6 43.5 -28.5t13.5 -58.5v-100h-52v111q0 29 -26 29q-14 0 -20 -7 t-6 -18v-158q0 -25 3 -33t14 -18q20 -17 37.5 -26.5t31.5 -23.5q11 -11 17.5 -26.5t6.5 -39.5v-165q0 -39 -15 -60t-48 -26v-67h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 199,
    d: "M5 0zM22 -11l120 688h34l-121 -688h-33zM86 421q0 -54 -40 -54q-41 0 -41 55v190q0 53 41 53q40 0 40 -53v-191zM56 612q0 26 -10 26q-11 0 -11 -26v-191q0 -26 11 -26q10 0 10 26v191zM194 52q0 -54 -40 -54q-41 0 -41 55v190q0 53 41 53q40 0 40 -53v-191zM164 243 q0 26 -10 26q-11 0 -11 -26v-191q0 -26 11 -26q10 0 10 26v191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 180,
    d: "M12 296q0 27 11.5 40t27.5 16v4q-35 6 -35 52v181q0 29 18 52t58 23h20v-52h-19q-13 0 -18.5 -8t-5.5 -20v-181q0 -17 5 -22.5t20 -5.5h11v-47h-13q-14 0 -19 -7t-5 -21v-222q0 -30 27 -30q26 0 26 30v297h48v-294q0 -84 -77 -84q-80 0 -80 85v214z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 66,
    d: "M12 478v194h42v-194h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 113,
    d: "M68 -143q-11 45 -20 97.5t-15 109.5t-9 116t-3 118q0 115 12 228t35 202h38q-19 -98 -28 -208.5t-9 -222.5q0 -110 9 -223.5t28 -216.5h-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 113,
    d: "M8 -143q18 104 27.5 217t9.5 224t-9.5 222t-27.5 208h38q11 -44 19.5 -95t14.5 -106.5t9 -113t3 -114.5q0 -59 -3 -118.5t-9 -116.5t-14.5 -109.5t-19.5 -97.5h-38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 164,
    d: "M115 523l-34 44l-32 -44l-25 17l33 47l-51 16l8 28l51 -17v58h32v-58l51 17l10 -28l-52 -16l33 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 171,
    d: "M64 261v53h-52v41h52v53h42v-53h53v-41h-53v-53h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 79,
    d: "M12 -95q24 14 24 45v50h-24v82h54v-125q0 -71 -54 -83v31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 86,
    d: "M9 281v47h67v-47h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "\xAD",
    horizAdvX: 86,
    d: "M9 281v47h67v-47h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 79,
    d: "M12 0v82h54v-82h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 106,
    d: "M0 0l62 664h44l-63 -664h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 185,
    d: "M172 104q0 -107 -79 -107q-81 0 -81 109v452q0 109 81 109q79 0 79 -108v-455zM117 560q0 56 -25 56t-25 -56v-456q0 -56 25 -56t25 56v456z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 107,
    d: "M41 0v588h-33v44q22 0 30 8.5t10 23.5h47v-664h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 178,
    d: "M12 0v201q0 25 5.5 43t19.5 36q15 19 35 36t31 31q7 9 9.5 17t2.5 25v197q0 14 -5 21.5t-19 7.5t-19.5 -8t-5.5 -23v-125h-53v120q0 22 2.5 38.5t11 27.5t23.5 16.5t41 5.5q47 0 62 -19t15 -60v-201q0 -23 -5 -37t-16 -28q-14 -17 -32 -32.5t-31 -31.5q-11 -13 -13.5 -23 t-2.5 -22v-164h100v-49h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 178,
    d: "M169 82q0 -85 -79 -85q-78 0 -78 84v112h52v-115q0 -30 25 -30t25 30v222q0 28 -28 28h-22v47h23q15 0 20.5 7t5.5 20v185q0 12 -6 20t-18 8q-25 0 -25 -28v-111h-52v105q0 41 20 63.5t57 22.5q40 0 57.5 -23.5t17.5 -50.5v-186q0 -46 -34 -52v-4q17 -3 28 -16t11 -40 v-213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: "\u0417",
    horizAdvX: 178,
    d: "M169 82q0 -85 -79 -85q-78 0 -78 84v112h52v-115q0 -30 25 -30t25 30v222q0 28 -28 28h-22v47h23q15 0 20.5 7t5.5 20v185q0 12 -6 20t-18 8q-25 0 -25 -28v-111h-52v105q0 41 20 63.5t57 22.5q40 0 57.5 -23.5t17.5 -50.5v-186q0 -46 -34 -52v-4q17 -3 28 -16t11 -40 v-213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 182,
    d: "M97 499h-4l-46 -277h50v277zM96 0v176h-88v45l75 443h67v-442h24v-46h-24v-176h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    d: "M169 82q0 -85 -79 -85q-15 0 -29 3.5t-25 13t-17.5 25.5t-6.5 41v91h52v-93q0 -17 7 -23.5t18 -6.5q25 0 25 30v258q0 15 -6.5 21t-16.5 6q-8 0 -13.5 -4t-10.5 -15h-55l7 320h140v-49h-92l-5 -229h4q8 12 17.5 18t26.5 6q24 0 41.5 -14t17.5 -55v-259z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    d: "M169 81q0 -84 -78 -84q-79 0 -79 85v498q0 42 20 64.5t60 22.5q37 0 57 -20t20 -58v-92h-53v89q0 29 -24 29q-25 0 -25 -30v-204h4q8 13 18 20t27 7q24 0 38.5 -15.5t14.5 -44.5v-267zM116 335q0 27 -22 27q-21 0 -27 -24v-260q0 -30 25 -30q24 0 24 30v257z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 150,
    d: "M30 0q1 69 6 151.5t13.5 166t20 160.5t24.5 135h-86v51h134v-46q-14 -61 -25 -139t-18 -161.5t-10.5 -166t-3.5 -151.5h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 178,
    d: "M112 587q0 12 -5.5 20t-17.5 8q-13 0 -18.5 -8t-5.5 -20v-188q0 -14 5 -21t19 -7t18.5 7t4.5 21v188zM114 298q0 26 -25 26q-14 0 -19.5 -6.5t-5.5 -19.5v-220q0 -30 25 -30t25 30v220zM169 82q0 -85 -80 -85q-81 0 -81 85v210q0 27 11 40t28 16v4q-34 7 -34 52v189 q0 28 18 51t58 23t57.5 -23t17.5 -51v-189q0 -45 -34 -52v-4q17 -3 28 -16t11 -40v-210z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    d: "M114 305h-4q-16 -28 -45 -28q-25 0 -39 16t-14 44v245q0 85 78 85q79 0 79 -86v-497q0 -42 -20 -64.5t-60 -22.5q-76 0 -76 77v103h52v-100q0 -28 24 -28q25 0 25 30v226zM114 586q0 30 -25 30t-25 -30v-236q0 -26 23 -26q20 0 27 23v239z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 79,
    d: "M12 48v82h54v-82h-54zM12 355v83h54v-83h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 79,
    d: "M12 355v83h54v-83h-54zM12 -47q24 14 24 45v50h-24v82h54v-125q0 -71 -54 -83v31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 171,
    d: "M12 310v44l147 70v-48l-100 -42v-4l100 -43v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 171,
    d: "M12 370v42h147v-42h-147zM12 253v41h147v-41h-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 171,
    d: "M12 241v46l100 43v4l-100 42v48l147 -70v-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 173,
    d: "M59 0v74h54v-74h-54zM60 149v89q0 34 2 53t7 29q1 3 5.5 11.5t10 18t10.5 18t7 13.5q4 9 5.5 20.5t1.5 38.5v144q0 17 -5 24t-19 7q-15 0 -19.5 -7.5t-4.5 -23.5v-113h-53v90q0 26 2.5 45.5t10.5 33t24 20.5t42 7q46 0 60.5 -23.5t14.5 -75.5v-128q0 -34 -1.5 -48.5 t-6.5 -25.5q-2 -3 -6 -11.5t-9.5 -18t-10 -19t-7.5 -15.5q-6 -14 -7.5 -28.5t-1.5 -44.5v-80h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 235,
    d: "M195 -70q-25 -14 -74 -14q-40 0 -62 10.5t-32.5 30t-12.5 48.5t-2 65v398q0 37 2 66t12.5 49t32 30.5t60.5 10.5q37 0 58 -10t31 -29t12 -47.5t2 -65.5v-318q0 -59 -48 -59q-22 0 -32 16h-4q-7 -10 -14 -13t-15 -3q-37 0 -37 56v254q0 27 9 38.5t26 11.5q19 0 28 -15h3 l2 12h24v-314q0 -13 11 -13q13 0 13 22v324q0 39 -3.5 62.5t-11.5 36t-21.5 16.5t-33.5 4q-22 0 -36 -4.5t-21.5 -17.5t-10.5 -37t-3 -63v-397q0 -38 3.5 -61t12.5 -35.5t23.5 -17t35.5 -4.5q36 0 63 10zM105 156q0 -16 3 -22t11 -6t12 6t4 23v248q0 20 -16 20 q-14 0 -14 -17v-252z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 186,
    d: "M126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "\u0410",
    horizAdvX: 186,
    d: "M126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "\u0391",
    horizAdvX: 186,
    d: "M126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 182,
    d: "M12 0v664h92q35 0 49.5 -18t14.5 -51v-190q0 -46 -33 -53v-4q17 -3 27.5 -14.5t10.5 -40.5v-235q0 -29 -14 -43.5t-48 -14.5h-99zM117 297q0 27 -25 27h-25v-276h25q25 0 25 28v221zM116 583q0 33 -23 33h-26v-245h26q11 0 17 6t6 22v184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "\u0412",
    horizAdvX: 182,
    d: "M12 0v664h92q35 0 49.5 -18t14.5 -51v-190q0 -46 -33 -53v-4q17 -3 27.5 -14.5t10.5 -40.5v-235q0 -29 -14 -43.5t-48 -14.5h-99zM117 297q0 27 -25 27h-25v-276h25q25 0 25 28v221zM116 583q0 33 -23 33h-26v-245h26q11 0 17 6t6 22v184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "\u0392",
    horizAdvX: 182,
    d: "M12 0v664h92q35 0 49.5 -18t14.5 -51v-190q0 -46 -33 -53v-4q17 -3 27.5 -14.5t10.5 -40.5v-235q0 -29 -14 -43.5t-48 -14.5h-99zM117 297q0 27 -25 27h-25v-276h25q25 0 25 28v221zM116 583q0 33 -23 33h-26v-245h26q11 0 17 6t6 22v184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    d: "M116 271h53v-190q0 -84 -77 -84q-80 0 -80 85v498q0 42 19.5 64.5t61.5 22.5q36 0 56 -20t20 -68v-153h-53v158q0 31 -24 31q-25 0 -25 -30v-506q0 -31 24 -31q25 0 25 30v193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "\u0421",
    d: "M116 271h53v-190q0 -84 -77 -84q-80 0 -80 85v498q0 42 19.5 64.5t61.5 22.5q36 0 56 -20t20 -68v-153h-53v158q0 31 -24 31q-25 0 -25 -30v-506q0 -31 24 -31q25 0 25 30v193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 185,
    d: "M12 0v664h83q77 0 77 -78v-504q0 -82 -77 -82h-83zM92 50q24 0 24 35v497q0 18 -7 24.5t-21 6.5h-21v-563h25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 145,
    d: "M12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "\u0415",
    horizAdvX: 145,
    d: "M12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "\u0395",
    horizAdvX: 145,
    d: "M12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 145,
    d: "M12 0v664h125v-51h-69v-248h58v-50h-58v-315h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    d: "M133 0l-2 21h-4q-5 -10 -15.5 -17t-29.5 -7q-33 0 -51.5 22t-18.5 63v498q0 42 20 64.5t58 22.5q39 0 59 -23t20 -65v-120h-53v125q0 31 -25 31q-24 0 -24 -30v-507q0 -30 24 -30q22 0 25 27v209h-28v50h81v-334h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 187,
    d: "M118 0v329h-50v-329h-56v664h56v-286h50v286h56v-664h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "\u041D",
    horizAdvX: 187,
    d: "M118 0v329h-50v-329h-56v664h56v-286h50v286h56v-664h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "\u0397",
    horizAdvX: 187,
    d: "M118 0v329h-50v-329h-56v664h56v-286h50v286h56v-664h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 80,
    d: "M12 0v664h56v-664h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u04CF",
    horizAdvX: 80,
    d: "M12 0v664h56v-664h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u04C0",
    horizAdvX: 80,
    d: "M12 0v664h56v-664h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u0406",
    horizAdvX: 80,
    d: "M12 0v664h56v-664h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u0399",
    horizAdvX: 80,
    d: "M12 0v664h56v-664h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 177,
    d: "M110 664h55v-582q0 -85 -79 -85q-78 0 -78 84v164h53v-167q0 -30 24 -30q25 0 25 30v586z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "\u0408",
    horizAdvX: 177,
    d: "M110 664h55v-582q0 -85 -79 -85q-78 0 -78 84v164h53v-167q0 -30 24 -30q25 0 25 30v586z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 184,
    d: "M123 0l-36 285h-2l-17 -76v-209h-56v664h56v-259h4l52 259h56l-53 -257l52 -407h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "\u041A",
    horizAdvX: 184,
    d: "M123 0l-36 285h-2l-17 -76v-209h-56v664h56v-259h4l52 259h56l-53 -257l52 -407h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "\u039A",
    horizAdvX: 184,
    d: "M123 0l-36 285h-2l-17 -76v-209h-56v664h56v-259h4l52 259h56l-53 -257l52 -407h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 149,
    d: "M12 0v664h56v-613h73v-51h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 263,
    d: "M201 0v307v22.5v41t0.5 49.5t0.5 50t0.5 42t0.5 24h-4l-42 -536h-52l-42 536h-4q0 -9 0.5 -20.5t1 -35t0.5 -64.5v-109v-307h-49v664h87l31 -499h4l31 499h86v-664h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "\u041C",
    horizAdvX: 263,
    d: "M201 0v307v22.5v41t0.5 49.5t0.5 50t0.5 42t0.5 24h-4l-42 -536h-52l-42 536h-4q0 -9 0.5 -20.5t1 -35t0.5 -64.5v-109v-307h-49v664h87l31 -499h4l31 499h86v-664h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "\u039C",
    horizAdvX: 263,
    d: "M201 0v307v22.5v41t0.5 49.5t0.5 50t0.5 42t0.5 24h-4l-42 -536h-52l-42 536h-4q0 -9 0.5 -20.5t1 -35t0.5 -64.5v-109v-307h-49v664h87l31 -499h4l31 499h86v-664h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 196,
    d: "M111 0l-52 532h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-289h-45v664h80l44 -527h4q0 15 -0.5 35.5t-1 53.5t-1 82t-0.5 121v235h47v-664h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "\u039D",
    horizAdvX: 196,
    d: "M111 0l-52 532h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-289h-45v664h80l44 -527h4q0 15 -0.5 35.5t-1 53.5t-1 82t-0.5 121v235h47v-664h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    d: "M170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "\u041E",
    d: "M170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "\u039F",
    d: "M170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 179,
    d: "M68 259v-259h-56v664h94q35 0 49.5 -18.5t14.5 -50.5v-268q0 -32 -14.5 -50t-49.5 -18h-38zM68 308h26q23 0 23 28v253q0 24 -23 24h-26v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "\u0420",
    horizAdvX: 179,
    d: "M68 259v-259h-56v664h94q35 0 49.5 -18.5t14.5 -50.5v-268q0 -32 -14.5 -50t-49.5 -18h-38zM68 308h26q23 0 23 28v253q0 24 -23 24h-26v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "\u03A1",
    horizAdvX: 179,
    d: "M68 259v-259h-56v664h94q35 0 49.5 -18.5t14.5 -50.5v-268q0 -32 -14.5 -50t-49.5 -18h-38zM68 308h26q23 0 23 28v253q0 24 -23 24h-26v-305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 180,
    d: "M170 85q0 -35 -15 -56t-41 -27v-166q0 -19 18 -19q19 0 19 19v142h49v-137q0 -32 -14.5 -53t-52.5 -21t-52.5 21t-14.5 53v162q-26 6 -41 27t-15 56v492q0 42 18.5 65.5t58.5 23.5q39 0 61 -23t22 -65v-494zM115 583q0 14 -6.5 23t-19.5 9q-24 0 -24 -32v-501 q0 -31 24 -31q26 0 26 30v502z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    d: "M12 0v664h94q35 0 49.5 -18t14.5 -51v-213q0 -44 -34 -52v-4q17 -4 26 -15.5t9 -37.5v-273h-54v278q0 25 -23 25h-27v-303h-55zM116 589q0 24 -23 24h-26v-265h26q23 0 23 28v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 188,
    d: "M119 457v128q0 14 -6 22t-20 8t-20 -7.5t-6 -18.5v-111q0 -20 1 -32t2.5 -20t4.5 -13.5t8 -11.5q20 -28 39 -45t35 -39q12 -17 16 -33.5t4 -48.5v-150q0 -45 -19.5 -66.5t-62.5 -21.5q-45 0 -65 23.5t-20 68.5v110h52v-120q0 -31 30 -31q27 0 27 28v136q0 21 -1 34t-3 22 t-6 15.5t-10 14.5q-18 23 -39 43t-32 44q-8 17 -12.5 43.5t-4.5 55.5v104q0 35 19.5 57t60.5 22q42 0 61 -24.5t19 -63.5v-122h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "\u0405",
    horizAdvX: 188,
    d: "M119 457v128q0 14 -6 22t-20 8t-20 -7.5t-6 -18.5v-111q0 -20 1 -32t2.5 -20t4.5 -13.5t8 -11.5q20 -28 39 -45t35 -39q12 -17 16 -33.5t4 -48.5v-150q0 -45 -19.5 -66.5t-62.5 -21.5q-45 0 -65 23.5t-20 68.5v110h52v-120q0 -31 30 -31q27 0 27 28v136q0 21 -1 34t-3 22 t-6 15.5t-10 14.5q-18 23 -39 43t-32 44q-8 17 -12.5 43.5t-4.5 55.5v104q0 35 19.5 57t60.5 22q42 0 61 -24.5t19 -63.5v-122h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 175,
    d: "M59 0v613h-51v51h159v-51h-52v-613h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "\u0422",
    horizAdvX: 175,
    d: "M59 0v613h-51v51h159v-51h-52v-613h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "\u03A4",
    horizAdvX: 175,
    d: "M59 0v613h-51v51h159v-51h-52v-613h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 184,
    d: "M116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 186,
    d: "M48 0l-44 664h55l32 -542h4l32 542h54l-45 -664h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 274,
    d: "M35 0l-31 664h53l19 -547h4l25 547h64l26 -547h4l18 547h53l-31 -664h-80l-20 536h-4l-20 -536h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 195,
    d: "M188 664l-52 -317l54 -347h-57l-34 262h-4l-35 -262h-56l55 335l-53 329h56l34 -248h4l33 248h55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "\u0425",
    horizAdvX: 195,
    d: "M188 664l-52 -317l54 -347h-57l-34 262h-4l-35 -262h-56l55 335l-53 329h56l34 -248h4l33 248h55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "\u03A7",
    horizAdvX: 195,
    d: "M188 664l-52 -317l54 -347h-57l-34 262h-4l-35 -262h-56l55 335l-53 329h56l34 -248h4l33 248h55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 184,
    d: "M65 0v274l-62 390h57l31 -250h4l29 250h57l-60 -390v-274h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "\u04AE",
    horizAdvX: 184,
    d: "M65 0v274l-62 390h57l31 -250h4l29 250h57l-60 -390v-274h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "\u03A5",
    horizAdvX: 184,
    d: "M65 0v274l-62 390h57l31 -250h4l29 250h57l-60 -390v-274h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 168,
    d: "M8 0v51l96 562h-95v51h148v-50l-94 -564h97v-50h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "\u0396",
    horizAdvX: 168,
    d: "M8 0v51l96 562h-95v51h148v-50l-94 -564h97v-50h-152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 113,
    d: "M22 -130v849h84v-45h-42v-760h42v-44h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 106,
    d: "M62 0l-62 664h44l62 -664h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 113,
    d: "M8 -130v44h41v760h-41v45h83v-849h-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 171,
    d: "M59 664h54l55 -213h-47l-34 154h-4l-33 -154h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 123,
    d: "M0 -91v36h124v-36h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 126,
    d: "M12 596l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 177,
    d: "M112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19q-25 0 -25 -21 v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "\u0430",
    horizAdvX: 177,
    d: "M112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19q-25 0 -25 -21 v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    d: "M114 414q0 28 -23 28q-13 0 -18 -10.5t-8 -33.5v-318q3 -18 9 -27.5t18 -9.5q9 0 15.5 6.5t6.5 22.5v342zM13 0v672h52v-211h4q10 14 19.5 21t27.5 7q26 0 38.5 -16.5t12.5 -62.5v-345q0 -41 -15 -54.5t-38 -13.5q-15 0 -27 6.5t-21 26.5h-4l-1 -30h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 177,
    d: "M113 178h50v-105q0 -38 -17.5 -57t-56.5 -19q-76 0 -76 76v339q0 77 76 77q39 0 56.5 -19.5t17.5 -57.5v-102h-50v102q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "\u0441",
    horizAdvX: 177,
    d: "M113 178h50v-105q0 -38 -17.5 -57t-56.5 -19q-76 0 -76 76v339q0 77 76 77q39 0 56.5 -19.5t17.5 -57.5v-102h-50v102q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    d: "M67 72q0 -29 23 -29q12 0 17.5 7.5t8.5 24.5v333q-3 19 -8 26.5t-17 7.5q-24 0 -24 -28v-342zM120 0l-2 30h-4q-12 -33 -47 -33q-26 0 -40 16t-14 45v369q0 29 14.5 45.5t40.5 16.5q29 0 42 -28h4v211h53v-672h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 179,
    d: "M166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "\u0435",
    horizAdvX: 179,
    d: "M166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 140,
    d: "M133 438h-44v-438h-54v438h-28v48h28v112q0 74 79 74h18v-48h-18q-25 0 -25 -26v-112h44v-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    d: "M167 -157q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-4q-12 -28 -46 -28q-25 0 -38 14t-13 47v363q0 31 14.5 48t40.5 17q18 0 28 -8.5t18 -25.5h4l2 31h47v-643zM67 77q0 -28 23 -28q20 0 26 30v330q-6 33 -25 33q-24 0 -24 -28v-337z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 182,
    d: "M115 0v416q0 26 -22 26q-21 0 -27 -28v-414h-53v672h53v-218h4q8 17 19 26t31 9q27 0 38 -16.5t11 -51.5v-421h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "\u04BB",
    horizAdvX: 182,
    d: "M115 0v416q0 26 -22 26q-21 0 -27 -28v-414h-53v672h53v-218h4q8 17 19 26t31 9q27 0 38 -16.5t11 -51.5v-421h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 80,
    d: "M13 0v486h53v-486h-53zM13 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "\u0456",
    horizAdvX: 80,
    d: "M13 0v486h53v-486h-53zM13 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 86,
    d: "M-82 -27h52v-130q0 -28 24 -28t24 28v643h54v-643q0 -76 -77 -76t-77 76v130zM18 530v75h54v-75h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "\u0458",
    horizAdvX: 86,
    d: "M-82 -27h52v-130q0 -28 24 -28t24 28v643h54v-643q0 -76 -77 -76t-77 76v130zM18 530v75h54v-75h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 180,
    d: "M121 0l-36 194h-3l-16 -59v-135h-53v672h53v-393h4l51 207h56l-53 -211l52 -275h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 80,
    d: "M13 0v672h53v-672h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 279,
    d: "M212 0v416q0 26 -22 26q-11 0 -16 -6t-9 -19v-417h-52v416q0 26 -21 26q-11 0 -16.5 -6.5t-9.5 -18.5v-417h-53v486h50l1 -31h4q16 34 43 34q39 0 50 -38q17 38 51 38q23 0 38.5 -16.5t15.5 -46.5v-426h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 182,
    d: "M115 0v416q0 26 -23 26q-11 0 -16 -6t-10 -19v-417h-53v486h50l1 -31h4q16 34 51 34q50 0 50 -63v-426h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 179,
    d: "M165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "\u043E",
    horizAdvX: 179,
    d: "M165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "\u03BF",
    horizAdvX: 179,
    d: "M165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    d: "M114 414q0 28 -24 28q-21 0 -25 -25v-348q4 -26 25 -26q24 0 24 29v342zM13 -233v719h48l1 -31h4q8 17 18.5 25.5t27.5 8.5q26 0 40.5 -16.5t14.5 -45.5v-369q0 -29 -14 -45t-40 -16q-15 0 -26 6.5t-18 22.5h-4v-259h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "\u0440",
    d: "M114 414q0 28 -24 28q-21 0 -25 -25v-348q4 -26 25 -26q24 0 24 29v342zM13 -233v719h48l1 -31h4q8 17 18.5 25.5t27.5 8.5q26 0 40.5 -16.5t14.5 -45.5v-369q0 -29 -14 -45t-40 -16q-15 0 -26 6.5t-18 22.5h-4v-259h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    d: "M263 -157q0 -76 -74 -76q-75 0 -75 76v183h-3q-7 -16 -17.5 -22.5t-27.5 -6.5q-29 0 -41 17t-12 52v361q0 29 14 45.5t40 16.5q18 0 29 -8.5t19 -26.5h3l2 32h47v-642q0 -29 23 -29q21 0 21 28v130h52v-130zM67 72q0 -29 23 -29q12 0 17.5 7.5t8.5 24.5v337 q-4 16 -9.5 23t-16.5 7q-23 0 -23 -28v-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 137,
    d: "M13 0v486h50l1 -35h4q7 18 17 28t27 10q8 0 18 -4v-49q-7 4 -20 4q-20 0 -30.5 -11t-13.5 -38v-391h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 176,
    d: "M112 337v85q0 22 -24 22t-24 -21v-94q0 -20 3.5 -28t14.5 -17q16 -12 30.5 -19.5t27.5 -18.5t19 -25.5t6 -48.5v-108q0 -35 -18 -51t-57 -16q-42 0 -60.5 17t-18.5 52v90h50v-91q0 -25 26 -25q25 0 25 23v109q0 16 -4.5 23.5t-17.5 18.5q-14 11 -29.5 21t-26.5 22 q-12 14 -16.5 28.5t-4.5 43.5v99q0 29 19 45t55 16q38 0 56.5 -18.5t18.5 -50.5v-83h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "\u0455",
    horizAdvX: 176,
    d: "M112 337v85q0 22 -24 22t-24 -21v-94q0 -20 3.5 -28t14.5 -17q16 -12 30.5 -19.5t27.5 -18.5t19 -25.5t6 -48.5v-108q0 -35 -18 -51t-57 -16q-42 0 -60.5 17t-18.5 52v90h50v-91q0 -25 26 -25q25 0 25 23v109q0 16 -4.5 23.5t-17.5 18.5q-14 11 -29.5 21t-26.5 22 q-12 14 -16.5 28.5t-4.5 43.5v99q0 29 19 45t55 16q38 0 56.5 -18.5t18.5 -50.5v-83h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 171,
    d: "M112 274h45v-201q0 -39 -14.5 -57.5t-53.5 -18.5q-76 0 -76 76v546h52v-133h92v-48h-92v-365q0 -28 25 -28q22 0 22 28v201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    d: "M67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 170,
    d: "M47 0l-44 486h53l28 -386h4l28 386h50l-43 -486h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "\u03BD",
    horizAdvX: 170,
    d: "M47 0l-44 486h53l28 -386h4l28 386h50l-43 -486h-76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 250,
    d: "M31 0l-28 486h51l14 -371h4l22 371h61l23 -371h4l14 371h51l-28 -486h-75l-17 377h-4l-18 -377h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 178,
    d: "M173 486l-46 -232l48 -254h-55l-30 185h-4l-29 -185h-54l48 247l-46 239h54l30 -175h4l27 175h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "\u0445",
    horizAdvX: 178,
    d: "M173 486l-46 -232l48 -254h-55l-30 185h-4l-29 -185h-54l48 247l-46 239h54l30 -175h4l27 175h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    d: "M67 77q0 -28 23 -28q13 0 18 8t8 23v406h51v-643q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-3q-13 -28 -45 -28q-25 0 -39 16.5t-14 58.5v411h54v-409z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "\u0443",
    d: "M67 77q0 -28 23 -28q13 0 18 8t8 23v406h51v-643q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-3q-13 -28 -45 -28q-25 0 -39 16.5t-14 58.5v411h54v-409z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 152,
    d: "M9 0v50l84 388h-84v48h133v-49l-84 -388h86v-49h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 113,
    d: "M80 -131q-43 0 -43 65v312q0 27 -24 27v44q24 0 24 27v310q0 66 43 66h26v-42h-9q-18 0 -18 -24v-310q0 -37 -25 -47v-4q25 -9 25 -47v-312q0 -23 18 -23h9v-42h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 99,
    d: "M28 -125v861h42v-861h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 113,
    d: "M7 -131v42h9q18 0 18 23v312q0 38 25 47v4q-25 10 -25 47v310q0 24 -18 24h-9v42h26q43 0 43 -66v-310q0 -27 24 -27v-44q-24 0 -24 -27v-312q0 -65 -43 -65h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 171,
    d: "M118 307q-20 0 -35 6.5t-32 6.5q-21 0 -39 -18v45q6 6 15.5 10.5t24.5 4.5q20 0 35 -6.5t32 -6.5q11 0 21.5 4t18.5 13v-44q-17 -15 -41 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonbreakingspace",
    unicode: "\xA0",
    horizAdvX: 60
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 91,
    d: "M73 492v-83h-54v83h54zM64 334q5 -32 7.5 -66.5t2.5 -71.5v-368h-58v350q0 42 2.5 80.5t7.5 75.5h38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 175,
    d: "M67 -3v90q-55 9 -55 75v351q0 66 55 75v82h42v-82q53 -9 53 -75v-105h-50v109q0 29 -24 29t-24 -29v-359q0 -28 24 -28t24 28v112h50v-108q0 -65 -53 -75v-90h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    d: "M168 258h-101v-207h101v-51h-156v581q0 86 80 86q76 0 76 -85v-177h-52v181q0 30 -24 30q-25 0 -25 -30v-278h101v-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 213,
    d: "M150 260q-20 -13 -43 -13q-24 0 -43 13l-25 -27l-27 27l28 25q-6 9 -10 21t-4 24q0 11 4 23t9 21l-26 25l26 26l24 -26q9 5 20.5 9t23.5 4q11 0 22.5 -4t21.5 -9l24 26l26 -26l-26 -24q5 -10 9 -22t4 -24t-4 -23.5t-9 -20.5l26 -25l-26 -27zM156 330q0 21 -14 35.5 t-35 14.5t-35 -14.5t-14 -36.5t14 -36t35 -14t35 14t14 37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 184,
    d: "M67 0v111h-46v34h46v101h-46v33h46v26l-64 359h56l32 -246h4l31 246h55l-62 -359v-26h49v-33h-49v-101h49v-34h-49v-111h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 99,
    d: "M28 -125v384h42v-384h-42zM28 356v380h42v-380h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 152,
    d: "M141 -74q0 -66 -64 -66q-35 0 -50 17.5t-15 51.5v86h41v-94q0 -22 22 -22q20 0 20 21v143q0 15 -13 24.5t-28 20t-28 26t-13 44.5v197q0 35 25 49q-25 21 -25 57v128q0 26 16 42t45 16q32 0 47 -18t15 -48v-82h-41v86q0 23 -19 23q-11 0 -15.5 -5.5t-4.5 -13.5v-131 q0 -7 2 -11t10 -11q12 -11 25 -17.5t23.5 -15t17.5 -21t7 -34.5v-203q0 -35 -18 -51q18 -17 18 -49v-139zM95 366q0 10 -5.5 16t-19.5 16q-14 -4 -14 -19v-204q0 -8 7.5 -17t26.5 -18q5 5 5 15v211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 150,
    d: "M12 530v75h49v-75h-49zM89 530v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 185,
    d: "M172 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM150 579q0 32 -15 49t-43 17t-43.5 -17t-15.5 -48v-498q0 -63 60 -63q57 0 57 62v498zM107 374v74q0 17 -14 17t-14 -17v-234q0 -18 13 -18q15 0 15 17v90h22v-89q0 -39 -36 -39t-36 40 v231q0 40 35 40q18 0 27.5 -11t9.5 -30v-71h-22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 118,
    d: "M71 525q-3 -3 -6.5 -4t-8.5 -3q-8 -3 -10 -7.5t-2 -12.5v-86q0 -14 12 -14q11 0 15 13v114zM73 370l-1 15h-3q-2 -5 -8 -11t-20 -6q-17 0 -23.5 10t-6.5 27v87q0 22 8 31.5t29 16.5q11 4 16.5 7t5.5 11v68q0 11 -12 11t-12 -12v-55h-33v58q0 39 47 39q45 0 45 -36v-261 h-32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 148,
    d: "M5 213zM5 318l53 105l24 -19l-45 -86l45 -87l-24 -18zM66 318l53 105l24 -19l-45 -86l45 -87l-24 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 171,
    d: "M118 101v302h-106v42h147v-344h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 144,
    d: "M132 348q0 -63 -60 -63t-60 64v253q0 31 15.5 48t43.5 17q29 0 45 -17t16 -49v-253zM115 601q0 49 -44 49q-20 0 -31 -12.5t-11 -35.5v-253q0 -47 43 -47t43 46v253zM83 384v78q0 9 -11 9h-10v-87h-18v201h33q23 0 23 -24v-63q0 -15 -11 -17v-3q11 -3 11 -18v-76h-17z M82 559q0 10 -10 10h-10v-83h10q10 0 10 10v63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 144,
    d: "M12 533v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 86,
    d: "M43 572q-20 0 -28.5 12t-8.5 38t8.5 38t28.5 12q37 0 37 -50t-37 -50zM43 592q8 0 12 6.5t4 23.5t-4 23.5t-12 6.5q-9 0 -12.5 -6.5t-3.5 -23.5t3.5 -23.5t12.5 -6.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 171,
    d: "M12 141zM64 261v53h-52v41h52v53h42v-53h53v-41h-53v-53h-42zM12 141v42h147v-42h-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 100,
    d: "M11 369zM11 369v83q0 14 3 23.5t11 19.5q7 10 16 19l14 14q4 5 5 10.5t1 14.5v73q0 12 -10 12t-10 -14v-70h-29v68q0 22 6.5 32.5t32.5 10.5q23 0 31 -9.5t8 -29.5v-73q0 -25 -12 -39q-3 -3 -13 -13.5t-15 -17.5q-8 -11 -8 -25v-63h48v-26h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 100,
    d: "M11 367zM90 409q0 -42 -39 -42q-40 0 -40 44v63h29v-65q0 -14 10 -14q11 0 11 12v87q0 15 -13 15h-10v25h11q11 0 11 14v77q0 13 -10 13t-10 -14v-55h-29v52q0 44 39 44q20 0 29 -11t9 -27v-77q0 -21 -16 -26v-3q8 -2 13 -8.5t5 -20.5v-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 126,
    d: "M33 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 184,
    d: "M123 -100v720h-37v-720h-45v581q-33 4 -33 37v109q0 37 49 37h125l-14 -44v-720h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 79,
    d: "M12 292v83h54v-83h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 72,
    d: "M12 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 69,
    d: "M9 369zM28 369v254h-19v24q12 0 16 4.5t6 12.5h25v-295h-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 116,
    d: "M103 416q0 -47 -46 -47t-46 47v206q0 46 46 46t46 -46v-206zM70 622q0 15 -13 15t-13 -15v-206q0 -15 13 -15t13 15v206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 148,
    d: "M5 213zM5 232l45 87l-45 86l23 19l54 -105l-54 -106zM66 232l45 87l-45 86l23 19l54 -105l-54 -106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 199,
    d: "M12 0zM16 -11l120 688h34l-121 -688h-33zM31 369v254h-19v24q12 0 16 4.5t6 12.5h25v-295h-28zM145 205h-4l-16 -117h20v117zM145 0v63h-43v25l33 207h38v-207h13v-25h-13v-63h-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 199,
    d: "M7 0zM11 -11l120 688h34l-121 -688h-33zM26 369v254h-19v24q12 0 16 4.5t6 12.5h25v-295h-28zM112 0v83q0 14 3 23.5t11 19.5q7 10 16 19l14 14q4 5 5 10.5t1 14.5v73q0 12 -10 12t-10 -14v-70h-29v68q0 22 6.5 32.5t32.5 10.5q23 0 31 -9.5t8 -29.5v-73q0 -25 -12 -39 q-3 -3 -13 -13.5t-15 -17.5q-8 -11 -8 -25v-63h48v-26h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 199,
    d: "M7 0zM28 -11l120 688h34l-121 -688h-33zM150 205h-4l-16 -117h20v117zM150 0v63h-43v25l33 207h38v-207h13v-25h-13v-63h-28zM86 409q0 -42 -39 -42q-40 0 -40 44v63h29v-65q0 -14 10 -14q11 0 11 12v87q0 15 -13 15h-10v25h11q11 0 11 14v77q0 13 -10 13t-10 -14v-55 h-29v52q0 44 39 44q20 0 29 -11t9 -27v-77q0 -21 -16 -26v-3q8 -2 13 -8.5t5 -20.5v-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 173,
    d: "M114 491v-74h-55v74h55zM112 342v-89q0 -39 -2 -55.5t-7 -26.5q-3 -6 -7.5 -14.5t-9.5 -17t-9.5 -16.5t-6.5 -13q-4 -8 -5.5 -20t-1.5 -39v-144q0 -17 5.5 -24t19.5 -7q15 0 19.5 7.5t4.5 23.5v113h53v-90q0 -26 -2.5 -45.5t-11 -33t-24 -20.5t-42.5 -7q-23 0 -38 5.5 t-23 17.5t-11 31t-3 45v128q0 35 2 49t7 25q6 15 17 35t16 30q6 14 7.5 28.5t1.5 43.5v80h51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM30 775l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM71 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM137 686l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM161 730q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM29 709v75h49v-75h-49zM106 709v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM92 709q10 0 15 9t5 23t-5 23.5t-15 9.5q-11 0 -16 -9.5t-5 -23.5t5 -23t16 -9zM92 686q-23 0 -33.5 16t-10.5 39t10.5 39t33.5 16q22 0 32.5 -16t10.5 -39t-10.5 -39t-32.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 246,
    d: "M114 0v146h-48l-8 -146h-54l44 664h188v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM69 194h45v419h-20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    d: "M12 0zM116 271h53v-190q0 -84 -77 -84q-80 0 -80 85v498q0 42 19.5 64.5t61.5 22.5q36 0 56 -20t20 -68v-153h-53v158q0 31 -24 31q-25 0 -25 -30v-506q0 -31 24 -31q25 0 25 30v193zM65 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 145,
    d: "M12 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM13 775l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\u0400",
    horizAdvX: 145,
    d: "M12 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM13 775l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 145,
    d: "M12 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM54 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 145,
    d: "M6 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM119 686l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 145,
    d: "M10 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM10 709v75h49v-75h-49zM87 709v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\u0401",
    horizAdvX: 145,
    d: "M10 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM10 709v75h49v-75h-49zM87 709v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 87,
    d: "M0 0zM19 0v664h56v-664h-56zM-16 775l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 90,
    d: "M5 0zM12 0v664h56v-664h-56zM26 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 110,
    d: "M0 0zM26 0v664h56v-664h-56zM100 686l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 105,
    d: "M0 0zM24 0v664h56v-664h-56zM-11 706v75h49v-75h-49zM66 706v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\u0407",
    horizAdvX: 105,
    d: "M0 0zM24 0v664h56v-664h-56zM-11 706v75h49v-75h-49zM66 706v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\u03AA",
    horizAdvX: 105,
    d: "M0 0zM24 0v664h56v-664h-56zM-11 706v75h49v-75h-49zM66 706v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 192,
    d: "M19 0v323h-17v50h17v291h84q77 0 77 -78v-504q0 -82 -77 -82h-84zM100 50q24 0 24 35v497q0 18 -7 24.5t-21 6.5h-22v-240h29v-50h-29v-273h26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\u0110",
    horizAdvX: 192,
    d: "M19 0v323h-17v50h17v291h84q77 0 77 -78v-504q0 -82 -77 -82h-84zM100 50q24 0 24 35v497q0 18 -7 24.5t-21 6.5h-22v-240h29v-50h-29v-273h26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 196,
    d: "M12 0zM111 0l-52 532h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-289h-45v664h80l44 -527h4q0 15 -0.5 35.5t-1 53.5t-1 82t-0.5 121v235h47v-664h-73zM167 730q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10 t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM30 775l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM70 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM136 686l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM160 730q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10 t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM27 709v75h49v-75h-49zM104 709v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 171,
    d: "M115 333l41 -41l-29 -29l-42 41l-41 -41l-29 29l41 41l-41 41l30 29l40 -41l41 41l30 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    d: "M13 -11l7 43q-10 19 -10 50v498q0 42 21 64.5t59 22.5q23 0 40 -9l3 19h35l-9 -49q11 -20 11 -49v-498q0 -84 -79 -84q-23 0 -41 8l-3 -16h-34zM115 375h-4l-46 -285q0 -24 6 -33t19 -9q25 0 25 30v297zM65 287h4l46 287q0 23 -6.5 32t-18.5 9q-25 0 -25 -30v-298z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 184,
    d: "M12 0zM116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM31 775l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 184,
    d: "M12 0zM116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM71 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 184,
    d: "M12 0zM116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM136 686l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 184,
    d: "M12 0zM116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM29 709v75h49v-75h-49zM106 709v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 184,
    d: "M3 0zM65 0v274l-62 390h57l31 -250h4l29 250h57l-60 -390v-274h-56zM74 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    d: "M12 664h56v-99h38q35 0 49.5 -18t14.5 -50v-296q0 -32 -14.5 -49.5t-49.5 -17.5h-38v-134h-56v664zM68 517v-335h26q23 0 23 29v278q0 28 -23 28h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 190,
    d: "M127 315q0 14 -5 20.5t-22 6.5h-18v45h9q22 0 22 24v189q0 27 -24 27q-25 0 -25 -29v-598h-52v599q0 39 19 57.5t61 18.5q37 0 57 -15t20 -52v-188q0 -22 -8.5 -36t-25.5 -17v-4q19 -3 31.5 -19.5t12.5 -46.5v-223q0 -39 -16.5 -58t-57.5 -19q-15 0 -26 4v44q9 -3 18 -3 q30 0 30 32v241z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM28 596l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM67 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM132 507l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM157 551q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM25 530v75h49v-75h-49zM102 530v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM90 530q10 0 15 9t5 23t-5 23.5t-15 9.5q-11 0 -16 -9.5t-5 -23.5t5 -23t16 -9zM90 507q-23 0 -33.5 16t-10.5 39t10.5 39t33.5 16q22 0 32.5 -16t10.5 -39t-10.5 -39t-32.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 277,
    d: "M265 73q0 -76 -78 -76q-54 0 -68 36h-3q-9 -17 -20.5 -26.5t-34.5 -9.5q-29 0 -40.5 15.5t-11.5 41.5v146q0 19 4 31.5t11.5 20.5t19 13.5t27.5 10.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t57.5 15q33 0 50 -12q16 12 47 12 q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM212 413q0 28 -24 28t-24 -28v-143h48v143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 177,
    d: "M13 0zM113 178h50v-105q0 -38 -17.5 -57t-56.5 -19q-76 0 -76 76v339q0 77 76 77q39 0 56.5 -19.5t17.5 -57.5v-102h-50v102q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v105zM64 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM29 596l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\u0450",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM29 596l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM69 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM134 507l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM27 530v75h49v-75h-49zM104 530v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\u0451",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM27 530v75h49v-75h-49zM104 530v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 97,
    d: "M0 0zM-4 596l28 32l74 -100l-21 -21zM30 0v486h53v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 101,
    d: "M2 0zM23 507l-21 21l74 100l28 -32zM13 0v486h53v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 125,
    d: "M0 0zM35 0v486h53v-486h-53zM107 507l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 107,
    d: "M0 0zM-10 530v75h49v-75h-49zM67 530v75h49v-75h-49zM26 0v486h53v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\u0457",
    horizAdvX: 107,
    d: "M0 0zM-10 530v75h49v-75h-49zM67 530v75h49v-75h-49zM26 0v486h53v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    d: "M168 625l-26 -21q14 -32 20 -69t6 -68v-359q0 -29 -2.5 -50t-11 -34.5t-24 -20t-41.5 -6.5q-27 0 -42 6t-22.5 18t-9.5 29t-2 38v328q0 29 15 43.5t39 14.5q14 0 26.5 -6t20.5 -21h4v40q0 20 -4 42.5t-11 43.5l-57 -45v27l49 39q-11 27 -24.5 48t-27.5 30h48 q13 -8 23.5 -20t18.5 -28l35 27v-26zM93 43q23 0 23 25v338q-5 14 -11.5 18t-14.5 4q-7 0 -11.5 -2t-7 -8.5t-3.5 -18.5t-1 -32v-299q0 -25 26 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 182,
    d: "M13 0zM115 0v416q0 26 -23 26q-11 0 -16 -6t-10 -19v-417h-53v486h50l1 -31h4q16 34 51 34q50 0 50 -63v-426h-54zM160 551q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM29 596l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM69 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM135 507l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM158 551q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM26 530v75h49v-75h-49zM103 530v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 171,
    d: "M12 313v41h147v-41h-147zM58 185v75h54v-75h-54zM58 408v75h54v-75h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 179,
    d: "M14 -10l8 37q-9 18 -9 46v339q0 77 76 77q24 0 39 -7l3 14h33l-9 -38q10 -20 10 -46v-339q0 -76 -76 -76q-24 0 -40 6l-3 -13h-32zM113 277h-4l-44 -205q0 -27 24 -27t24 28v204zM65 211h4l44 207q-3 23 -24 23q-24 0 -24 -29v-201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    d: "M13 0zM67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54zM31 596l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    d: "M13 0zM67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54zM70 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    d: "M13 0zM67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54zM136 507l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    d: "M13 0zM67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54zM27 530v75h49v-75h-49zM104 530v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    d: "M13 0zM67 77q0 -28 23 -28q13 0 18 8t8 23v406h51v-643q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-3q-13 -28 -45 -28q-25 0 -39 16.5t-14 58.5v411h54v-409zM70 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    d: "M13 -233v905h52v-211h4q7 14 18 20t28 6q16 0 26.5 -7t16 -19.5t7.5 -29.5t2 -36v-294q0 -22 -1 -41t-5.5 -33t-15.5 -22t-30 -8q-34 0 -46 28h-4v-258h-52zM114 414q0 28 -23 28q-13 0 -18 -10.5t-8 -33.5v-318q3 -18 9 -27.5t18 -9.5q9 0 15.5 6.5t6.5 22.5v342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    d: "M13 0zM67 77q0 -28 23 -28q13 0 18 8t8 23v406h51v-643q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-3q-13 -28 -45 -28q-25 0 -39 16.5t-14 58.5v411h54v-409zM29 530v75h49v-75h-49zM106 530v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM32 712v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM28 533v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM91 686q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM86 507q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 186,
    d: "M180 -203q-13 -7 -33 -7q-25 0 -36.5 13t-11.5 54v32q0 38 13.5 63t36.5 41v7h-23l-10 171h-49l-9 -171h-54l44 664h88l45 -664q-26 -20 -35.5 -42.5t-9.5 -58.5v-33q0 -19 5 -24t17 -5q13 0 22 3v-43zM70 219h43l-19 349h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 177,
    d: "M163 -203q-11 -7 -33 -7q-24 0 -36 13t-12 54v32q0 38 13.5 64t38.5 41v6h-19l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 18 3.5 30t11 20.5t19 14.5t28.5 11q19 6 29.5 11t10.5 18v118q0 19 -23 19q-25 0 -25 -21v-92h-50v98q0 32 20.5 47 t58.5 15q72 0 72 -58v-431q-25 -20 -35 -42.5t-10 -58.5v-33q0 -19 5.5 -24t16.5 -5q14 0 22 3v-43zM112 256q-6 -5 -11 -6.5t-16 -5.5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    d: "M12 0zM116 271h53v-190q0 -84 -77 -84q-80 0 -80 85v498q0 42 19.5 64.5t61.5 22.5q36 0 56 -20t20 -68v-153h-53v158q0 31 -24 31q-25 0 -25 -30v-506q0 -31 24 -31q25 0 25 30v193zM71 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 177,
    d: "M13 0zM113 178h50v-105q0 -38 -17.5 -57t-56.5 -19q-76 0 -76 76v339q0 77 76 77q39 0 56.5 -19.5t17.5 -57.5v-102h-50v102q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v105zM68 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    d: "M12 0zM116 271h53v-190q0 -84 -77 -84q-80 0 -80 85v498q0 42 19.5 64.5t61.5 22.5q36 0 56 -20t20 -68v-153h-53v158q0 31 -24 31q-25 0 -25 -30v-506q0 -31 24 -31q25 0 25 30v193zM64 709v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 177,
    d: "M13 0zM113 178h50v-105q0 -38 -17.5 -57t-56.5 -19q-76 0 -76 76v339q0 77 76 77q39 0 56.5 -19.5t17.5 -57.5v-102h-50v102q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v105zM62 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    d: "M12 0zM116 271h53v-190q0 -84 -77 -84q-80 0 -80 85v498q0 42 19.5 64.5t61.5 22.5q36 0 56 -20t20 -68v-153h-53v158q0 31 -24 31q-25 0 -25 -30v-506q0 -31 24 -31q25 0 25 30v193zM67 695l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 177,
    d: "M13 0zM113 178h50v-105q0 -38 -17.5 -57t-56.5 -19q-76 0 -76 76v339q0 77 76 77q39 0 56.5 -19.5t17.5 -57.5v-102h-50v102q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v105zM65 516l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 185,
    d: "M12 0zM12 0v664h83q77 0 77 -78v-504q0 -82 -77 -82h-83zM92 50q24 0 24 35v497q0 18 -7 24.5t-21 6.5h-21v-563h25zM67 695l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 239,
    d: "M13 0zM67 72q0 -29 23 -29q12 0 17.5 7.5t8.5 24.5v333q-3 19 -8 26.5t-17 7.5q-24 0 -24 -28v-342zM120 0l-2 30h-4q-12 -33 -47 -33q-26 0 -40 16t-14 45v369q0 29 14.5 45.5t40.5 16.5q29 0 42 -28h4v211h53v-672h-47zM180 494q24 16 24 45v50h-24v83h54v-125 q0 -71 -54 -83v30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    d: "M120 0l-2 30h-4q-12 -33 -47 -33q-26 0 -40 16t-14 45v369q0 29 14.5 45.5t40.5 16.5q29 0 42 -28h4v84h-53v34h53v93h53v-93h13v-34h-13v-545h-47zM67 72q0 -29 23 -29q12 0 17.5 7.5t8.5 24.5v333q-3 19 -8 26.5t-17 7.5q-24 0 -24 -28v-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 145,
    d: "M12 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM15 712v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM30 533v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 145,
    d: "M7 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM77 686q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM89 507q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39 q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 145,
    d: "M12 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM49 709v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM62 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 145,
    d: "M137 -203q-13 -7 -33 -7q-25 0 -36.5 13t-11.5 54v32q0 38 13.5 64t38.5 41v6h-96v664h122v-51h-67v-240h60v-50h-60v-273h71v-50q-26 -20 -35.5 -42.5t-9.5 -58.5v-33q0 -19 5 -24t17 -5q13 0 22 3v-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 179,
    d: "M121 -203q-13 -7 -33 -7q-24 0 -36 13t-12 54v32q0 70 44 103v5q-37 2 -54 20t-17 56v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93q0 -59 -47 -73q-23 -20 -32.5 -43t-9.5 -58v-33q0 -19 5 -24t17 -5q13 0 22 3v-43zM113 413q0 28 -24 28 t-24 -28v-143h48v143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 145,
    d: "M6 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM50 695l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM66 516l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    d: "M12 0zM133 0l-2 21h-4q-5 -10 -15.5 -17t-29.5 -7q-33 0 -51.5 22t-18.5 63v498q0 42 20 64.5t58 22.5q39 0 59 -23t20 -65v-120h-53v125q0 31 -25 31q-24 0 -24 -30v-507q0 -30 24 -30q22 0 25 27v209h-28v50h81v-334h-36zM92 686q-31 0 -50.5 27.5t-19.5 73.5h39 q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    d: "M13 0zM167 -157q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-4q-12 -28 -46 -28q-25 0 -38 14t-13 47v363q0 31 14.5 48t40.5 17q18 0 28 -8.5t18 -25.5h4l2 31h47v-643zM67 77q0 -28 23 -28q20 0 26 30v330q-6 33 -25 33q-24 0 -24 -28v-337z M92 507q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    d: "M12 0zM133 0l-2 21h-4q-5 -10 -15.5 -17t-29.5 -7q-33 0 -51.5 22t-18.5 63v498q0 42 20 64.5t58 22.5q39 0 59 -23t20 -65v-120h-53v125q0 31 -25 31q-24 0 -24 -30v-507q0 -30 24 -30q22 0 25 27v209h-28v50h81v-334h-36zM64 709v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    d: "M13 0zM167 -157q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-4q-12 -28 -46 -28q-25 0 -38 14t-13 47v363q0 31 14.5 48t40.5 17q18 0 28 -8.5t18 -25.5h4l2 31h47v-643zM67 77q0 -28 23 -28q20 0 26 30v330q-6 33 -25 33q-24 0 -24 -28v-337z M64 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    d: "M12 0zM133 0l-2 21h-4q-5 -10 -15.5 -17t-29.5 -7q-33 0 -51.5 22t-18.5 63v498q0 42 20 64.5t58 22.5q39 0 59 -23t20 -65v-120h-53v125q0 31 -25 31q-24 0 -24 -30v-507q0 -30 24 -30q22 0 25 27v209h-28v50h81v-334h-36zM69 -185q11 2 17.5 9t6.5 27v42h-24v89h48 v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    d: "M13 0zM167 -157q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-4q-12 -28 -46 -28q-25 0 -38 14t-13 47v363q0 31 14.5 48t40.5 17q18 0 28 -8.5t18 -25.5h4l2 31h47v-643zM67 77q0 -28 23 -28q20 0 26 30v330q-6 33 -25 33q-24 0 -24 -28v-337z M115.001 702.988q-11 -1.99902 -17.499 -8.99902q-6.5 -7 -6.5 -26.998v-41.998h23.999v-88.9941h-47.9971v117.993q0 37.9971 11.499 54.9961t36.498 18.999v-24.999z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 187,
    d: "M118 0v329h-50v-329h-56v502h-13v34h13v128h56v-128h50v128h56v-128h12v-34h-12v-502h-56zM118 378v124h-50v-124h50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 182,
    d: "M66 545v-91h4q8 17 19 26t31 9q27 0 38 -16.5t11 -51.5v-421h-54v416q0 26 -22 26q-21 0 -27 -28v-414h-53v545h-14v34h14v93h53v-93h53v-34h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u045B",
    horizAdvX: 182,
    d: "M66 545v-91h4q8 17 19 26t31 9q27 0 38 -16.5t11 -51.5v-421h-54v416q0 26 -22 26q-21 0 -27 -28v-414h-53v545h-14v34h14v93h53v-93h53v-34h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 101,
    d: "M0 0zM22 0v664h56v-664h-56zM119 727q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 123,
    d: "M0 0zM130 551q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17zM33 0v486h53v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 106,
    d: "M0 0zM24 0v664h56v-664h-56zM-7 709v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 102,
    d: "M0 0zM-9 533v34h119v-34h-119zM23 0v486h53v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 105,
    d: "M0 0zM24 0v664h56v-664h-56zM52 686q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 120,
    d: "M0 0zM59 507q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27zM33 0v486h53v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 83,
    d: "M70 -203q-13 -7 -33 -7q-25 0 -36.5 13t-11.5 54v32q0 38 14 64.5t39 41.5v5h-27v664h56v-664q-26 -20 -35.5 -42.5t-9.5 -58.5v-33q0 -19 5 -24t17 -5q13 0 22 3v-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 83,
    d: "M68 -203q-11 -7 -33 -7q-24 0 -36 13t-12 54v32q0 38 14 64.5t40 41.5v5h-25v486h53v-486q-25 -20 -35 -42.5t-10 -58.5v-33q0 -19 5.5 -24t16.5 -5q14 0 22 3v-43zM16 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 80,
    d: "M12 0zM12 0v664h56v-664h-56zM13 706v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 80,
    d: "M13 0v486h53v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 253,
    d: "M12 0zM12 0v664h56v-664h-56zM185 664h55v-582q0 -85 -79 -85q-78 0 -78 84v164h53v-167q0 -30 24 -30q25 0 25 30v586z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 176,
    d: "M13 0v486h53v-486h-53zM13 530v75h53v-75h-53zM13 -45h53v-113q0 -27 21 -27q22 0 22 27v644h53v-644q0 -37 -18 -56t-57 -19q-74 0 -74 75v113zM109 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 184,
    d: "M12 0zM123 0l-36 285h-2l-17 -76v-209h-56v664h56v-259h4l52 259h56l-53 -257l52 -407h-56zM65 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 180,
    d: "M13 0zM121 0l-36 194h-3l-16 -59v-135h-53v672h53v-393h4l51 207h56l-53 -211l52 -275h-55zM65 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 149,
    d: "M7 0zM12 0v664h56v-613h73v-51h-129zM28 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 84,
    d: "M2 0zM13 0v672h53v-672h-53zM23 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 149,
    d: "M12 0zM12 0v664h56v-613h73v-51h-129zM50 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 80,
    d: "M13 0zM13 0v672h53v-672h-53zM15 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 154,
    d: "M12 0zM12 0v664h56v-613h73v-51h-129zM87 494q24 16 24 45v50h-24v83h54v-125q0 -71 -54 -83v30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 138,
    d: "M13 0zM13 0v672h53v-672h-53zM79 494q24 16 24 45v50h-24v83h54v-125q0 -71 -54 -83v30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 149,
    d: "M12 0v664h56v-200l55 33v-49l-55 -33v-364h73v-51h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 108,
    d: "M27 0v301l-25 -11v42l25 11v329h54v-304l25 11v-42l-25 -11v-326h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 196,
    d: "M12 0zM111 0l-52 532h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-289h-45v664h80l44 -527h4q0 15 -0.5 35.5t-1 53.5t-1 82t-0.5 121v235h47v-664h-73zM78 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 182,
    d: "M13 0zM115 0v416q0 26 -23 26q-11 0 -16 -6t-10 -19v-417h-53v486h50l1 -31h4q16 34 51 34q50 0 50 -63v-426h-54zM70 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 196,
    d: "M12 0zM111 0l-52 532h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-289h-45v664h80l44 -527h4q0 15 -0.5 35.5t-1 53.5t-1 82t-0.5 121v235h47v-664h-73zM71 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 182,
    d: "M13 0zM115 0v416q0 26 -23 26q-11 0 -16 -6t-10 -19v-417h-53v486h50l1 -31h4q16 34 51 34q50 0 50 -63v-426h-54zM66 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 196,
    d: "M12 0zM111 0l-52 532h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-289h-45v664h80l44 -527h4q0 15 -0.5 35.5t-1 53.5t-1 82t-0.5 121v235h47v-664h-73zM74 695l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 182,
    d: "M13 0zM115 0v416q0 26 -23 26q-11 0 -16 -6t-10 -19v-417h-53v486h50l1 -31h4q16 34 51 34q50 0 50 -63v-426h-54zM67 516l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 196,
    d: "M85 -183q2 -2 6 -2h6q25 0 25 28v61l-63 628h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-289h-45v664h80l44 -527h4q-1 15 -1.5 35.5t-1 53.5t-0.5 82v121v235h47v-821q0 -38 -20.5 -57.5t-58.5 -19.5q-14 0 -20 2v49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 182,
    d: "M169 -157q0 -38 -19 -57t-51 -19q-8 0 -12 0.5t-7 1.5v48q4 -2 12 -2q23 0 23 28v573q0 26 -23 26q-11 0 -16 -6t-10 -19v-417h-53v486h50l1 -31h4q16 34 51 34q50 0 50 -63v-583v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM31 712v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM30 533v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM90 686q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74 t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM89 507q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM32 698l42 109l34 -19l-52 -102zM92 698l42 109l34 -19l-51 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM31 519l42 109l34 -19l-52 -102zM91 519l42 109l34 -19l-51 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 243,
    d: "M117 0q-14 -3 -26 -3q-81 0 -81 85v498q0 42 21 64.5t59 22.5q13 0 24 -3h119v-51h-71q8 -14 8 -34v-206h56v-50h-56v-242q0 -20 -7 -31h74v-50h-120zM115 584q0 31 -25 31t-25 -31v-506q0 -30 25 -30t25 30v506z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 275,
    d: "M263 73q0 -76 -78 -76q-32 0 -48 13q-16 -13 -48 -13q-76 0 -76 76v339q0 77 76 77q32 0 48 -13q18 13 49 13q77 0 77 -77v-180h-102v-160q0 -29 25 -29q24 0 24 29v94h53v-93zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM210 413q0 28 -24 28 q-25 0 -25 -28v-143h49v143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    d: "M12 0zM12 0v664h94q35 0 49.5 -18t14.5 -51v-213q0 -44 -34 -52v-4q17 -4 26 -15.5t9 -37.5v-273h-54v278q0 25 -23 25h-27v-303h-55zM116 589q0 24 -23 24h-26v-265h26q23 0 23 28v213zM66 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 137,
    d: "M13 0zM13 0v486h50l1 -35h4q7 18 17 28t27 10q8 0 18 -4v-49q-7 4 -20 4q-20 0 -30.5 -11t-13.5 -38v-391h-53zM51 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    d: "M12 0zM12 0v664h94q35 0 49.5 -18t14.5 -51v-213q0 -44 -34 -52v-4q17 -4 26 -15.5t9 -37.5v-273h-54v278q0 25 -23 25h-27v-303h-55zM116 589q0 24 -23 24h-26v-265h26q23 0 23 28v213zM66 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 137,
    d: "M13 0zM13 0v486h50l1 -35h4q7 18 17 28t27 10q8 0 18 -4v-49q-7 4 -20 4q-20 0 -30.5 -11t-13.5 -38v-391h-53zM14 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    d: "M12 0zM12 0v664h94q35 0 49.5 -18t14.5 -51v-213q0 -44 -34 -52v-4q17 -4 26 -15.5t9 -37.5v-273h-54v278q0 25 -23 25h-27v-303h-55zM116 589q0 24 -23 24h-26v-265h26q23 0 23 28v213zM64 695l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 137,
    d: "M3 0zM13 0v486h50l1 -35h4q7 18 17 28t27 10q8 0 18 -4v-49q-7 4 -20 4q-20 0 -30.5 -11t-13.5 -38v-391h-53zM47 516l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 188,
    d: "M10 0zM119 457v128q0 14 -6 22t-20 8t-20 -7.5t-6 -18.5v-111q0 -20 1 -32t2.5 -20t4.5 -13.5t8 -11.5q20 -28 39 -45t35 -39q12 -17 16 -33.5t4 -48.5v-150q0 -45 -19.5 -66.5t-62.5 -21.5q-45 0 -65 23.5t-20 68.5v110h52v-120q0 -31 30 -31q27 0 27 28v136q0 21 -1 34 t-3 22t-6 15.5t-10 14.5q-18 23 -39 43t-32 44q-8 17 -12.5 43.5t-4.5 55.5v104q0 35 19.5 57t60.5 22q42 0 61 -24.5t19 -63.5v-122h-52zM72 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 176,
    d: "M11 0zM112 337v85q0 22 -24 22t-24 -21v-94q0 -20 3.5 -28t14.5 -17q16 -12 30.5 -19.5t27.5 -18.5t19 -25.5t6 -48.5v-108q0 -35 -18 -51t-57 -16q-42 0 -60.5 17t-18.5 52v90h50v-91q0 -25 26 -25q25 0 25 23v109q0 16 -4.5 23.5t-17.5 18.5q-14 11 -29.5 21t-26.5 22 q-12 14 -16.5 28.5t-4.5 43.5v99q0 29 19 45t55 16q38 0 56.5 -18.5t18.5 -50.5v-83h-50zM67 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 188,
    d: "M10 0zM119 457v128q0 14 -6 22t-20 8t-20 -7.5t-6 -18.5v-111q0 -20 1 -32t2.5 -20t4.5 -13.5t8 -11.5q20 -28 39 -45t35 -39q12 -17 16 -33.5t4 -48.5v-150q0 -45 -19.5 -66.5t-62.5 -21.5q-45 0 -65 23.5t-20 68.5v110h52v-120q0 -31 30 -31q27 0 27 28v136q0 21 -1 34 t-3 22t-6 15.5t-10 14.5q-18 23 -39 43t-32 44q-8 17 -12.5 43.5t-4.5 55.5v104q0 35 19.5 57t60.5 22q42 0 61 -24.5t19 -63.5v-122h-52zM68 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u0218",
    horizAdvX: 188,
    d: "M10 0zM119 457v128q0 14 -6 22t-20 8t-20 -7.5t-6 -18.5v-111q0 -20 1 -32t2.5 -20t4.5 -13.5t8 -11.5q20 -28 39 -45t35 -39q12 -17 16 -33.5t4 -48.5v-150q0 -45 -19.5 -66.5t-62.5 -21.5q-45 0 -65 23.5t-20 68.5v110h52v-120q0 -31 30 -31q27 0 27 28v136q0 21 -1 34 t-3 22t-6 15.5t-10 14.5q-18 23 -39 43t-32 44q-8 17 -12.5 43.5t-4.5 55.5v104q0 35 19.5 57t60.5 22q42 0 61 -24.5t19 -63.5v-122h-52zM68 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 176,
    d: "M11 0zM112 337v85q0 22 -24 22t-24 -21v-94q0 -20 3.5 -28t14.5 -17q16 -12 30.5 -19.5t27.5 -18.5t19 -25.5t6 -48.5v-108q0 -35 -18 -51t-57 -16q-42 0 -60.5 17t-18.5 52v90h50v-91q0 -25 26 -25q25 0 25 23v109q0 16 -4.5 23.5t-17.5 18.5q-14 11 -29.5 21t-26.5 22 q-12 14 -16.5 28.5t-4.5 43.5v99q0 29 19 45t55 16q38 0 56.5 -18.5t18.5 -50.5v-83h-50zM64 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u0219",
    horizAdvX: 176,
    d: "M11 0zM112 337v85q0 22 -24 22t-24 -21v-94q0 -20 3.5 -28t14.5 -17q16 -12 30.5 -19.5t27.5 -18.5t19 -25.5t6 -48.5v-108q0 -35 -18 -51t-57 -16q-42 0 -60.5 17t-18.5 52v90h50v-91q0 -25 26 -25q25 0 25 23v109q0 16 -4.5 23.5t-17.5 18.5q-14 11 -29.5 21t-26.5 22 q-12 14 -16.5 28.5t-4.5 43.5v99q0 29 19 45t55 16q38 0 56.5 -18.5t18.5 -50.5v-83h-50zM64 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 188,
    d: "M10 0zM119 457v128q0 14 -6 22t-20 8t-20 -7.5t-6 -18.5v-111q0 -20 1 -32t2.5 -20t4.5 -13.5t8 -11.5q20 -28 39 -45t35 -39q12 -17 16 -33.5t4 -48.5v-150q0 -45 -19.5 -66.5t-62.5 -21.5q-45 0 -65 23.5t-20 68.5v110h52v-120q0 -31 30 -31q27 0 27 28v136q0 21 -1 34 t-3 22t-6 15.5t-10 14.5q-18 23 -39 43t-32 44q-8 17 -12.5 43.5t-4.5 55.5v104q0 35 19.5 57t60.5 22q42 0 61 -24.5t19 -63.5v-122h-52zM70 695l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 176,
    d: "M11 0zM112 337v85q0 22 -24 22t-24 -21v-94q0 -20 3.5 -28t14.5 -17q16 -12 30.5 -19.5t27.5 -18.5t19 -25.5t6 -48.5v-108q0 -35 -18 -51t-57 -16q-42 0 -60.5 17t-18.5 52v90h50v-91q0 -25 26 -25q25 0 25 23v109q0 16 -4.5 23.5t-17.5 18.5q-14 11 -29.5 21t-26.5 22 q-12 14 -16.5 28.5t-4.5 43.5v99q0 29 19 45t55 16q38 0 56.5 -18.5t18.5 -50.5v-83h-50zM63 516l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u0162",
    horizAdvX: 175,
    d: "M8 0zM59 0v613h-51v51h159v-51h-52v-613h-56zM62 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u021A",
    horizAdvX: 175,
    d: "M8 0zM59 0v613h-51v51h159v-51h-52v-613h-56zM62 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u0163",
    horizAdvX: 171,
    d: "M13 0zM112 274h45v-201q0 -39 -14.5 -57.5t-53.5 -18.5q-76 0 -76 76v546h52v-133h92v-48h-92v-365q0 -28 25 -28q22 0 22 28v201zM62 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u021B",
    horizAdvX: 171,
    d: "M13 0zM112 274h45v-201q0 -39 -14.5 -57.5t-53.5 -18.5q-76 0 -76 76v546h52v-133h92v-48h-92v-365q0 -28 25 -28q22 0 22 28v201zM62 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 175,
    d: "M8 0zM59 0v613h-51v51h159v-51h-52v-613h-56zM63 693l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 223,
    d: "M13 0zM112 274h45v-201q0 -39 -14.5 -57.5t-53.5 -18.5q-76 0 -76 76v546h52v-133h92v-48h-92v-365q0 -28 25 -28q22 0 22 28v201zM164 494q24 16 24 45v50h-24v83h54v-125q0 -71 -54 -83v30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 175,
    d: "M59 0v375h-32v34h32v204h-51v51h159v-51h-52v-204h32v-34h-32v-375h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 171,
    d: "M65 334v-261q0 -28 25 -28q22 0 22 28v196h45v-196q0 -39 -14.5 -57.5t-53.5 -18.5q-76 0 -76 76v546h52v-133h92v-48h-92v-69h88v-35h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 184,
    d: "M12 0zM116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM161 730q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    d: "M13 0zM67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54zM160 551q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9 q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 184,
    d: "M12 0zM116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM32 712v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    d: "M13 0zM67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54zM31 533v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 184,
    d: "M12 0zM116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM91 686q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    d: "M13 0zM67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54zM90 507q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39 q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 184,
    d: "M12 0zM116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM92 709q10 0 15 9t5 23t-5 23.5t-15 9.5q-11 0 -16 -9.5t-5 -23.5t5 -23t16 -9zM92 686q-23 0 -33.5 16t-10.5 39t10.5 39t33.5 16q22 0 32.5 -16t10.5 -39t-10.5 -39 t-32.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    d: "M13 0zM67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54zM91 530q10 0 15 9t5 23t-5 23.5t-15 9.5q-11 0 -16 -9.5t-5 -23.5t5 -23t16 -9zM91 507q-23 0 -33.5 16 t-10.5 39t10.5 39t33.5 16q22 0 32.5 -16t10.5 -39t-10.5 -39t-32.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 184,
    d: "M12 0zM116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM33 698l42 109l34 -19l-52 -102zM93 698l42 109l34 -19l-51 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    d: "M13 0zM67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54zM32 519l42 109l34 -19l-52 -102zM92 519l42 109l34 -19l-51 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 184,
    d: "M114 -203q-11 -7 -33 -7q-24 0 -36 13t-12 54v32q0 35 12 60.5t34 41.5v7q-67 6 -67 83v583h54v-586q0 -30 25 -30t25 30v586h55v-582q0 -72 -59 -83q-23 -20 -32.5 -42.5t-9.5 -57.5v-33q0 -19 5.5 -24t16.5 -5q14 0 22 3v-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    d: "M167 -203q-13 -7 -33 -7q-24 0 -36 13t-12 54v32q0 38 13.5 63.5t37.5 41.5v6h-19l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486q-25 -20 -35 -42.5t-10 -58.5v-33 q0 -19 5 -24t17 -5q13 0 22 3v-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 274,
    d: "M4 0zM35 0l-31 664h53l19 -547h4l25 547h64l26 -547h4l18 547h53l-31 -664h-80l-20 536h-4l-20 -536h-80zM181 686l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 250,
    d: "M3 0zM31 0l-28 486h51l14 -371h4l22 371h61l23 -371h4l14 371h51l-28 -486h-75l-17 377h-4l-18 -377h-74zM170 507l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 184,
    d: "M3 0zM65 0v274l-62 390h57l31 -250h4l29 250h57l-60 -390v-274h-56zM139 686l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    d: "M13 0zM67 77q0 -28 23 -28q13 0 18 8t8 23v406h51v-643q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-3q-13 -28 -45 -28q-25 0 -39 16.5t-14 58.5v411h54v-409zM138 507l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 184,
    d: "M3 0zM65 0v274l-62 390h57l31 -250h4l29 250h57l-60 -390v-274h-56zM30 706v75h49v-75h-49zM107 706v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u03AB",
    horizAdvX: 184,
    d: "M3 0zM65 0v274l-62 390h57l31 -250h4l29 250h57l-60 -390v-274h-56zM30 706v75h49v-75h-49zM107 706v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 168,
    d: "M8 0zM8 0v51l96 562h-95v51h148v-50l-94 -564h97v-50h-152zM64 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 152,
    d: "M9 0zM9 0v50l84 388h-84v48h133v-49l-84 -388h86v-49h-135zM56 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 168,
    d: "M8 0zM8 0v51l96 562h-95v51h148v-50l-94 -564h97v-50h-152zM55 709v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 152,
    d: "M9 0zM9 0v50l84 388h-84v48h133v-49l-84 -388h86v-49h-135zM47 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 168,
    d: "M8 0zM8 0v51l96 562h-95v51h148v-50l-94 -564h97v-50h-152zM60 693l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 152,
    d: "M8 0zM9 0v50l84 388h-84v48h133v-49l-84 -388h86v-49h-135zM52 516l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018E",
    unicode: "\u018E",
    horizAdvX: 145,
    d: "M133 664v-664h-123v50h67v240h-60v51h60v272h-71v51h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u018F",
    horizAdvX: 179,
    d: "M13 412q0 77 77 77q76 0 76 -77v-339q0 -76 -76 -76q-77 0 -77 76v181h101v160q0 28 -24 28q-25 0 -25 -28v-94h-52v92zM65 72q0 -28 25 -28q24 0 24 28v143h-49v-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u04D8",
    horizAdvX: 179,
    d: "M13 412q0 77 77 77q76 0 76 -77v-339q0 -76 -76 -76q-77 0 -77 76v181h101v160q0 28 -24 28q-25 0 -25 -28v-94h-52v92zM65 72q0 -28 25 -28q24 0 24 28v143h-49v-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 155,
    d: "M109 407l-30 -526q-2 -30 -16.5 -42t-42.5 -12h-18v50h8q17 0 17 13l30 517h-30v34h32l10 177q2 31 16.5 42.5t42.5 11.5h21v-50h-11q-16 0 -17 -13l-10 -168h38v-34h-40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0194",
    unicode: "\u0194",
    horizAdvX: 206,
    d: "M103 -233q-20 0 -32.5 6t-19.5 16.5t-9.5 24t-2.5 27.5q0 8 1 20.5t5 46.5t11.5 96.5t20.5 169.5l-67 490h58l31 -270h6l32 270h59l-68 -491q12 -99 19.5 -159t11.5 -94t5.5 -50t1.5 -27q0 -15 -2.5 -28.5t-9 -24t-19 -17t-32.5 -6.5zM98 -24q-8 -68 -10 -98t-2 -40 q0 -15 4 -21t12 -6t13 7t5 28q0 9 -1 18t-2.5 23.5t-4.5 35.5t-6 53h-8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni019D",
    unicode: "\u019D",
    horizAdvX: 196,
    d: "M111 0l-52 532h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-446q0 -76 -60 -76q-10 0 -16 2v48q2 -2 5 -2h5q21 0 21 28v821h80l44 -527h4q0 15 -0.5 35.5t-1 53.5t-1 82t-0.5 121v235h47v-664h-73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohorn",
    unicode: "\u01A0",
    horizAdvX: 210,
    d: "M170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 20.5 64.5t58.5 22.5q15 0 32 -2.5t30 -2.5q15 0 20.5 5.5t5.5 19.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -26 -7.5 -39t-26.5 -13h-7.5t-9.5 2q13 -20 13 -53v-498zM115 584q0 31 -25 31t-25 -30v-507 q0 -30 25 -30t25 30v506z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohorn",
    unicode: "\u01A1",
    horizAdvX: 202,
    d: "M165 73q0 -39 -18 -57.5t-58 -18.5q-76 0 -76 76v339q0 77 74 77q17 0 31 -3t27 -3q14 0 19 5.5t5 20.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -53 -32 -53q-7 0 -11 1q8 -18 8 -40v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhorn",
    unicode: "\u01AF",
    horizAdvX: 228,
    d: "M116 664h59q20 0 20 25q0 5 -0.5 12.5t-2.5 12.5h30q2 -5 3 -13.5t1 -18.5q0 -27 -7.5 -39.5t-25.5 -12.5q-5 0 -10 1t-12 2v-551q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhorn",
    unicode: "\u01B0",
    horizAdvX: 223,
    d: "M67 486v-417q0 -26 21 -26q11 0 16.5 6t10.5 20v417h56q19 0 19 24q0 5 -0.5 13t-2.5 13h29q3 -5 4 -13.5t1 -18.5q0 -26 -7.5 -39t-26.5 -13q-9 0 -19 3v-455h-50l-1 30h-3q-7 -14 -18 -23.5t-31 -9.5q-17 0 -27.5 7.5t-16 21t-7 31.5t-1.5 38v391h54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01DD",
    unicode: "\u01DD",
    horizAdvX: 179,
    d: "M13 412q0 77 77 77q76 0 76 -77v-339q0 -76 -76 -76q-77 0 -77 76v181h101v160q0 28 -24 28q-25 0 -25 -28v-94h-52v92zM65 72q0 -28 25 -28q24 0 24 28v143h-49v-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01DD",
    unicode: "\u04D9",
    horizAdvX: 179,
    d: "M13 412q0 77 77 77q76 0 76 -77v-339q0 -76 -76 -76q-77 0 -77 76v181h101v160q0 28 -24 28q-25 0 -25 -28v-94h-52v92zM65 72q0 -28 25 -28q24 0 24 28v143h-49v-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E6",
    unicode: "\u01E6",
    d: "M12 0zM133 0l-2 21h-4q-5 -10 -15.5 -17t-29.5 -7q-33 0 -51.5 22t-18.5 63v498q0 42 20 64.5t58 22.5q39 0 59 -23t20 -65v-120h-53v125q0 31 -25 31q-24 0 -24 -30v-507q0 -30 24 -30q22 0 25 27v209h-28v50h81v-334h-36zM69 695l-44 70l23 19l45 -57l45 57l23 -19 l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E7",
    unicode: "\u01E7",
    d: "M13 0zM167 -157q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-4q-12 -28 -46 -28q-25 0 -38 14t-13 47v363q0 31 14.5 48t40.5 17q18 0 28 -8.5t18 -25.5h4l2 31h47v-643zM67 77q0 -28 23 -28q20 0 26 30v330q-6 33 -25 33q-24 0 -24 -28v-337z M67 516l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F4",
    unicode: "\u01F4",
    d: "M12 0zM133 0l-2 21h-4q-5 -10 -15.5 -17t-29.5 -7q-33 0 -51.5 22t-18.5 63v498q0 42 20 64.5t58 22.5q39 0 59 -23t20 -65v-120h-53v125q0 31 -25 31q-24 0 -24 -30v-507q0 -30 24 -30q22 0 25 27v209h-28v50h81v-334h-36zM72 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F5",
    unicode: "\u01F5",
    d: "M13 0zM167 -157q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-4q-12 -28 -46 -28q-25 0 -38 14t-13 47v363q0 31 14.5 48t40.5 17q18 0 28 -8.5t18 -25.5h4l2 31h47v-643zM67 77q0 -28 23 -28q20 0 26 30v330q-6 33 -25 33q-24 0 -24 -28v-337z M72 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F8",
    unicode: "\u01F8",
    horizAdvX: 196,
    d: "M12 0zM111 0l-52 532h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-289h-45v664h80l44 -527h4q0 15 -0.5 35.5t-1 53.5t-1 82t-0.5 121v235h47v-664h-73zM39 775l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F9",
    unicode: "\u01F9",
    horizAdvX: 182,
    d: "M13 0zM115 0v416q0 26 -23 26q-11 0 -16 -6t-10 -19v-417h-53v486h50l1 -31h4q16 34 51 34q50 0 50 -63v-426h-54zM31 596l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 86,
    d: "M-82 -27h52v-130q0 -28 24 -28t24 28v643h54v-643q0 -76 -77 -76t-77 76v130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0241",
    unicode: "\u0241",
    horizAdvX: 171,
    d: "M56 0v251q0 29 2.5 44.5t7.5 26.5q9 23 19 40.5t15 28.5t6.5 27t1.5 37v131q0 15 -4 22t-19 7t-20 -7.5t-5 -23.5v-113h-53v112q0 43 16.5 63.5t61.5 20.5t60.5 -19.5t15.5 -62.5v-113q0 -22 -0.5 -35.5t-1.5 -22.5t-2.5 -16t-4.5 -14q-8 -20 -16 -33t-14 -28 q-5 -13 -7.5 -27.5t-2.5 -43.5v-252h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0242",
    unicode: "\u0242",
    horizAdvX: 179,
    d: "M61 0v130q0 11 2.5 20.5t5.5 17.5q8 17 19.5 32.5t17.5 27.5q3 7 5 14t2 15v155q0 29 -23 29q-14 0 -19.5 -8t-5.5 -23v-108h-52v100q0 46 17 66.5t59 20.5q41 0 58.5 -19t17.5 -59v-154q0 -21 -6 -34q-8 -19 -20.5 -33t-18.5 -31q-5 -13 -5 -29v-130h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni024C",
    unicode: "\u024C",
    horizAdvX: 199,
    d: "M29 0v303h-28v45h28v316h95q35 0 49.5 -18t14.5 -51v-213q0 -44 -34 -52v-4q17 -4 26 -15.5t9 -37.5v-273h-55v278q0 12 -4.5 18.5t-17.5 6.5h-27v-303h-56zM134 589q0 24 -23 24h-26v-265h26q23 0 23 28v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni024D",
    unicode: "\u024D",
    horizAdvX: 148,
    d: "M22 0v217h-21v34h21v235h50l2 -35h4q7 18 17 28t27 10q8 0 18 -4v-49q-7 4 -20 4q-20 0 -30.5 -11t-13.5 -38v-140h44v-34h-44v-217h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0263",
    unicode: "\u0263",
    horizAdvX: 177,
    d: "M112 93q12 -85 18.5 -134.5t9.5 -76t4 -36.5t1 -15q0 -34 -14.5 -49t-42.5 -15q-57 0 -57 65q0 5 1 14.5t4 36t9.5 75.5t18.5 133l-61 395h55l27 -214h5l29 214h54zM85 -66q-3 -31 -5.5 -50.5t-3.5 -31t-1.5 -17.5t-0.5 -10q0 -21 14 -21t14 21q0 3 -0.5 9l-1.5 18 t-3.5 31.5t-6.5 50.5h-5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0272",
    unicode: "\u0272",
    horizAdvX: 182,
    d: "M115 0v416q0 26 -23 26q-11 0 -16 -6t-10 -19v-574q0 -38 -18.5 -57t-50.5 -19q-8 0 -12 0.5t-6 1.5v48q2 -2 5.5 -2h6.5q22 0 22 28v643h50l1 -31h4q16 34 51 34q50 0 50 -63v-426h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 162,
    d: "M126 507l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 161,
    d: "M57 516l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 0,
    d: "M-33 533zM-152 533v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 165,
    d: "M82 507q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 78,
    d: "M12 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 111,
    d: "M56 530q10 0 15 9t5 23t-5 23.5t-15 9.5q-11 0 -16 -9.5t-5 -23.5t5 -23t16 -9zM56 507q-23 0 -33.5 16t-10.5 39t10.5 39t33.5 16q22 0 32.5 -16t10.5 -39t-10.5 -39t-32.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 102,
    d: "M89 -203q-13 -7 -33 -7q-25 0 -36.5 13t-11.5 54v32q0 42 17 69.5t46 41.5h19q-26 -20 -35.5 -42.5t-9.5 -58.5v-33q0 -19 5 -24t17 -5q13 0 22 3v-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 162,
    d: "M150 551q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 160,
    d: "M12 519l42 109l34 -19l-52 -102zM72 519l42 109l34 -19l-51 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    horizAdvX: 0,
    d: "M-51 507zM-153 596l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    horizAdvX: 0,
    d: "M-39 507zM-120 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    horizAdvX: 0,
    d: "M-24 507zM-47 507l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    horizAdvX: 0,
    d: "M-23 515zM-23 551q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    horizAdvX: 0,
    d: "M-33 533zM-152 533v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    horizAdvX: 0,
    d: "M-23 507zM-93 507q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    horizAdvX: 0,
    d: "M-66 530zM-119 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    horizAdvX: 0,
    d: "M-29 530zM-155 530v75h49v-75h-49zM-78 530v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hookabovecomb",
    unicode: "\u0309",
    horizAdvX: 0,
    d: "M-111 513q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    horizAdvX: 0,
    d: "M-48 507zM-91 530q10 0 15 9t5 23t-5 23.5t-15 9.5q-11 0 -16 -9.5t-5 -23.5t5 -23t16 -9zM-91 507q-23 0 -33.5 16t-10.5 39t10.5 39t33.5 16q22 0 32.5 -16t10.5 -39t-10.5 -39t-32.5 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    horizAdvX: 0,
    d: "M-23 507zM-159 519l42 109l34 -19l-52 -102zM-99 519l42 109l34 -19l-51 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    horizAdvX: 0,
    d: "M-24 516zM-116 516l-44 70l23 19l45 -57l45 57l23 -19l-44 -70h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0313",
    unicode: "\u0313",
    horizAdvX: 0,
    d: "M-68 516zM-67.999 683.988q-11 -1.99902 -17.499 -8.99902q-6.5 -7 -6.5 -26.998v-41.998h23.999v-88.9941h-47.9971v117.993q0 37.9971 11.499 54.9961t36.498 18.999v-24.999z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni031B",
    unicode: "\u031B",
    horizAdvX: 36,
    d: "M-51 486q8 -1 16 -1.5t16 -0.5q15 0 18.5 5.5t3.5 18.5q0 9 -0.5 16t-1.5 12h29q2 -5 3 -13t1 -19q0 -53 -34 -53q-12 0 -26 5t-25 11v19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelowcomb",
    unicode: "\u0323",
    horizAdvX: 0,
    d: "M-118 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M-68 -18zM-116 -185q11 2 17.5 9t6.5 27v42h-24v89h48v-118q0 -38 -11.5 -55t-36.5 -19v25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    horizAdvX: 0,
    d: "M-51 0zM-52 -203q-13 -7 -33 -7q-25 0 -36.5 13t-11.5 54v32q0 42 17 69.5t46 41.5h19q-26 -20 -35.5 -42.5t-9.5 -58.5v-33q0 -19 5 -24t17 -5q13 0 22 3v-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni032D",
    unicode: "\u032D",
    horizAdvX: 0,
    d: "M-24 -59zM-47 -160l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tonos",
    unicode: "\u0384",
    horizAdvX: 52,
    d: "M7 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresistonos",
    unicode: "\u0385",
    horizAdvX: 0,
    d: "M-6 522zM-108 522v156h43l-10 -156h-33zM-174 530v75h53v-75h-53zM-59 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Alphatonos",
    unicode: "\u0386",
    horizAdvX: 203,
    d: "M7 0zM143 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM87 219h43l-19 349h-4zM7 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "anoteleia",
    unicode: "\u0387",
    horizAdvX: 60,
    d: "M12 326zM12 326v83h54v-83h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Epsilontonos",
    unicode: "\u0388",
    horizAdvX: 189,
    d: "M7 0zM56 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM7 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etatonos",
    unicode: "\u0389",
    horizAdvX: 230,
    d: "M7 0zM161 0v329h-50v-329h-56v664h56v-286h50v286h56v-664h-56zM7 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iotatonos",
    unicode: "\u038A",
    horizAdvX: 123,
    d: "M7 0zM55 0v664h56v-664h-56zM7 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omicrontonos",
    unicode: "\u038C",
    horizAdvX: 222,
    d: "M7 0zM211 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM156 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM7 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Upsilontonos",
    unicode: "\u038E",
    horizAdvX: 235,
    d: "M7 0zM116 0v274l-62 390h57l31 -250h4l29 250h57l-60 -390v-274h-56zM7 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omegatonos",
    unicode: "\u038F",
    horizAdvX: 235,
    d: "M7 0zM149 0v45q8 6 12.5 27t4.5 72v441q0 30 -27 30q-29 0 -29 -30v-441q0 -51 4.5 -72t14.5 -27v-45h-80v48h34v4q-14 12 -21.5 31.5t-7.5 61.5v447q0 37 22.5 56t62.5 19t62 -19t22 -56v-447q0 -42 -7.5 -61t-22.5 -32v-4h36v-48h-80zM7 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresistonos",
    unicode: "\u0390",
    horizAdvX: 157,
    d: "M0 0zM112 0q-63 0 -63 63v423h53v-423q0 -16 11 -16h8v-47h-9zM60 522v156h43l-10 -156h-33zM-6 530v75h53v-75h-53zM109 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0393",
    horizAdvX: 149,
    d: "M12 0v664h129v-51h-73v-613h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 149,
    d: "M12 0v664h129v-51h-73v-613h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u0394",
    horizAdvX: 186,
    d: "M4 0l44 664h88l45 -664h-177zM94 568h-4l-27 -517h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Theta",
    unicode: "\u0398",
    d: "M170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM69 323v50h42v-50h-42zM119 584q0 31 -29 31t-29 -30v-507q0 -30 29 -30t29 30v506z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lambda",
    unicode: "\u039B",
    horizAdvX: 186,
    d: "M137 664l45 -664h-56l-32 542h-4l-32 -542h-53l44 664h88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Xi",
    unicode: "\u039E",
    horizAdvX: 145,
    d: "M7 0v50h131v-50h-131zM17 323v50h110v-50h-110zM10 613v51h124v-51h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u03A0",
    horizAdvX: 187,
    d: "M118 0v613h-50v-613h-56v664h162v-664h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 187,
    d: "M118 0v613h-50v-613h-56v664h162v-664h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sigma",
    unicode: "\u03A3",
    horizAdvX: 145,
    d: "M8 0v50l52 285l-53 280v49h127v-51h-76l52 -277l-52 -286h80v-50h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u03A6",
    horizAdvX: 256,
    d: "M101 0v134h-29q-35 0 -49 17.5t-14 49.5v296q0 32 14 50t49 18h29v99h54v-99h29q35 0 49.5 -18t14.5 -50v-296q0 -32 -14.5 -49.5t-49.5 -17.5h-29v-134h-54zM199 489q0 28 -24 28h-20v-335h20q24 0 24 28v279zM101 517h-20q-24 0 -24 -28v-279q0 -28 24 -28h20v335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 256,
    d: "M101 0v134h-29q-35 0 -49 17.5t-14 49.5v296q0 32 14 50t49 18h29v99h54v-99h29q35 0 49.5 -18t14.5 -50v-296q0 -32 -14.5 -49.5t-49.5 -17.5h-29v-134h-54zM199 489q0 28 -24 28h-20v-335h20q24 0 24 28v279zM101 517h-20q-24 0 -24 -28v-279q0 -28 24 -28h20v335z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Psi",
    unicode: "\u03A8",
    horizAdvX: 260,
    d: "M103 0v142h-29q-35 0 -49.5 18t-14.5 50v454h49v-445q0 -29 24 -29h20v474h54v-474h20q24 0 24 29v445h49v-454q0 -32 -14.5 -50t-49.5 -18h-29v-142h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u03A9",
    horizAdvX: 194,
    d: "M107 0v45q8 6 12.5 27t4.5 72v441q0 30 -27 30q-29 0 -29 -30v-441q0 -51 4.5 -72t14.5 -27v-45h-80v48h34v4q-14 12 -21.5 31.5t-7.5 61.5v447q0 37 22.5 56t62.5 19t62 -19t22 -56v-447q0 -42 -7.5 -61t-22.5 -32v-4h36v-48h-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alphatonos",
    unicode: "\u03AC",
    horizAdvX: 192,
    d: "M13 0zM177 0q-25 0 -37.5 6.5t-17.5 23.5h-4q-8 -16 -20 -24.5t-33 -8.5q-18 0 -28 5.5t-15.5 15.5t-7 24t-1.5 30v355q0 29 14 45.5t40 16.5q17 0 28 -8.5t19 -25.5h4l2 31h47v-422q0 -17 10 -17h8v-47h-8zM67 72q0 -29 23 -29q14 0 18.5 8.5t7.5 25.5v335 q-4 17 -9 23.5t-16 6.5q-24 0 -24 -28v-342zM72 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilontonos",
    unicode: "\u03AD",
    horizAdvX: 176,
    d: "M12 0zM70 522v156h43l-10 -156h-33zM163 62q0 -65 -75 -65q-41 0 -58.5 17t-17.5 47v147q0 26 10.5 35.5t26.5 12.5v4q-33 6 -33 40v127q0 62 72 62q37 0 56 -17t19 -48v-114h-51v109q0 23 -23 23q-24 0 -24 -25v-122q0 -21 25 -21h21v-35h-20q-27 0 -27 -25v-147 q0 -24 24 -24t24 27v103h51v-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etatonos",
    unicode: "\u03AE",
    horizAdvX: 182,
    d: "M13 0zM115 -233v649q0 26 -23 26q-11 0 -16 -6t-10 -19v-417h-53v486h50l1 -31h4q16 34 51 34q50 0 50 -63v-659h-54zM73 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotatonos",
    unicode: "\u03AF",
    horizAdvX: 92,
    d: "M13 0zM76 0q-63 0 -63 63v423h53v-423q0 -16 11 -16h8v-47h-9zM24 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresistonos",
    unicode: "\u03B0",
    horizAdvX: 177,
    d: "M4 0zM69 522v156h43l-10 -156h-33zM113 486h50v-413q0 -39 -18 -57.5t-57 -18.5t-57 18.5t-18 57.5v413h52v-413q0 -28 24 -28t24 28v413zM4 530v75h53v-75h-53zM118 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alpha",
    unicode: "\u03B1",
    horizAdvX: 192,
    d: "M177 0q-25 0 -37.5 6.5t-17.5 23.5h-4q-8 -16 -20 -24.5t-33 -8.5q-18 0 -28 5.5t-15.5 15.5t-7 24t-1.5 30v355q0 29 14 45.5t40 16.5q17 0 28 -8.5t19 -25.5h4l2 31h47v-422q0 -17 10 -17h8v-47h-8zM67 72q0 -29 23 -29q14 0 18.5 8.5t7.5 25.5v335q-4 17 -9 23.5 t-16 6.5q-24 0 -24 -28v-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "beta",
    unicode: "\u03B2",
    d: "M13 -233v845q0 33 17.5 48t60.5 15q39 0 56.5 -13.5t17.5 -48.5v-199q0 -35 -33 -45v-4q36 -9 36 -56v-236q0 -22 -5.5 -36.5t-14.5 -23.5t-20.5 -12.5t-24.5 -3.5q-14 0 -22.5 3t-15.5 8v-241h-52zM115 315q0 17 -5.5 23t-19.5 6h-8v42h8q16 0 20 8t4 19v191 q0 23 -24 23q-25 0 -25 -23v-548q5 -5 11 -9t15 -4q11 0 17.5 6.5t6.5 21.5v244z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u03B3",
    horizAdvX: 170,
    d: "M58 -233v174l-55 545h54l27 -378h4l27 378h51l-55 -545v-174h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u04AF",
    horizAdvX: 170,
    d: "M58 -233v174l-55 545h54l27 -378h4l27 378h51l-55 -545v-174h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "delta",
    unicode: "\u03B4",
    horizAdvX: 179,
    d: "M13 363q0 17 8 31t21 22v4q-9 6 -14 19t-5 28v137q0 38 21 54.5t60 16.5q9 0 20.5 -0.5t22.5 -2.5v-48q-20 5 -38 5q-19 0 -26.5 -5.5t-7.5 -19.5v-135q0 -11 4 -16.5t15 -11.5q2 -1 8 -4.5t13.5 -8l15 -9t12.5 -8.5q22 -18 22 -62v-276q0 -39 -18 -57.5t-58 -18.5 q-76 0 -76 76v290zM113 351q0 14 -4.5 22t-13.5 15l-17 10q-13 -13 -13 -35v-290q0 -28 24 -28t24 28v278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilon",
    unicode: "\u03B5",
    horizAdvX: 176,
    d: "M163 62q0 -65 -75 -65q-41 0 -58.5 17t-17.5 47v147q0 26 10.5 35.5t26.5 12.5v4q-33 6 -33 40v127q0 62 72 62q37 0 56 -17t19 -48v-114h-51v109q0 23 -23 23q-24 0 -24 -25v-122q0 -21 25 -21h21v-35h-20q-27 0 -27 -25v-147q0 -24 24 -24t24 27v103h51v-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeta",
    unicode: "\u03B6",
    horizAdvX: 161,
    d: "M95 -173v163q0 10 -9 10h-27q-46 0 -46 49v239q0 24 2.5 41t8.5 38l77 257h-83v48h136v-48l-80 -271q-3 -11 -5.5 -26.5t-2.5 -30.5v-234q0 -15 14 -15h33q36 0 36 -40v-180h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eta",
    unicode: "\u03B7",
    horizAdvX: 182,
    d: "M115 -233v649q0 26 -23 26q-11 0 -16 -6t-10 -19v-417h-53v486h50l1 -31h4q16 34 51 34q50 0 50 -63v-659h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "theta",
    unicode: "\u03B8",
    horizAdvX: 179,
    d: "M13 592q0 77 76 77t76 -77v-519q0 -76 -76 -76t-76 76v519zM113 327h-48v-254q0 -28 24 -28t24 28v254zM113 592q0 29 -24 29t-24 -29v-225h48v225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iota",
    unicode: "\u03B9",
    horizAdvX: 92,
    d: "M76 0q-63 0 -63 63v423h53v-423q0 -16 11 -16h8v-47h-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u03BA",
    horizAdvX: 180,
    d: "M121 0l-36 194h-3l-16 -59v-135h-53v486h53v-207h4l51 207h56l-53 -210l52 -276h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 180,
    d: "M121 0l-36 194h-3l-16 -59v-135h-53v486h53v-207h4l51 207h56l-53 -210l52 -276h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lambda",
    unicode: "\u03BB",
    horizAdvX: 188,
    d: "M182 0h-20q-25 0 -35 10t-12 32l-23 268h-5l-31 -310h-53l63 510l-8 97q-1 11 -5 14.5t-12 3.5h-11v47h26q29 0 41.5 -11.5t15.5 -45.5l50 -555q1 -8 3 -10.5t10 -2.5h6v-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\u03BC",
    d: "M13 -233v719h54v-417q0 -11 5 -18t16 -7q12 0 18 8t9 20v414h53v-486h-50l-1 30h-4q-13 -30 -37 -30q-5 0 -9.5 1t-6.5 3l7 -237h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "xi",
    unicode: "\u03BE",
    horizAdvX: 172,
    d: "M103 -173v163q0 10 -8 10h-36q-46 0 -46 49v286q0 25 10.5 34.5t26.5 12.5v4q-17 5 -25 14t-8 26v188q0 61 72 61q38 0 56 -17t18 -48v-101h-50v97q0 22 -23 22q-24 0 -24 -25v-182q0 -21 25 -21h20v-35h-18q-27 0 -27 -24v-279q0 -15 14 -15h42q35 0 35 -40v-180h-54z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 223,
    d: "M197 0q-64 0 -64 63v375h-44v-438h-54v438h-28v48h209v-48h-30v-375q0 -16 11 -16h7v-47h-7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rho",
    unicode: "\u03C1",
    horizAdvX: 179,
    d: "M113 412q0 29 -24 29t-24 -29v-343q4 -26 25 -26q23 0 23 29v340zM13 -233v645q0 77 76 77t76 -77v-354q0 -29 -13.5 -45t-38.5 -16q-29 0 -44 28h-4v-258h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigma1",
    unicode: "\u03C2",
    horizAdvX: 177,
    d: "M110 -173v163q0 10 -8 10h-43q-46 0 -46 49v363q0 77 76 77q39 0 56.5 -19.5t17.5 -57.5v-102h-50v102q0 29 -24 29t-24 -29v-350q0 -15 14 -15h50q34 0 34 -40v-180h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigma",
    unicode: "\u03C3",
    horizAdvX: 189,
    d: "M182 438h-23q2 -6 3 -13.5t1 -15.5v-336q0 -39 -17.5 -57.5t-56.5 -18.5q-76 0 -76 76v336q0 77 76 77h93v-48zM113 409q0 17 -5 29h-12q-13 0 -22 -6t-9 -23v-335q0 -14 5 -21.5t19 -7.5q24 0 24 28v336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tau",
    unicode: "\u03C4",
    horizAdvX: 142,
    d: "M108 0q-64 0 -64 63v375h-37v48h128v-48h-37v-375q0 -16 11 -16h7v-47h-8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilon",
    unicode: "\u03C5",
    horizAdvX: 177,
    d: "M113 486h50v-413q0 -39 -18 -57.5t-57 -18.5t-57 18.5t-18 57.5v413h52v-413q0 -28 24 -28t24 28v413z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u03C6",
    horizAdvX: 254,
    d: "M101 -233v233h-38q-23 0 -36.5 15.5t-13.5 42.5v370q0 26 13.5 42t36.5 16h38v186h52v-186h38q23 0 37 -16t14 -42v-370q0 -27 -14 -42.5t-37 -15.5h-38v-233h-52zM101 442h-19q-20 0 -20 -25v-348q0 -25 20 -25h19v398zM153 44h19q20 0 20 25v348q0 25 -20 25h-19v-398z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 254,
    d: "M101 -233v233h-38q-23 0 -36.5 15.5t-13.5 42.5v370q0 26 13.5 42t36.5 16h38v186h52v-186h38q23 0 37 -16t14 -42v-370q0 -27 -14 -42.5t-37 -15.5h-38v-233h-52zM101 442h-19q-20 0 -20 -25v-348q0 -25 20 -25h19v398zM153 44h19q20 0 20 25v348q0 25 -20 25h-19v-398z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "chi",
    unicode: "\u03C7",
    horizAdvX: 178,
    d: "M120 -233l-30 286h-4l-29 -286h-54l48 364l-46 355h54l30 -271h4l27 271h53l-46 -343l48 -376h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omega",
    unicode: "\u03C9",
    horizAdvX: 262,
    d: "M197 427q0 36 -13 59h52q13 -17 13 -59v-352q0 -42 -15 -60t-44 -18q-18 0 -32 6t-25 21h-4q-11 -15 -25 -21t-32 -6q-30 0 -44.5 18t-14.5 60v352q0 41 12 59h52q-12 -24 -12 -59v-353q0 -29 21 -29q22 0 22 28v270h45v-270q0 -28 22 -28t22 29v353z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresis",
    unicode: "\u03CA",
    horizAdvX: 122,
    d: "M0 0zM95 0q-63 0 -63 63v423h53v-423q0 -16 11 -16h8v-47h-9zM-4 530v75h49v-75h-49zM73 530v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresis",
    unicode: "\u03CB",
    horizAdvX: 177,
    d: "M13 0zM113 486h50v-413q0 -39 -18 -57.5t-57 -18.5t-57 18.5t-18 57.5v413h52v-413q0 -28 24 -28t24 28v413zM26 530v75h49v-75h-49zM103 530v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omicrontonos",
    unicode: "\u03CC",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM71 522v156h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilontonos",
    unicode: "\u03CD",
    horizAdvX: 177,
    d: "M13 0zM69 522v156h43l-10 -156h-33zM113 486h50v-413q0 -39 -18 -57.5t-57 -18.5t-57 18.5t-18 57.5v413h52v-413q0 -28 24 -28t24 28v413z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omegatonos",
    unicode: "\u03CE",
    horizAdvX: 262,
    d: "M13 0zM197 427q0 36 -13 59h52q13 -17 13 -59v-352q0 -42 -15 -60t-44 -18q-18 0 -32 6t-25 21h-4q-11 -15 -25 -21t-32 -6q-30 0 -44.5 18t-14.5 60v352q0 41 12 59h52q-12 -24 -12 -59v-353q0 -29 21 -29q22 0 22 28v270h45v-270q0 -28 22 -28t22 29v353zM109 522v156 h43l-10 -156h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 218,
    d: "M47 613h-39v51h139v-51h-44v-189h4q11 14 21.5 20t27.5 6q49 0 49 -58v-549q0 -76 -79 -76q-38 0 -58.5 19t-20.5 57v117h56v-117q0 -28 23 -28t23 28v533q0 24 -21 24q-11 0 -16.5 -7t-8.5 -24v-369h-56v613z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 149,
    d: "M12 0zM55 686l-21 21l74 100l28 -32zM12 0v664h129v-51h-73v-613h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    d: "M169 81q0 -84 -78 -84q-79 0 -79 85v498q0 42 20 64.5t58 22.5q39 0 59 -23t20 -65v-103h-53v108q0 31 -24 31q-25 0 -25 -30v-212h49v-46h-49v-249q0 -30 25 -30q24 0 24 30v115h53v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 306,
    d: "M195 381h38q35 0 49.5 -16.5t14.5 -46.5v-251q0 -30 -14 -48.5t-50 -18.5h-94v613h-39l-5 -195q-2 -85 -4.5 -148.5t-5.5 -109t-6.5 -74.5t-7.5 -44q-7 -24 -20.5 -33t-34.5 -9h-8v51h4q8 0 12.5 5t6.5 19t4.5 40.5t4.5 68t4.5 100t4.5 135.5l7 245h139v-283zM221 50 q14 0 18.5 8.5t4.5 26.5v221q0 17 -5 21.5t-17 4.5h-27v-282h26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 285,
    d: "M174 381h38q35 0 50 -16.5t15 -46.5v-251q0 -30 -14 -48.5t-51 -18.5h-94v332h-50v-332h-56v664h56v-283h50v283h56v-283zM201 50q23 0 23 35v221q0 17 -5 21.5t-17 4.5h-28v-282h27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 217,
    d: "M47 613h-39v51h139v-51h-44v-189h4q11 14 21.5 20t27.5 6q49 0 49 -58v-392h-56v376q0 24 -21 24q-10 0 -15 -5.5t-10 -19.5v-375h-56v613z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 184,
    d: "M12 0zM123 0l-36 285h-2l-17 -76v-209h-56v664h56v-259h4l52 259h56l-53 -257l52 -407h-56zM67 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 196,
    d: "M12 0zM39 775l28 32l74 -100l-21 -21zM130 0v453h-3l-56 -453h-59v664h54v-431h4l51 431h63v-664h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 184,
    d: "M12 0zM91 686q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27zM116 277h-4q-6 -13 -19 -19t-27 -6q-54 0 -54 84v328h54v-331q0 -30 23 -30t27 25v336h55v-582q0 -85 -79 -85q-38 0 -59 20.5 t-21 63.5v140h54v-143q0 -30 25 -30t25 30v199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 187,
    d: "M72 -138v138h-60v664h56v-613h50v613h56v-664h-60v-138h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 179,
    d: "M141 613h-73v-232h38q35 0 49.5 -16.5t14.5 -46.5v-251q0 -30 -14 -48.5t-50 -18.5h-94v664h129v-51zM94 50q14 0 18.5 8.5t4.5 26.5v221q0 17 -5 21.5t-17 4.5h-27v-282h26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 223,
    d: "M175 -138v138h-127v-138h-41v189h5q9 0 13 10q4 7 7.5 26.5t6.5 59t5.5 105t5.5 166.5l7 246h139v-613h20v-189h-41zM140 613h-39l-5 -196q-3 -110 -6 -178.5t-6 -108t-6.5 -56.5t-6.5 -23h69v562z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 292,
    d: "M3 0l66 338l-63 326h57l51 -269h4v269h55v-269h4l52 269h57l-65 -326l68 -338h-59l-53 295h-4v-295h-55v295h-4l-53 -295h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 196,
    d: "M130 0v453h-3l-56 -453h-59v664h54v-431h4l51 431h63v-664h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 196,
    d: "M12 0zM99 686q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27zM130 0v453h-3l-56 -453h-59v664h54v-431h4l51 431h63v-664h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 207,
    d: "M139 0v613h-39l-5 -195q-2 -85 -4.5 -148.5t-5.5 -109t-6.5 -74.5t-7.5 -44q-7 -24 -20.5 -33t-34.5 -9h-8v51h4q8 0 12.5 5t6.5 19t4.5 40.5t4.5 68t4.5 100t4.5 135.5l7 245h139v-664h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 184,
    d: "M116 277h-4q-6 -13 -19 -19t-27 -6q-54 0 -54 84v328h54v-331q0 -30 23 -30t27 25v336h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v140h54v-143q0 -30 25 -30t25 30v199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 201,
    d: "M153 -138v138h-141v664h56v-613h50v613h56v-613h21v-189h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 184,
    d: "M116 0v295h-3q-18 -9 -43 -9q-32 0 -45 17t-13 59v302h54v-299q0 -16 5.5 -22t18.5 -6q7 0 14.5 1.5t11.5 6.5v319h55v-664h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 278,
    d: "M12 0v664h56v-613h44v613h52v-613h45v613h56v-664h-253z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 293,
    d: "M244 -138v138h-232v664h56v-613h44v613h52v-613h45v613h56v-613h21v-189h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 237,
    d: "M69 613h-61v51h118v-283h38q36 0 50 -18t14 -54v-242q0 -30 -14 -48.5t-50 -18.5h-95v613zM152 50q23 0 23 32v221q0 17 -6 23t-22 6h-21v-282h26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 258,
    d: "M12 0zM190 0v664h56v-664h-56zM68 381h38q35 0 49.5 -16.5t14.5 -46.5v-251q0 -30 -14 -48.5t-50 -18.5h-94v664h56v-283zM94 50q14 0 18.5 8.5t4.5 26.5v221q0 17 -5 21.5t-17 4.5h-27v-282h26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 179,
    d: "M68 381h38q35 0 49.5 -16.5t14.5 -46.5v-251q0 -30 -14 -48.5t-50 -18.5h-94v664h56v-283zM94 50q14 0 18.5 8.5t4.5 26.5v221q0 17 -5 21.5t-17 4.5h-27v-282h26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    d: "M12 193h52v-115q0 -30 25 -30t25 30v249h-50v46h50v212q0 30 -25 30t-25 -31v-108h-52v103q0 42 20 65t59 23q38 0 58 -22.5t20 -64.5v-498q0 -85 -79 -85q-78 0 -78 84v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 276,
    d: "M12 0v664h56v-291h35v207q0 42 21 64.5t59 22.5t59 -23t21 -65v-498q0 -84 -79 -84q-81 0 -81 85v242h-35v-324h-56zM208 584q0 31 -25 31t-25 -31v-506q0 -30 25 -30t25 30v506z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 179,
    d: "M3 0l34 299q-15 10 -21.5 27.5t-6.5 41.5v215q0 41 12.5 61t50.5 20h94v-664h-56v291h-21l-31 -291h-55zM61 365q0 -29 23 -29h26v277h-26q-23 0 -23 -30v-218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 180,
    d: "M113 414q0 28 -23 28q-19 0 -25 -25v-345q0 -29 24 -29t24 29v342zM168 58q0 -29 -19.5 -45t-57.5 -16q-41 0 -59.5 18.5t-18.5 57.5v506q0 48 11 70.5t44 22.5h32q23 0 26 24h32q0 -72 -39 -72h-30q-26 0 -26 -45v-118h4q8 14 18.5 21t27.5 7q26 0 40.5 -16.5 t14.5 -45.5v-369z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 178,
    d: "M162 306q0 -37 -31 -46v-4q20 -4 28 -17t8 -33v-136q0 -37 -17.5 -53.5t-57.5 -16.5h-79v486h80q36 0 52.5 -15t16.5 -47v-118zM66 239v-196h27q22 0 22 25v147q0 24 -25 24h-24zM113 415q0 24 -21 24h-26v-165h25q22 0 22 20v121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 121,
    d: "M13 0v486h101v-48h-48v-438h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 210,
    d: "M162 -150v150h-114v-150h-41v197h7q6 0 11 9.5t8.5 37.5t6.5 78t6 131l7 183h130v-439h21v-197h-42zM129 438h-35l-7 -136q-4 -74 -6.5 -120.5t-4.5 -74t-5 -40.5t-7 -20h65v391z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 272,
    d: "M213 0l-47 219h-4v-219h-52v219h-4l-47 -219h-56l58 248l-55 238h55l45 -198h4v198h52v-198h4l46 198h54l-56 -238l59 -248h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 176,
    d: "M163 61q0 -30 -17.5 -47t-58.5 -17q-75 0 -75 65v111h52v-103q0 -27 24 -27q23 0 23 24v147q0 25 -27 25h-19v35h20q25 0 25 21v122q0 25 -23 25q-24 0 -24 -23v-82h-51v87q0 31 19 48t57 17q70 0 70 -62v-127q0 -34 -32 -40v-4q16 -3 26.5 -12.5t10.5 -35.5v-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 189,
    d: "M123 0v300h-4l-51 -300h-55v486h52v-299h4l49 299h57v-486h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 189,
    d: "M13 0zM94 507q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27zM123 0v300h-4l-51 -300h-55v486h52v-299h4l49 299h57v-486h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 194,
    d: "M126 0v438h-35l-7 -127q-5 -80 -8 -132t-5.5 -83.5t-5 -47t-5.5 -23.5q-5 -13 -15.5 -19t-30.5 -6h-7v47h4q11 0 15 12q2 7 4 20.5t4 41.5t4 73.5t5 116.5l7 175h130v-486h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 243,
    d: "M183 0v263q0 27 0.5 44t1 28.5t1 19t0.5 14.5h-4l-37 -369h-47l-37 369h-4q0 -7 0.5 -14.5t1 -19t0.5 -28.5v-44v-263h-46v486h78l30 -356h3l29 356h77v-486h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 183,
    d: "M116 0v227h-50v-227h-53v486h53v-211h50v211h53v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 183,
    d: "M116 0v438h-50v-438h-53v486h156v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 152,
    d: "M49 0v438h-41v48h137v-48h-42v-438h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 197,
    d: "M148 -134v134h-135v486h53v-439h50v439h53v-439h21v-181h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 182,
    d: "M115 0v211h-4q-17 -10 -43 -10q-30 0 -43 12t-13 40v233h53v-219q0 -20 25 -20q17 0 25 6v233h53v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 268,
    d: "M13 0v486h53v-439h44v439h48v-439h44v439h53v-486h-242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 283,
    d: "M234 -134v134h-221v486h53v-439h44v439h48v-439h44v439h53v-439h21v-181h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 213,
    d: "M105 296h36q35 0 48.5 -12.5t13.5 -41.5v-192q0 -24 -14 -37t-48 -13h-90v438h-46v48h100v-190zM130 46q22 0 22 21v164q0 20 -22 20h-25v-205h25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 250,
    d: "M13 0zM66 296h37q34 0 47.5 -12.5t13.5 -41.5v-192q0 -24 -13.5 -37t-47.5 -13h-90v486h53v-190zM92 46q22 0 22 21v164q0 20 -22 20h-26v-205h26zM183 0v486h53v-486h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 174,
    d: "M66 296h37q34 0 47.5 -12.5t13.5 -41.5v-192q0 -24 -13.5 -37t-47.5 -13h-90v486h53v-190zM92 46q22 0 22 21v164q0 20 -22 20h-26v-205h26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 177,
    d: "M64 235v39h48v140q0 28 -24 28q-23 0 -23 -22v-81h-51v82q0 32 17.5 50t56.5 18q76 0 76 -77v-339q0 -76 -76 -76q-39 0 -57 19t-18 57v98h51v-101q0 -27 24 -27t24 28v164h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 265,
    d: "M251 73q0 -39 -18 -57.5t-58 -18.5q-39 0 -57 18.5t-18 57.5v156h-35v-229h-52v486h52v-209h35v135q0 40 18 58.5t57 18.5q40 0 58 -18.5t18 -58.5v-339zM199 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 178,
    d: "M3 0l36 203q-26 11 -26 50v182q0 24 13.5 37.5t47.5 13.5h90v-486h-53v198h-23l-31 -198h-54zM63 261q0 -12 6 -16t16 -4h26v198h-26q-22 0 -22 -23v-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    horizAdvX: 182,
    d: "M66 545v-91h4q8 17 19 26t31 9q27 0 38 -16.5t11 -51.5v-578q0 -76 -79 -76q-77 0 -77 76v130h53v-130q0 -28 24 -28q25 0 25 28v573q0 26 -23 26q-20 0 -26 -28v-414h-53v545h-14v34h14v93h53v-93h53v-34h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 121,
    d: "M13 0zM41 507l-21 21l74 100l28 -32zM13 0v486h101v-48h-48v-438h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 177,
    d: "M65 235v-164q0 -28 24 -28t24 27v101h50v-98q0 -38 -17.5 -57t-56.5 -19q-76 0 -76 76v339q0 77 76 77q39 0 56 -18t17 -50v-82h-50v81q0 22 -23 22q-24 0 -24 -28v-140h47v-39h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 288,
    d: "M180 296h36q35 0 48.5 -12.5t13.5 -41.5v-192q0 -24 -14 -37t-48 -13h-90v438h-35l-7 -127q-5 -80 -8 -132t-5.5 -83.5t-5 -47t-5.5 -23.5q-5 -13 -15.5 -19t-30.5 -6h-7v47h4q11 0 15 12q2 7 4 20.5t4 41.5t4 73.5t5 116.5l7 175h130v-190zM205 46q23 0 23 21v164 q0 20 -23 20h-25v-205h25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 277,
    d: "M169 296h37q34 0 47.5 -12.5t13.5 -41.5v-192q0 -24 -13.5 -37t-47.5 -13h-90v251h-50v-251h-53v486h53v-190h50v190h53v-190zM195 46q22 0 22 21v164q0 20 -22 20h-26v-205h26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 180,
    d: "M13 0zM72 507l-21 21l74 100l28 -32zM121 0l-36 194h-3l-16 -59v-135h-53v486h53v-207h4l51 207h56l-53 -210l52 -276h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 189,
    d: "M13 0zM34 596l28 32l74 -100l-21 -21zM123 0v300h-4l-51 -300h-55v486h52v-299h4l49 299h57v-486h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    d: "M13 0zM67 77q0 -28 23 -28q13 0 18 8t8 23v406h51v-643q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-3q-13 -28 -45 -28q-25 0 -39 16.5t-14 58.5v411h54v-409zM92 507q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5 t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 183,
    d: "M70 -134v134h-57v486h53v-439h50v439h53v-486h-57v-134h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0490",
    unicode: "\u0490",
    horizAdvX: 148,
    d: "M12 0v664h87v118h42v-169h-73v-613h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0491",
    unicode: "\u0491",
    horizAdvX: 121,
    d: "M13 0v486h60v104h41v-152h-48v-438h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0492",
    unicode: "\u0492",
    horizAdvX: 157,
    d: "M20 0v300h-18v43h18v321h130v-51h-74v-270h45v-43h-45v-300h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0493",
    unicode: "\u0493",
    horizAdvX: 128,
    d: "M19 0v203h-17v33h17v250h102v-48h-48v-202h48v-33h-48v-203h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0496",
    unicode: "\u0496",
    horizAdvX: 316,
    d: "M3 0l66 338l-63 326h57l51 -269h4v269h55v-269h4l52 269h57l-65 -326l57 -287h31v-154h-42v103h-37l-53 295h-4v-295h-55v295h-4l-53 -295h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0497",
    unicode: "\u0497",
    horizAdvX: 298,
    d: "M249 -103v103h-36l-47 219h-4v-219h-52v219h-4l-47 -219h-56l58 248l-55 238h55l45 -198h4v198h52v-198h4l46 198h54l-56 -238l47 -197h34v-154h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0498",
    unicode: "\u0498",
    horizAdvX: 178,
    d: "M50 -160q9 -3 22 -3q12 0 17 5t5 24v33q0 30 -5.5 55t-19.5 45q-57 9 -57 82v112h52v-115q0 -30 25 -30t25 30v222q0 28 -28 28h-22v47h23q15 0 20.5 7t5.5 20v185q0 12 -6 20t-18 8q-25 0 -25 -28v-111h-52v105q0 41 20 63.5t57 22.5q40 0 57.5 -23.5t17.5 -50.5v-186 q0 -46 -34 -52v-4q17 -3 28 -16t11 -40v-213q0 -78 -68 -84v-6q30 -39 30 -103v-32q0 -41 -11.5 -54t-36.5 -13q-20 0 -33 7v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0499",
    unicode: "\u0499",
    horizAdvX: 176,
    d: "M163 61q0 -29 -17 -46t-55 -18v-4q38 -33 38 -104v-32q0 -41 -11.5 -54t-36.5 -13q-20 0 -33 7v43q9 -3 22 -3q12 0 17 5t5 24v33q0 33 -6 57.5t-26 43.5q-48 9 -48 62v111h52v-103q0 -27 24 -27q23 0 23 24v147q0 25 -27 25h-19v35h20q25 0 25 21v122q0 25 -23 25 q-24 0 -24 -23v-82h-51v87q0 31 19 48t57 17q70 0 70 -62v-127q0 -34 -32 -40v-4q16 -3 26.5 -12.5t10.5 -35.5v-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049A",
    unicode: "\u049A",
    horizAdvX: 210,
    d: "M162 -103v103h-39l-36 285h-2l-17 -76v-209h-56v664h56v-259h4l52 259h56l-53 -257l45 -356h32v-154h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049B",
    unicode: "\u049B",
    horizAdvX: 203,
    d: "M155 -103v103h-34l-36 194h-3l-16 -59v-135h-53v486h53v-207h4l51 207h56l-53 -210l42 -225h31v-154h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A0",
    unicode: "\u04A0",
    horizAdvX: 252,
    d: "M80 0v613h-72v51h129v-259h4l51 259h56l-52 -257l51 -407h-56l-36 285h-2l-16 -76v-209h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A1",
    unicode: "\u04A1",
    horizAdvX: 222,
    d: "M55 0v438h-47v48h101v-207h3l51 207h56l-52 -210l51 -276h-55l-35 194h-4l-15 -56v-138h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A2",
    unicode: "\u04A2",
    horizAdvX: 201,
    d: "M153 -103v103h-35v329h-50v-329h-56v664h56v-286h50v286h56v-613h21v-154h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A3",
    unicode: "\u04A3",
    horizAdvX: 203,
    d: "M155 -103v103h-39v227h-50v-227h-53v486h53v-211h50v211h53v-435h28v-154h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AA",
    unicode: "\u04AA",
    d: "M54 -160q9 -3 22 -3q12 0 17 5t5 24v33q0 35 -7.5 59t-30.5 43q-48 15 -48 81v498q0 42 19.5 64.5t60.5 22.5q37 0 56.5 -20t19.5 -68l1 -153h-53v158q0 31 -24 31q-25 0 -25 -30v-506q0 -31 24 -31q25 0 25 30v193h53v-190q0 -42 -19 -62t-54 -22v-5q39 -34 39 -103v-32 q0 -41 -12 -54t-36 -13q-20 0 -33 7v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AB",
    unicode: "\u04AB",
    horizAdvX: 177,
    d: "M48 -160q9 -3 22 -3q12 0 17 5t5 24v33q0 35 -7 58.5t-30 43.5q-42 13 -42 72v339q0 77 76 77q39 0 56.5 -19.5t17.5 -57.5v-102h-50v102q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v105h50v-105q0 -38 -16.5 -56.5t-54.5 -19.5v-7q37 -33 37 -101v-32 q0 -41 -11.5 -54t-36.5 -13q-20 0 -33 7v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B2",
    unicode: "\u04B2",
    horizAdvX: 217,
    d: "M188 664l-53 -317l47 -296h28v-154h-41v103h-36l-34 259h-4l-35 -259h-56l55 335l-53 329h56l34 -246h4l33 246h55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B3",
    unicode: "\u04B3",
    horizAdvX: 202,
    d: "M173 486l-46 -232l38 -203h31v-154h-42v103h-34l-30 185h-4l-29 -185h-54l48 247l-46 239h54l30 -175h4l27 175h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B6",
    unicode: "\u04B6",
    horizAdvX: 201,
    d: "M153 -103v103h-37v295h-3q-18 -9 -43 -9q-32 0 -45 17t-13 59v302h54v-299q0 -16 5.5 -22t18.5 -6q7 0 14.5 1.5t11.5 6.5v319h55v-613h24v-154h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B7",
    unicode: "\u04B7",
    horizAdvX: 199,
    d: "M150 -103v103h-35v211h-4q-17 -10 -43 -10q-30 0 -43 12t-13 40v233h53v-219q0 -20 25 -20q17 0 25 6v233h53v-435h24v-154h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BA",
    unicode: "\u04BA",
    horizAdvX: 184,
    d: "M68 664v-295h2q19 9 44 9q32 0 45 -17t13 -59v-302h-54v299q0 28 -24 28q-7 0 -14.5 -2t-11.5 -7v-318h-55v664h55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C3",
    unicode: "\u04C3",
    horizAdvX: 184,
    d: "M99 -185q24 0 24 28v157l-36 285h-2l-17 -76v-209h-56v664h56v-259h4l52 259h56l-53 -257l52 -407v-157q0 -76 -80 -76v48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C4",
    unicode: "\u04C4",
    horizAdvX: 180,
    d: "M98 -185q24 0 24 28v146l-37 205h-3l-16 -59v-135h-53v486h53v-207h4l51 207h56l-53 -210l52 -276v-157q0 -76 -78 -76v48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C7",
    unicode: "\u04C7",
    horizAdvX: 187,
    d: "M94 -185q24 0 24 28v486h-50v-329h-56v664h56v-286h50v286h56v-821q0 -76 -80 -76v48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C8",
    unicode: "\u04C8",
    horizAdvX: 183,
    d: "M91 -185q25 0 25 28v384h-50v-227h-53v486h53v-211h50v211h53v-643q0 -76 -77 -76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E8",
    unicode: "\u04E8",
    d: "M170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 318h-50v-240q0 -30 25 -30t25 30v240zM65 367h50v217q0 31 -25 31t-25 -30v-218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E9",
    unicode: "\u04E9",
    horizAdvX: 179,
    d: "M165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 230h-48v-157q0 -28 24 -28t24 28v157zM65 265h48v147q0 29 -24 29t-24 -29v-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EE",
    unicode: "\u04EE",
    horizAdvX: 184,
    d: "M12 0zM32 712v34h119v-34h-119zM116 277h-4q-6 -13 -19 -19t-27 -6q-54 0 -54 84v328h54v-331q0 -30 23 -30t27 25v336h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v140h54v-143q0 -30 25 -30t25 30v199z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EF",
    unicode: "\u04EF",
    d: "M13 0zM67 77q0 -28 23 -28q13 0 18 8t8 23v406h51v-643q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-3q-13 -28 -45 -28q-25 0 -39 16.5t-14 58.5v411h54v-409zM32 533v34h119v-34h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0512",
    unicode: "\u0512",
    horizAdvX: 207,
    d: "M114 -185q25 0 25 28v770h-39l-5 -195q-2 -85 -4.5 -148.5t-5.5 -109t-6.5 -74.5t-7.5 -44q-7 -24 -20.5 -33t-34.5 -9h-8v51h4q8 0 12.5 5t6.5 19t4.5 40.5t4.5 68t4.5 100t4.5 135.5l7 245h139v-821q0 -38 -21 -57t-60 -19v48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0513",
    unicode: "\u0513",
    horizAdvX: 194,
    d: "M102 -185q24 0 24 28v595h-35l-7 -127q-5 -80 -8 -132t-5.5 -83.5t-5 -47t-5.5 -23.5q-5 -13 -15.5 -19t-30.5 -6h-7v47h4q11 0 15 12q2 7 4 20.5t4 41.5t4 73.5t5 116.5l7 175h130v-643q0 -76 -78 -76v48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni058F",
    unicode: "\u058F",
    horizAdvX: 196,
    d: "M110 0v161h-69v34h69v104h-69v34h69v253q0 30 -25 30q-24 0 -24 -30v-173h-53v169q0 85 78 85q79 0 79 -86v-248h23v-34h-23v-104h23v-34h-23v-161h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E0C",
    unicode: "\u1E0C",
    horizAdvX: 185,
    d: "M12 0zM12 0v664h83q77 0 77 -78v-504q0 -82 -77 -82h-83zM92 50q24 0 24 35v497q0 18 -7 24.5t-21 6.5h-21v-563h25zM59 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E0D",
    unicode: "\u1E0D",
    d: "M13 0zM67 72q0 -29 23 -29q12 0 17.5 7.5t8.5 24.5v333q-3 19 -8 26.5t-17 7.5q-24 0 -24 -28v-342zM120 0l-2 30h-4q-12 -33 -47 -33q-26 0 -40 16t-14 45v369q0 29 14.5 45.5t40.5 16.5q29 0 42 -28h4v211h53v-672h-47zM64 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E12",
    unicode: "\u1E12",
    horizAdvX: 185,
    d: "M11 0zM12 0v664h83q77 0 77 -78v-504q0 -82 -77 -82h-83zM92 50q24 0 24 35v497q0 18 -7 24.5t-21 6.5h-21v-563h25zM124 -160l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E13",
    unicode: "\u1E13",
    d: "M13 0zM67 72q0 -29 23 -29q12 0 17.5 7.5t8.5 24.5v333q-3 19 -8 26.5t-17 7.5q-24 0 -24 -28v-342zM120 0l-2 30h-4q-12 -33 -47 -33q-26 0 -40 16t-14 45v369q0 29 14.5 45.5t40.5 16.5q29 0 42 -28h4v211h53v-672h-47zM133 -160l-45 70l-45 -70l-23 18l44 83h48 l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E24",
    unicode: "\u1E24",
    horizAdvX: 187,
    d: "M12 0zM118 0v329h-50v-329h-56v664h56v-286h50v286h56v-664h-56zM66 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E25",
    unicode: "\u1E25",
    horizAdvX: 182,
    d: "M13 0zM115 0v416q0 26 -22 26q-21 0 -27 -28v-414h-53v672h53v-218h4q8 17 19 26t31 9q27 0 38 -16.5t11 -51.5v-421h-54zM63 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E3C",
    unicode: "\u1E3C",
    horizAdvX: 149,
    d: "M8 0zM12 0v664h56v-613h73v-51h-129zM121 -160l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E3D",
    unicode: "\u1E3D",
    horizAdvX: 87,
    d: "M0 0zM16 0v672h53v-672h-53zM88 -160l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E44",
    unicode: "\u1E44",
    horizAdvX: 196,
    d: "M12 0zM111 0l-52 532h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-289h-45v664h80l44 -527h4q0 15 -0.5 35.5t-1 53.5t-1 82t-0.5 121v235h47v-664h-73zM69 709v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E45",
    unicode: "\u1E45",
    horizAdvX: 182,
    d: "M13 0zM115 0v416q0 26 -23 26q-11 0 -16 -6t-10 -19v-417h-53v486h50l1 -31h4q16 34 51 34q50 0 50 -63v-426h-54zM63 530v75h53v-75h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E4A",
    unicode: "\u1E4A",
    horizAdvX: 196,
    d: "M12 0zM111 0l-52 532h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-289h-45v664h80l44 -527h4q0 15 -0.5 35.5t-1 53.5t-1 82t-0.5 121v235h47v-664h-73zM139 -160l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E4B",
    unicode: "\u1E4B",
    horizAdvX: 182,
    d: "M13 0zM115 0v416q0 26 -23 26q-11 0 -16 -6t-10 -19v-417h-53v486h50l1 -31h4q16 34 51 34q50 0 50 -63v-426h-54zM135 -160l-45 70l-45 -70l-23 18l44 83h48l44 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E5A",
    unicode: "\u1E5A",
    d: "M12 0zM12 0v664h94q35 0 49.5 -18t14.5 -51v-213q0 -44 -34 -52v-4q17 -4 26 -15.5t9 -37.5v-273h-54v278q0 25 -23 25h-27v-303h-55zM116 589q0 24 -23 24h-26v-265h26q23 0 23 28v213zM63 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E5B",
    unicode: "\u1E5B",
    horizAdvX: 137,
    d: "M10 0zM13 0v486h50l1 -35h4q7 18 17 28t27 10q8 0 18 -4v-49q-7 4 -20 4q-20 0 -30.5 -11t-13.5 -38v-391h-53zM10 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E62",
    unicode: "\u1E62",
    horizAdvX: 188,
    d: "M10 0zM119 457v128q0 14 -6 22t-20 8t-20 -7.5t-6 -18.5v-111q0 -20 1 -32t2.5 -20t4.5 -13.5t8 -11.5q20 -28 39 -45t35 -39q12 -17 16 -33.5t4 -48.5v-150q0 -45 -19.5 -66.5t-62.5 -21.5q-45 0 -65 23.5t-20 68.5v110h52v-120q0 -31 30 -31q27 0 27 28v136q0 21 -1 34 t-3 22t-6 15.5t-10 14.5q-18 23 -39 43t-32 44q-8 17 -12.5 43.5t-4.5 55.5v104q0 35 19.5 57t60.5 22q42 0 61 -24.5t19 -63.5v-122h-52zM65 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E63",
    unicode: "\u1E63",
    horizAdvX: 176,
    d: "M11 0zM112 337v85q0 22 -24 22t-24 -21v-94q0 -20 3.5 -28t14.5 -17q16 -12 30.5 -19.5t27.5 -18.5t19 -25.5t6 -48.5v-108q0 -35 -18 -51t-57 -16q-42 0 -60.5 17t-18.5 52v90h50v-91q0 -25 26 -25q25 0 25 23v109q0 16 -4.5 23.5t-17.5 18.5q-14 11 -29.5 21t-26.5 22 q-12 14 -16.5 28.5t-4.5 43.5v99q0 29 19 45t55 16q38 0 56.5 -18.5t18.5 -50.5v-83h-50zM62 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E6C",
    unicode: "\u1E6C",
    horizAdvX: 175,
    d: "M8 0zM59 0v613h-51v51h159v-51h-52v-613h-56zM60 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E6D",
    unicode: "\u1E6D",
    horizAdvX: 171,
    d: "M13 0zM112 274h45v-201q0 -39 -14.5 -57.5t-53.5 -18.5q-76 0 -76 76v546h52v-133h92v-48h-92v-365q0 -28 25 -28q22 0 22 28v201zM61 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 274,
    d: "M4 0zM35 0l-31 664h53l19 -547h4l25 547h64l26 -547h4l18 547h53l-31 -664h-80l-20 536h-4l-20 -536h-80zM76 775l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 250,
    d: "M3 0zM31 0l-28 486h51l14 -371h4l22 371h61l23 -371h4l14 371h51l-28 -486h-75l-17 377h-4l-18 -377h-74zM65 596l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 274,
    d: "M4 0zM35 0l-31 664h53l19 -547h4l25 547h64l26 -547h4l18 547h53l-31 -664h-80l-20 536h-4l-20 -536h-80zM118 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 250,
    d: "M3 0zM31 0l-28 486h51l14 -371h4l22 371h61l23 -371h4l14 371h51l-28 -486h-75l-17 377h-4l-18 -377h-74zM104 507l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 274,
    d: "M4 0zM35 0l-31 664h53l19 -547h4l25 547h64l26 -547h4l18 547h53l-31 -664h-80l-20 536h-4l-20 -536h-80zM73 709v75h49v-75h-49zM150 709v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 250,
    d: "M3 0zM31 0l-28 486h51l14 -371h4l22 371h61l23 -371h4l14 371h51l-28 -486h-75l-17 377h-4l-18 -377h-74zM61 530v75h49v-75h-49zM138 530v75h49v-75h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E92",
    unicode: "\u1E92",
    horizAdvX: 168,
    d: "M8 0zM8 0v51l96 562h-95v51h148v-50l-94 -564h97v-50h-152zM56 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E93",
    unicode: "\u1E93",
    horizAdvX: 152,
    d: "M9 0zM9 0v50l84 388h-84v48h133v-49l-84 -388h86v-49h-135zM49 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 205,
    d: "M87 50q5 -3 11.5 -4t11.5 -1q28 0 28 29v264q0 22 -22 22q-10 0 -22 -5v50l38 208h-32q-32 0 -32 -34v-579h-56v580q0 41 20.5 62.5t59.5 21.5h91v-47l-40 -213q23 0 36.5 -15.5t13.5 -47.5v-266q0 -43 -17.5 -60.5t-52.5 -17.5q-11 0 -20.5 1t-15.5 3v49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA0",
    unicode: "\u1EA0",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM64 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA1",
    unicode: "\u1EA1",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM60 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA2",
    unicode: "\u1EA2",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM77 692q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA3",
    unicode: "\u1EA3",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM72 513q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA4",
    unicode: "\u1EA4",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM136 686l-44 62l-46 -62l-23 18l44 75h48l44 -75zM150 754l-20 21l60 71l28 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA5",
    unicode: "\u1EA5",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM135 507l-44 62l-46 -62l-23 18l44 75h48l44 -75zM149 575l-20 21l60 71l28 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA6",
    unicode: "\u1EA6",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM134 686l-44 62l-46 -62l-23 18l44 75h48l44 -75zM106 815l27 31l60 -71l-20 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA7",
    unicode: "\u1EA7",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM131 507l-44 62l-46 -62l-23 18l44 75h48l44 -75zM103 636l27 31l60 -71l-20 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA8",
    unicode: "\u1EA8",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM138 686l-45 62l-45 -62l-23 18l44 75h48l44 -75zM149 740q0 11 4.5 17.5t10 11t10 8.5t4.5 12q0 12 -14 12q-15 0 -25 -10l-10 28q8 8 19.5 11t20.5 3q17 0 28 -11t11 -28 q0 -13 -5 -20t-11.5 -12.5t-11.5 -10t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA9",
    unicode: "\u1EA9",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM128 507l-45 62l-45 -62l-23 18l44 75h48l44 -75zM139 561q0 11 4.5 17.5t10 11t10 8.5t4.5 12q0 12 -14 12q-15 0 -25 -10l-10 28q8 8 19.5 11t20.5 3q17 0 28 -11t11 -28q0 -13 -5 -20t-11.5 -12.5 t-11.5 -10t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAA",
    unicode: "\u1EAA",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM136 686l-44 54l-46 -54l-23 18l44 67h48l44 -67zM162 815q-5 -17 -15 -25t-23 -8q-17 0 -30 8t-28 8q-7 0 -11.5 -2.5t-7.5 -12.5l-24 13q5 18 14.5 26t23.5 8q17 0 30 -8t28 -8 q6 0 11 2.5t8 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAB",
    unicode: "\u1EAB",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM130 507l-44 54l-46 -54l-23 18l44 67h48l44 -67zM156 636q-5 -17 -15 -25t-23 -8q-17 0 -30 8t-28 8q-7 0 -11.5 -2.5t-7.5 -12.5l-24 13q5 18 14.5 26t23.5 8q17 0 30 -8t28 -8q6 0 11 2.5t8 12.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAC",
    unicode: "\u1EAC",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM137 686l-45 70l-45 -70l-23 18l44 83h48l44 -83zM65 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAD",
    unicode: "\u1EAD",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM132 507l-45 70l-45 -70l-23 18l44 83h48l44 -83zM60 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAE",
    unicode: "\u1EAE",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM94 685q-31 0 -50 19t-19 61h38q2 -50 31 -50t29 50h40q0 -42 -19.5 -61t-49.5 -19zM87 745l-20 21l63 73l27 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAF",
    unicode: "\u1EAF",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM90 506q-31 0 -50 19t-19 61h38q2 -50 31 -50t29 50h40q0 -42 -19.5 -61t-49.5 -19zM83 566l-20 21l63 73l27 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB0",
    unicode: "\u1EB0",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM95 685q-32 0 -51 19t-19 61h39q2 -50 31 -50t29 50h39q0 -42 -19 -61t-49 -19zM31 803l27 31l63 -68l-20 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB1",
    unicode: "\u1EB1",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM88 506q-32 0 -51 19t-19 61h39q2 -50 31 -50t29 50h39q0 -42 -19 -61t-49 -19zM24 624l27 31l63 -68l-20 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB2",
    unicode: "\u1EB2",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM92 685q-31 0 -50 19t-19 61h38q2 -50 31 -50q28 0 30 50h39q0 -42 -19.5 -61t-49.5 -19zM73 750q0 11 4.5 17t9.5 10.5t9.5 8.5t4.5 11q0 12 -14 12q-12 0 -25 -10l-8 27q7 7 18.5 10 t20.5 3q17 0 27.5 -10t10.5 -27q0 -12 -5 -19t-11.5 -12t-11.5 -9.5t-5 -11.5h-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB3",
    unicode: "\u1EB3",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM88 506q-31 0 -50 19t-19 61h38q2 -50 31 -50q28 0 30 50h39q0 -42 -19.5 -61t-49.5 -19zM69 571q0 11 4.5 17t9.5 10.5t9.5 8.5t4.5 11q0 12 -14 12q-12 0 -25 -10l-8 27q7 7 18.5 10t20.5 3 q17 0 27.5 -10t10.5 -27q0 -12 -5 -19t-11.5 -12t-11.5 -9.5t-5 -11.5h-25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB4",
    unicode: "\u1EB4",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM91 685q-31 0 -50 19t-19 61h38q2 -50 31 -50q28 0 30 50h39q0 -42 -19.5 -61t-49.5 -19zM159 818q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13 q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB5",
    unicode: "\u1EB5",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM86 506q-31 0 -50 19t-19 61h38q2 -50 31 -50q28 0 30 50h39q0 -42 -19.5 -61t-49.5 -19zM154 639q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9 q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB6",
    unicode: "\u1EB6",
    horizAdvX: 186,
    d: "M4 0zM126 0l-10 171h-49l-9 -171h-54l44 664h88l45 -664h-55zM70 219h43l-19 349h-4zM92 686q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27zM65 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB7",
    unicode: "\u1EB7",
    horizAdvX: 177,
    d: "M9 0zM112 256q-6 -5 -12.5 -7t-14.5 -5q-14 -5 -18.5 -12.5t-4.5 -21.5v-143q0 -24 22 -24q20 0 28 20v193zM115 0l-1 25h-4q-6 -11 -16.5 -19.5t-33.5 -8.5q-29 0 -40 15.5t-11 41.5v146q0 34 13.5 49.5t48.5 26.5q19 6 29.5 11.5t10.5 18.5v117q0 19 -23 19 q-25 0 -25 -21v-92h-50v98q0 32 20.5 47t58.5 15q72 0 72 -58v-431h-49zM86 507q-31 0 -50.5 27.5t-19.5 73.5h39q1 -36 8.5 -51.5t22.5 -15.5q14 0 21.5 15.5t9.5 51.5h39q0 -47 -19.5 -74t-50.5 -27zM59 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB8",
    unicode: "\u1EB8",
    horizAdvX: 145,
    d: "M12 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM46 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB9",
    unicode: "\u1EB9",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM62 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBA",
    unicode: "\u1EBA",
    horizAdvX: 145,
    d: "M12 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM62 692q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBB",
    unicode: "\u1EBB",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM73 513q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5 q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBC",
    unicode: "\u1EBC",
    horizAdvX: 145,
    d: "M4 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM143 730q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBD",
    unicode: "\u1EBD",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM158 551q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9 q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBE",
    unicode: "\u1EBE",
    horizAdvX: 145,
    d: "M7 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM120 686l-44 62l-46 -62l-23 18l44 75h48l44 -75zM134 754l-20 21l60 71l28 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBF",
    unicode: "\u1EBF",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM134 507l-44 62l-46 -62l-23 18l44 75h48l44 -75zM148 575l-20 21l60 71l28 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC0",
    unicode: "\u1EC0",
    horizAdvX: 145,
    d: "M5 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM118 686l-44 62l-46 -62l-23 18l44 75h48l44 -75zM90 815l27 31l60 -71l-20 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC1",
    unicode: "\u1EC1",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM130 507l-44 62l-46 -62l-23 18l44 75h48l44 -75zM102 636l27 31l60 -71l-20 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC2",
    unicode: "\u1EC2",
    horizAdvX: 145,
    d: "M6 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM119 686l-45 62l-45 -62l-23 18l44 75h48l44 -75zM130 740q0 11 4.5 17.5t10 11t10 8.5t4.5 12q0 12 -14 12q-15 0 -25 -10l-10 28q8 8 19.5 11t20.5 3q17 0 28 -11t11 -28q0 -13 -5 -20t-11.5 -12.5 t-11.5 -10t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC3",
    unicode: "\u1EC3",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM130 507l-45 62l-45 -62l-23 18l44 75h48l44 -75zM141 561q0 11 4.5 17.5t10 11t10 8.5t4.5 12 q0 12 -14 12q-15 0 -25 -10l-10 28q8 8 19.5 11t20.5 3q17 0 28 -11t11 -28q0 -13 -5 -20t-11.5 -12.5t-11.5 -10t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC4",
    unicode: "\u1EC4",
    horizAdvX: 145,
    d: "M7 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM120 686l-44 54l-46 -54l-23 18l44 67h48l44 -67zM146 815q-5 -17 -15 -25t-23 -8q-17 0 -30 8t-28 8q-7 0 -11.5 -2.5t-7.5 -12.5l-24 13q5 18 14.5 26t23.5 8q17 0 30 -8t28 -8q6 0 11 2.5t8 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC5",
    unicode: "\u1EC5",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM133 507l-44 54l-46 -54l-23 18l44 67h48l44 -67zM159 636q-5 -17 -15 -25t-23 -8q-17 0 -30 8t-28 8 q-7 0 -11.5 -2.5t-7.5 -12.5l-24 13q5 18 14.5 26t23.5 8q17 0 30 -8t28 -8q6 0 11 2.5t8 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC6",
    unicode: "\u1EC6",
    horizAdvX: 145,
    d: "M9 0zM12 0v664h122v-51h-67v-240h60v-50h-60v-273h71v-50h-126zM122 686l-45 70l-45 -70l-23 18l44 83h48l44 -83zM50 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC7",
    unicode: "\u1EC7",
    horizAdvX: 179,
    d: "M13 0zM166 73q0 -76 -77 -76q-76 0 -76 76v339q0 77 76 77q77 0 77 -77v-180h-101v-160q0 -29 24 -29t24 29v94h53v-93zM113 413q0 28 -24 28t-24 -28v-143h48v143zM134 507l-45 70l-45 -70l-23 18l44 83h48l44 -83zM61 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC8",
    unicode: "\u1EC8",
    horizAdvX: 84,
    d: "M5 0zM12 0v664h56v-664h-56zM25 692q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC9",
    unicode: "\u1EC9",
    horizAdvX: 83,
    d: "M4 0zM13 0v486h53v-486h-53zM24 513q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECA",
    unicode: "\u1ECA",
    horizAdvX: 80,
    d: "M12 0zM12 0v664h56v-664h-56zM13 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECB",
    unicode: "\u1ECB",
    horizAdvX: 80,
    d: "M12 0zM13 0v486h53v-486h-53zM13 530v75h53v-75h-53zM12 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECC",
    unicode: "\u1ECC",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM63 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECD",
    unicode: "\u1ECD",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM62 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECE",
    unicode: "\u1ECE",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM75 692q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5 t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECF",
    unicode: "\u1ECF",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM73 513q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5 t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED0",
    unicode: "\u1ED0",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM137 686l-44 62l-46 -62l-23 18l44 75h48l44 -75zM151 754l-20 21l60 71l28 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED1",
    unicode: "\u1ED1",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM133 507l-44 62l-46 -62l-23 18l44 75h48l44 -75zM147 575l-20 21l60 71l28 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED2",
    unicode: "\u1ED2",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM136 686l-44 62l-46 -62l-23 18l44 75h48l44 -75zM108 815l27 31l60 -71l-20 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED3",
    unicode: "\u1ED3",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM132 507l-44 62l-46 -62l-23 18l44 75h48l44 -75zM104 636l27 31l60 -71l-20 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED4",
    unicode: "\u1ED4",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM135 686l-45 62l-45 -62l-23 18l44 75h48l44 -75zM146 740q0 11 4.5 17.5t10 11t10 8.5t4.5 12q0 12 -14 12 q-15 0 -25 -10l-10 28q8 8 19.5 11t20.5 3q17 0 28 -11t11 -28q0 -13 -5 -20t-11.5 -12.5t-11.5 -10t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED5",
    unicode: "\u1ED5",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM132 507l-45 62l-45 -62l-23 18l44 75h48l44 -75zM143 561q0 11 4.5 17.5t10 11t10 8.5t4.5 12q0 12 -14 12q-15 0 -25 -10l-10 28 q8 8 19.5 11t20.5 3q17 0 28 -11t11 -28q0 -13 -5 -20t-11.5 -12.5t-11.5 -10t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED6",
    unicode: "\u1ED6",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM135 686l-44 54l-46 -54l-23 18l44 67h48l44 -67zM161 815q-5 -17 -15 -25t-23 -8q-17 0 -30 8t-28 8 q-7 0 -11.5 -2.5t-7.5 -12.5l-24 13q5 18 14.5 26t23.5 8q17 0 30 -8t28 -8q6 0 11 2.5t8 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED7",
    unicode: "\u1ED7",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM134 507l-44 54l-46 -54l-23 18l44 67h48l44 -67zM160 636q-5 -17 -15 -25t-23 -8q-17 0 -30 8t-28 8q-7 0 -11.5 -2.5t-7.5 -12.5l-24 13 q5 18 14.5 26t23.5 8q17 0 30 -8t28 -8q6 0 11 2.5t8 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED8",
    unicode: "\u1ED8",
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM115 584q0 31 -25 31t-25 -30v-507q0 -30 25 -30t25 30v506zM135 686l-45 70l-45 -70l-23 18l44 83h48l44 -83zM63 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED9",
    unicode: "\u1ED9",
    horizAdvX: 179,
    d: "M13 0zM165 73q0 -76 -76 -76t-76 76v339q0 77 76 77t76 -77v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339zM135 507l-45 70l-45 -70l-23 18l44 83h48l44 -83zM62 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDA",
    unicode: "\u1EDA",
    horizAdvX: 210,
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 20.5 64.5t58.5 22.5q15 0 32 -2.5t30 -2.5q15 0 20.5 5.5t5.5 19.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -26 -7.5 -39t-26.5 -13h-7.5t-9.5 2q13 -20 13 -53v-498zM115 584q0 31 -25 31t-25 -30v-507 q0 -30 25 -30t25 30v506zM68 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDB",
    unicode: "\u1EDB",
    horizAdvX: 202,
    d: "M13 0zM69 507l-21 21l74 100l28 -32zM165 73q0 -39 -18 -57.5t-58 -18.5q-76 0 -76 76v339q0 77 74 77q17 0 31 -3t27 -3q14 0 19 5.5t5 20.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -53 -32 -53q-7 0 -11 1q8 -18 8 -40v-339zM113 412q0 29 -24 29t-24 -29 v-339q0 -28 24 -28t24 28v339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDC",
    unicode: "\u1EDC",
    horizAdvX: 210,
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 20.5 64.5t58.5 22.5q15 0 32 -2.5t30 -2.5q15 0 20.5 5.5t5.5 19.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -26 -7.5 -39t-26.5 -13h-7.5t-9.5 2q13 -20 13 -53v-498zM115 584q0 31 -25 31t-25 -30v-507 q0 -30 25 -30t25 30v506zM30 775l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDD",
    unicode: "\u1EDD",
    horizAdvX: 202,
    d: "M13 0zM29 596l28 32l74 -100l-21 -21zM165 73q0 -39 -18 -57.5t-58 -18.5q-76 0 -76 76v339q0 77 74 77q17 0 31 -3t27 -3q14 0 19 5.5t5 20.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -53 -32 -53q-7 0 -11 1q8 -18 8 -40v-339zM113 412q0 29 -24 29t-24 -29 v-339q0 -28 24 -28t24 28v339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDE",
    unicode: "\u1EDE",
    horizAdvX: 210,
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 20.5 64.5t58.5 22.5q15 0 32 -2.5t30 -2.5q15 0 20.5 5.5t5.5 19.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -26 -7.5 -39t-26.5 -13h-7.5t-9.5 2q13 -20 13 -53v-498zM115 584q0 31 -25 31t-25 -30v-507 q0 -30 25 -30t25 30v506zM74 692q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDF",
    unicode: "\u1EDF",
    horizAdvX: 202,
    d: "M13 0zM165 73q0 -39 -18 -57.5t-58 -18.5q-76 0 -76 76v339q0 77 74 77q17 0 31 -3t27 -3q14 0 19 5.5t5 20.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -53 -32 -53q-7 0 -11 1q8 -18 8 -40v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339z M75 513q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE0",
    unicode: "\u1EE0",
    horizAdvX: 210,
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 20.5 64.5t58.5 22.5q15 0 32 -2.5t30 -2.5q15 0 20.5 5.5t5.5 19.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -26 -7.5 -39t-26.5 -13h-7.5t-9.5 2q13 -20 13 -53v-498zM115 584q0 31 -25 31t-25 -30v-507 q0 -30 25 -30t25 30v506zM160 730q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE1",
    unicode: "\u1EE1",
    horizAdvX: 202,
    d: "M13 0zM165 73q0 -39 -18 -57.5t-58 -18.5q-76 0 -76 76v339q0 77 74 77q17 0 31 -3t27 -3q14 0 19 5.5t5 20.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -53 -32 -53q-7 0 -11 1q8 -18 8 -40v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339z M159 551q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE2",
    unicode: "\u1EE2",
    horizAdvX: 210,
    d: "M10 0zM170 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 20.5 64.5t58.5 22.5q15 0 32 -2.5t30 -2.5q15 0 20.5 5.5t5.5 19.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -26 -7.5 -39t-26.5 -13h-7.5t-9.5 2q13 -20 13 -53v-498zM115 584q0 31 -25 31t-25 -30v-507 q0 -30 25 -30t25 30v506zM63 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE3",
    unicode: "\u1EE3",
    horizAdvX: 202,
    d: "M13 0zM165 73q0 -39 -18 -57.5t-58 -18.5q-76 0 -76 76v339q0 77 74 77q17 0 31 -3t27 -3q14 0 19 5.5t5 20.5q0 5 -0.5 13.5t-1.5 13.5h29q2 -5 3 -14t1 -18q0 -53 -32 -53q-7 0 -11 1q8 -18 8 -40v-339zM113 412q0 29 -24 29t-24 -29v-339q0 -28 24 -28t24 28v339z M62 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE4",
    unicode: "\u1EE4",
    horizAdvX: 184,
    d: "M12 0zM116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM64 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE5",
    unicode: "\u1EE5",
    d: "M13 0zM67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54zM64 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE6",
    unicode: "\u1EE6",
    horizAdvX: 184,
    d: "M12 0zM116 664h55v-582q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM75 692q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5 t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE7",
    unicode: "\u1EE7",
    d: "M13 0zM67 486v-410q0 -17 4.5 -25t17.5 -8t18.5 8t7.5 26v409h53v-486h-50l-1 30h-4q-9 -18 -19 -25.5t-28 -7.5t-28.5 6.5t-16 17.5t-7 25.5t-1.5 29.5v410h54zM76 513q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5 q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE8",
    unicode: "\u1EE8",
    horizAdvX: 228,
    d: "M12 0zM116 664h59q20 0 20 25q0 5 -0.5 12.5t-2.5 12.5h30q2 -5 3 -13.5t1 -18.5q0 -27 -7.5 -39.5t-25.5 -12.5q-5 0 -10 1t-12 2v-551q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM70 686l-21 21l74 100l28 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE9",
    unicode: "\u1EE9",
    horizAdvX: 223,
    d: "M13 0zM70 507l-21 21l74 100l28 -32zM67 486v-417q0 -26 21 -26q11 0 16.5 6t10.5 20v417h56q19 0 19 24q0 5 -0.5 13t-2.5 13h29q3 -5 4 -13.5t1 -18.5q0 -26 -7.5 -39t-26.5 -13q-9 0 -19 3v-455h-50l-1 30h-3q-7 -14 -18 -23.5t-31 -9.5q-17 0 -27.5 7.5t-16 21 t-7 31.5t-1.5 38v391h54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEA",
    unicode: "\u1EEA",
    horizAdvX: 228,
    d: "M12 0zM116 664h59q20 0 20 25q0 5 -0.5 12.5t-2.5 12.5h30q2 -5 3 -13.5t1 -18.5q0 -27 -7.5 -39.5t-25.5 -12.5q-5 0 -10 1t-12 2v-551q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM32 775l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEB",
    unicode: "\u1EEB",
    horizAdvX: 223,
    d: "M13 0zM31 596l28 32l74 -100l-21 -21zM67 486v-417q0 -26 21 -26q11 0 16.5 6t10.5 20v417h56q19 0 19 24q0 5 -0.5 13t-2.5 13h29q3 -5 4 -13.5t1 -18.5q0 -26 -7.5 -39t-26.5 -13q-9 0 -19 3v-455h-50l-1 30h-3q-7 -14 -18 -23.5t-31 -9.5q-17 0 -27.5 7.5t-16 21 t-7 31.5t-1.5 38v391h54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEC",
    unicode: "\u1EEC",
    horizAdvX: 228,
    d: "M12 0zM116 664h59q20 0 20 25q0 5 -0.5 12.5t-2.5 12.5h30q2 -5 3 -13.5t1 -18.5q0 -27 -7.5 -39.5t-25.5 -12.5q-5 0 -10 1t-12 2v-551q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM76 692q0 11 4.5 17t10 10.5t10 8t4.5 10.5 q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EED",
    unicode: "\u1EED",
    horizAdvX: 223,
    d: "M13 0zM67 486v-417q0 -26 21 -26q11 0 16.5 6t10.5 20v417h56q19 0 19 24q0 5 -0.5 13t-2.5 13h29q3 -5 4 -13.5t1 -18.5q0 -26 -7.5 -39t-26.5 -13q-9 0 -19 3v-455h-50l-1 30h-3q-7 -14 -18 -23.5t-31 -9.5q-17 0 -27.5 7.5t-16 21t-7 31.5t-1.5 38v391h54zM75 513 q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEE",
    unicode: "\u1EEE",
    horizAdvX: 228,
    d: "M12 0zM116 664h59q20 0 20 25q0 5 -0.5 12.5t-2.5 12.5h30q2 -5 3 -13.5t1 -18.5q0 -27 -7.5 -39.5t-25.5 -12.5q-5 0 -10 1t-12 2v-551q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM160 727q-9 -36 -37 -36q-17 0 -30.5 10.5 t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEF",
    unicode: "\u1EEF",
    horizAdvX: 223,
    d: "M13 0zM160 551q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17zM67 486v-417q0 -26 21 -26q11 0 16.5 6t10.5 20v417h56q19 0 19 24q0 5 -0.5 13t-2.5 13h29q3 -5 4 -13.5t1 -18.5 q0 -26 -7.5 -39t-26.5 -13q-9 0 -19 3v-455h-50l-1 30h-3q-7 -14 -18 -23.5t-31 -9.5q-17 0 -27.5 7.5t-16 21t-7 31.5t-1.5 38v391h54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF0",
    unicode: "\u1EF0",
    horizAdvX: 228,
    d: "M12 0zM116 664h59q20 0 20 25q0 5 -0.5 12.5t-2.5 12.5h30q2 -5 3 -13.5t1 -18.5q0 -27 -7.5 -39.5t-25.5 -12.5q-5 0 -10 1t-12 2v-551q0 -85 -79 -85q-38 0 -59 20.5t-21 63.5v583h54v-586q0 -30 25 -30t25 30v586zM64 -111v74h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF1",
    unicode: "\u1EF1",
    horizAdvX: 223,
    d: "M13 0zM67 486v-417q0 -26 21 -26q11 0 16.5 6t10.5 20v417h56q19 0 19 24q0 5 -0.5 13t-2.5 13h29q3 -5 4 -13.5t1 -18.5q0 -26 -7.5 -39t-26.5 -13q-9 0 -19 3v-455h-50l-1 30h-3q-7 -14 -18 -23.5t-31 -9.5q-17 0 -27.5 7.5t-16 21t-7 31.5t-1.5 38v391h54zM64 -111v74 h54v-74h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 184,
    d: "M3 0zM65 0v274l-62 390h57l31 -250h4l29 250h57l-60 -390v-274h-56zM32 775l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    d: "M13 0zM67 77q0 -28 23 -28q13 0 18 8t8 23v406h51v-643q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-3q-13 -28 -45 -28q-25 0 -39 16.5t-14 58.5v411h54v-409zM31 596l28 32l74 -100l-21 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF6",
    unicode: "\u1EF6",
    horizAdvX: 184,
    d: "M3 0zM65 0v274l-62 390h57l31 -250h4l29 250h57l-60 -390v-274h-56zM79 692q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF7",
    unicode: "\u1EF7",
    d: "M13 0zM67 77q0 -28 23 -28q13 0 18 8t8 23v406h51v-643q0 -76 -77 -76q-76 0 -76 76v127h52v-127q0 -28 24 -28t24 28v185h-3q-13 -28 -45 -28q-25 0 -39 16.5t-14 58.5v411h54v-409zM76 513q0 11 4.5 17t10 10.5t10 8t4.5 10.5q0 11 -14 11t-25 -11l-10 29 q8 7 19.5 10.5t20.5 3.5q17 0 28 -10.5t11 -27.5q0 -12 -5 -18.5t-11.5 -11.5t-11.5 -9.5t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 125,
    d: "M9 282v46h106v-46h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 179,
    d: "M9 282v46h160v-46h-160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 79,
    d: "M66 654q-23 -14 -23 -46v-49h23v-83h-54v125q0 71 54 83v-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 79,
    d: "M12 494q24 16 24 45v50h-24v83h54v-125q0 -71 -54 -83v30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 79,
    d: "M12 0zM12 -95q24 14 24 45v50h-24v82h54v-125q0 -71 -54 -83v31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 156,
    d: "M12 476zM66 654q-23 -14 -23 -46v-49h23v-83h-54v125q0 71 54 83v-30zM143 654q-23 -14 -23 -46v-49h23v-83h-54v125q0 71 54 83v-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 155,
    d: "M12 464zM12 494q24 16 24 45v50h-24v83h54v-125q0 -71 -54 -83v30zM88 494q24 16 24 45v50h-24v83h54v-125q0 -71 -54 -83v30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 155,
    d: "M12 0zM12 -95q24 14 24 45v50h-24v82h54v-125q0 -71 -54 -83v31zM88 -95q24 14 24 45v50h-24v82h54v-125q0 -71 -54 -83v31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 152,
    d: "M60 0v488h-48v30h48v146h33v-146h47v-30h-47v-488h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 151,
    d: "M60 0v145h-48v31h48v311h-48v31h48v146h33v-146h47v-31h-47v-311h47v-31h-47v-145h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 112,
    d: "M56 284q-19 0 -31.5 14t-12.5 34q0 21 12.5 34.5t31.5 13.5t32 -13.5t13 -34.5q0 -20 -13 -34t-32 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 231,
    d: "M88 0v82h54v-82h-54zM164 0v82h55v-82h-55zM12 0v82h54v-82h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 274,
    d: "M1 0zM15 -11l120 688h34l-121 -688h-33zM185 52q0 -54 -40 -54q-41 0 -41 55v190q0 53 41 53q40 0 40 -53v-191zM155 243q0 26 -10 26q-11 0 -11 -26v-191q0 -26 11 -26q10 0 10 26v191zM272 52q0 -54 -40 -54q-41 0 -41 55v190q0 53 41 53q40 0 40 -53v-191zM242 243 q0 26 -10 26q-11 0 -11 -26v-191q0 -26 11 -26q10 0 10 26v191zM82 421q0 -54 -40 -54q-41 0 -41 55v190q0 53 41 53q40 0 40 -53v-191zM52 612q0 26 -10 26q-11 0 -11 -26v-191q0 -26 11 -26q10 0 10 26v191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 87,
    d: "M5 318l53 105l24 -19l-45 -86l45 -87l-24 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 87,
    d: "M5 232l45 87l-45 86l23 19l54 -105l-54 -106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 42,
    d: "M-55 -11l120 688h34l-121 -688h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 103,
    d: "M11 367zM92 421q0 -54 -40 -54q-41 0 -41 55v190q0 53 41 53q40 0 40 -53v-191zM62 612q0 26 -10 26q-11 0 -11 -26v-191q0 -26 11 -26q10 0 10 26v191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 102,
    d: "M9 369zM52 574h-4l-16 -117h20v117zM52 369v63h-43v25l33 207h38v-207h13v-25h-13v-63h-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 102,
    d: "M11 367zM90 410q0 -43 -39 -43q-15 0 -27.5 8.5t-12.5 33.5v38h29v-40q0 -12 10 -12q11 0 11 12v116q0 12 -10 12q-8 0 -11 -9h-28l4 138h69v-27h-43l-3 -85q6 8 22 8q11 0 20 -7t9 -27v-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 102,
    d: "M11 367zM90 409q0 -42 -39 -42q-40 0 -40 43v212q0 43 41 43q38 0 38 -39v-52h-29v52q0 12 -9 12q-11 0 -11 -13v-93h1q7 13 22 13q26 0 26 -29v-107zM61 509q0 11 -8 11q-9 0 -12 -10v-103q0 -12 11 -12q9 0 9 12v102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 86,
    d: "M9 369zM20 369q0 65 8.5 135t21.5 132h-41v28h67v-24q-17 -69 -22 -137.5t-5 -133.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 100,
    d: "M10 367zM50 638q-10 0 -10 -14v-81q0 -14 10 -14q9 0 9 14v81q0 14 -9 14zM50 367q-20 0 -30 11t-10 31v70q0 14 4 23t15 14v3q-16 4 -16 30v78q0 16 8.5 27t28.5 11t29 -11t9 -27v-78q0 -26 -17 -30v-3q19 -8 19 -37v-70q0 -20 -10 -31t-30 -11zM50 395q11 0 11 12v81 q0 16 -11 16q-10 0 -10 -16v-81q0 -12 10 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 102,
    d: "M11 367zM11 623q0 20 8 31t32 11q23 0 31 -11t8 -31v-211q0 -18 -7.5 -31.5t-32.5 -13.5q-23 0 -30.5 12t-7.5 31v41h28v-44q0 -12 10 -12q11 0 11 12v97h-4q-7 -13 -20 -13q-11 0 -18.5 7.5t-7.5 21.5v103zM40 527q0 -11 8 -11q10 0 13 12v97q0 13 -11 13q-10 0 -10 -13 v-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 103,
    d: "M92 52q0 -54 -40 -54q-41 0 -41 55v190q0 53 41 53q40 0 40 -53v-191zM62 243q0 26 -10 26q-11 0 -11 -26v-191q0 -26 11 -26q10 0 10 26v191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 69,
    d: "M28 0v254h-19v24q12 0 16 4.5t6 12.5h25v-295h-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 100,
    d: "M11 0v83q0 14 3 23.5t11 19.5q7 10 16 19l14 14q4 5 5 10.5t1 14.5v73q0 12 -10 12t-10 -14v-70h-29v68q0 22 6.5 32.5t32.5 10.5q23 0 31 -9.5t8 -29.5v-73q0 -25 -12 -39q-3 -3 -13 -13.5t-15 -17.5q-8 -11 -8 -25v-63h48v-26h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 100,
    d: "M90 40q0 -42 -39 -42q-40 0 -40 44v63h29v-65q0 -14 10 -14q11 0 11 12v87q0 15 -13 15h-10v25h11q11 0 11 14v77q0 13 -10 13t-10 -14v-55h-29v52q0 44 39 44q20 0 29 -11t9 -27v-77q0 -21 -16 -26v-3q8 -2 13 -8.5t5 -20.5v-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 102,
    d: "M52 205h-4l-16 -117h20v117zM52 0v63h-43v25l33 207h38v-207h13v-25h-13v-63h-28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 102,
    d: "M90 41q0 -43 -39 -43q-15 0 -27.5 8.5t-12.5 33.5v38h29v-40q0 -12 10 -12q11 0 11 12v116q0 12 -10 12q-8 0 -11 -9h-28l4 138h69v-27h-43l-3 -85q6 8 22 8q11 0 20 -7t9 -27v-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 102,
    d: "M90 40q0 -42 -39 -42q-40 0 -40 43v212q0 43 41 43q38 0 38 -39v-52h-29v52q0 12 -9 12q-11 0 -11 -13v-93h1q7 13 22 13q26 0 26 -29v-107zM61 140q0 11 -8 11q-9 0 -12 -10v-103q0 -12 11 -12q9 0 9 12v102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 86,
    d: "M20 0q0 65 8.5 135t21.5 132h-41v28h67v-24q-17 -69 -22 -137.5t-5 -133.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 100,
    d: "M50 269q-10 0 -10 -14v-81q0 -14 10 -14q9 0 9 14v81q0 14 -9 14zM50 -2q-20 0 -30 11t-10 31v70q0 14 4 23t15 14v3q-16 4 -16 30v78q0 16 8.5 27t28.5 11t29 -11t9 -27v-78q0 -26 -17 -30v-3q19 -8 19 -37v-70q0 -20 -10 -31t-30 -11zM50 26q11 0 11 12v81q0 16 -11 16 q-10 0 -10 -16v-81q0 -12 10 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 102,
    d: "M11 254q0 20 8 31t32 11q23 0 31 -11t8 -31v-211q0 -18 -7.5 -31.5t-32.5 -13.5q-23 0 -30.5 12t-7.5 31v41h28v-44q0 -12 10 -12q11 0 11 12v97h-4q-7 -13 -20 -13q-11 0 -18.5 7.5t-7.5 21.5v103zM40 158q0 -11 8 -11q10 0 13 12v97q0 13 -11 13q-10 0 -10 -13v-98z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 273,
    d: "M42 0l-12 255h-25v34h24l-5 119h-19v34h17l-9 222h49l6 -222h29l10 222h57l10 -222h30l7 222h47l-10 -222h20v-34h-22l-5 -119h27v-34h-28l-11 -255h-72l-10 255h-24l-8 -255h-73zM181 289h18l4 119h-27zM73 289h18l5 119h-27zM124 289h22l-4 119h-14zM83 102l6 153h-15 l5 -153h4zM194 102l4 153h-15l7 -153h4zM129 442h12l-4 110h-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AA",
    unicode: "\u20AA",
    horizAdvX: 225,
    d: "M122 68v521q0 20 -17 20h-58v-609h-35v664h108q19 0 28.5 -10.5t9.5 -41.5v-544h-36zM102 595v-520q0 -22 18 -22h57v611h36v-664h-108q-20 0 -29 10t-9 41v544h35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dong",
    unicode: "\u20AB",
    horizAdvX: 152,
    d: "M97 90l-1 20h-4q-4 -9 -13 -16t-25 -7q-19 0 -30 11.5t-11 31.5v314q0 21 12.5 31.5t29.5 10.5q14 0 22.5 -5t11.5 -13h4v118h-65v29h65v57h39v-57h15v-29h-15v-496h-35zM52 141q0 -19 20 -19q11 0 15.5 5t6.5 13v290q-5 21 -22 21q-8 0 -14 -4t-6 -14v-292zM9 0v29h123 v-29h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 172,
    d: "M166 41q-23 -44 -69 -44q-33 0 -52 21.5t-19 63.5v169h-17l3 34h14v106h-17l3 33h14v156q0 42 20 64.5t61 22.5q28 0 42 -13l-9 -53q-14 14 -30 14q-29 0 -29 -30v-161h50l-3 -33h-47v-106h39l-4 -34h-35v-173q0 -30 23 -30q11 0 18 7t13 19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AD",
    unicode: "\u20AD",
    horizAdvX: 206,
    d: "M136 337l57 -337h-56l-53 337h-2v-337h-57v337h-20v37h20v290h57v-290h2l53 290h57l-60 -290h62v-37h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AE",
    unicode: "\u20AE",
    horizAdvX: 175,
    d: "M115 350v-97l46 26v-40l-46 -26v-213h-56v181l-40 -22v39l40 23v98l-43 -24v39l43 24v255h-51v51h159v-51h-52v-224l43 25v-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B1",
    unicode: "\u20B1",
    horizAdvX: 198,
    d: "M179 380v-53q0 -32 -15 -50t-50 -18h-38v-259h-56v380h-20v42h20v76h-20v41h20v125h94q35 0 50 -18.5t15 -50.5v-56h19v-41h-19v-76h19v-42h-19zM76 422h50v76h-50v-76zM76 539h50v50q0 24 -23 24h-27v-74zM103 308q23 0 23 28v44h-50v-72h27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B2",
    unicode: "\u20B2",
    d: "M12 -11l8 47q-5 9 -6.5 20.5t-1.5 25.5v498q0 42 20 64.5t58 22.5q21 0 39 -8l3 18h35l-9 -48q11 -22 11 -50v-116h-41l-22 -129h63v-334h-36l-2 21h-4q-5 -10 -15.5 -17t-29.5 -7q-17 0 -34 7l-2 -15h-34zM97 284l-30 -175q0 -38 6 -49.5t18 -11.5q22 0 25 27v209h-19z M67 305h4l45 280q-2 30 -25 30q-24 0 -24 -30v-280z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4",
    unicode: "\u20B4",
    horizAdvX: 188,
    d: "M76 278q-5 -10 -6.5 -25t-1.5 -41v-136q0 -28 28 -28q30 0 30 31v120h52v-110q0 -45 -20 -68.5t-65 -23.5q-43 0 -62.5 21.5t-19.5 66.5v150v24t2 19h-11v27h21l46 55h-67v26h91q9 12 14.5 20.5t8.5 18t4 21.5t1 32v111q0 11 -6 18.5t-20 7.5t-20 -8t-6 -22v-128h-52v122 q0 39 19 63.5t61 24.5q41 0 60.5 -22t19.5 -57v-104q0 -29 -4.5 -55t-12.5 -43h27v-26h-43l-49 -55h92v-27h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8",
    unicode: "\u20B8",
    horizAdvX: 156,
    d: "M57 0v522h-48v48h140v-48h-48v-522h-44zM9 617v47h140v-47h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 153,
    d: "M64 0l-36 303v32h19q27 0 27 30v95h-65v37h65v100q0 28 -26 28h-39v39h135v-39h-28v-4q8 -8 8 -24v-100h20v-37h-20v-95q0 -52 -44 -65l39 -300h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BA",
    unicode: "\u20BA",
    horizAdvX: 192,
    d: "M82 304v-254h25q24 0 24 30v119h53v-117q0 -82 -77 -82h-80v273l-19 -10v39l19 10v88l-19 -10v38l19 10v226h55v-195l68 38v-38l-68 -38v-88l68 38v-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BC",
    unicode: "\u20BC",
    horizAdvX: 260,
    d: "M157 664v-143h29q35 0 49.5 -17.5t14.5 -49.5v-454h-49v445q0 28 -24 28h-20v-473h-54v473h-20q-24 0 -24 -28v-445h-49v454q0 32 14.5 49.5t49.5 17.5h29v143h54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BD",
    unicode: "\u20BD",
    horizAdvX: 198,
    d: "M87 149v-149h-56v149h-25v34h25v83h-25v34h25v364h94q35 0 49.5 -18.5t14.5 -50.5v-261q0 -32 -14.5 -50t-49.5 -18h-38v-83h77v-34h-77zM137 589q0 24 -24 24h-26v-313h26q24 0 24 28v261z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BE",
    unicode: "\u20BE",
    horizAdvX: 209,
    d: "M86 397v215q-22 -6 -22 -27v-428q0 -42 12 -67t35 -44v-46h-104v48h47v4q-20 14 -31 35.5t-11 68.5v436q0 33 16.5 51.5t57.5 22.5v70h15v-69h19v69h15v-71q35 -5 50 -23t15 -50v-146h-44v139q0 19 -21 27v-215h-15v218h-19v-218h-15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "litre",
    unicode: "\u2113",
    horizAdvX: 146,
    d: "M101 0q-11 -3 -21 -3q-14 0 -25 5.5t-18 20.5t-10.5 40.5t-3.5 66.5l-18 -4v42l18 3v432q0 64 55 64q58 0 58 -64v-312q0 -103 -77 -145q0 -38 2 -60t5.5 -33.5t8.5 -15t11 -3.5q7 0 15 2v-36zM59 187q42 30 42 108v309q0 23 -21 23t-21 -23v-417z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2116",
    unicode: "\u2116",
    horizAdvX: 325,
    d: "M113 0l-52 532h-4q1 -12 1.5 -28.5t0.5 -43.5v-68.5v-102.5v-289h-45v664h80l44 -527h4q0 15 -0.5 35.5t-1 53.5t-1 82t-0.5 121v235h47v-664h-73zM315 366q0 -35 -15.5 -51.5t-38.5 -16.5q-25 0 -40 18t-15 51v232q0 33 15 50.5t40 17.5q23 0 38.5 -16.5t15.5 -51.5 v-233zM276 596q0 31 -16 31t-16 -31v-225q0 -33 16 -33t16 32v226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2117",
    unicode: "\u2117",
    horizAdvX: 176,
    d: "M172 81q0 -84 -79 -84q-81 0 -81 85v498q0 42 21 64.5t59 22.5t59 -23t21 -65v-498zM150 579q0 32 -15 49t-43 17t-43.5 -17t-15.5 -48v-498q0 -63 60 -63q57 0 57 62v498zM56 176v310h44q29 0 29 -32v-121q0 -36 -29 -36h-22v-121h-22zM107 451q0 14 -14 14h-15v-149h15 q14 0 14 14v121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 190,
    d: "M29 444v199h-20v21h63v-21h-20v-199h-23zM156 444v158h-4l-11 -158h-23l-12 158h-4v-158h-20v220h37l8 -152h4l10 152h36v-220h-21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 199,
    d: "M9 0zM14 -11l120 688h34l-121 -688h-33zM28 369v254h-19v24q12 0 16 4.5t6 12.5h25v-295h-28zM192 40q0 -42 -39 -42q-40 0 -40 44v63h29v-65q0 -14 10 -14q11 0 11 12v87q0 15 -13 15h-10v25h11q11 0 11 14v77q0 13 -10 13t-10 -14v-55h-29v52q0 44 39 44q20 0 29 -11 t9 -27v-77q0 -21 -16 -26v-3q8 -2 13 -8.5t5 -20.5v-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 199,
    d: "M1 0zM26 -11l120 688h34l-121 -688h-33zM1 369v83q0 14 3 23.5t11 19.5q7 10 16 19l14 14q4 5 5 10.5t1 14.5v73q0 12 -10 12t-10 -14v-70h-29v68q0 22 6.5 32.5t32.5 10.5q23 0 31 -9.5t8 -29.5v-73q0 -25 -12 -39q-3 -3 -13 -13.5t-15 -17.5q-8 -11 -8 -25v-63h48v-26 h-79zM196 40q0 -42 -39 -42q-40 0 -40 44v63h29v-65q0 -14 10 -14q11 0 11 12v87q0 15 -13 15h-10v25h11q11 0 11 14v77q0 13 -10 13t-10 -14v-55h-29v52q0 44 39 44q20 0 29 -11t9 -27v-77q0 -21 -16 -26v-3q8 -2 13 -8.5t5 -20.5v-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 199,
    d: "M10 0zM10 -11l120 688h34l-121 -688h-33zM32 369v254h-19v24q12 0 16 4.5t6 12.5h25v-295h-28zM146 269q-10 0 -10 -14v-81q0 -14 10 -14q9 0 9 14v81q0 14 -9 14zM146 -2q-20 0 -30 11t-10 31v70q0 14 4 23t15 14v3q-16 4 -16 30v78q0 16 8.5 27t28.5 11t29 -11t9 -27 v-78q0 -26 -17 -30v-3q19 -8 19 -37v-70q0 -20 -10 -31t-30 -11zM146 26q11 0 11 12v81q0 16 -11 16q-10 0 -10 -16v-81q0 -12 10 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 199,
    d: "M3 0zM23 -11l120 688h34l-121 -688h-33zM154 269q-10 0 -10 -14v-81q0 -14 10 -14q9 0 9 14v81q0 14 -9 14zM154 -2q-20 0 -30 11t-10 31v70q0 14 4 23t15 14v3q-16 4 -16 30v78q0 16 8.5 27t28.5 11t29 -11t9 -27v-78q0 -26 -17 -30v-3q19 -8 19 -37v-70q0 -20 -10 -31 t-30 -11zM154 26q11 0 11 12v81q0 16 -11 16q-10 0 -10 -16v-81q0 -12 10 -12zM82 409q0 -42 -39 -42q-40 0 -40 44v63h29v-65q0 -14 10 -14q11 0 11 12v87q0 15 -13 15h-10v25h11q11 0 11 14v77q0 13 -10 13t-10 -14v-55h-29v52q0 44 39 44q20 0 29 -11t9 -27v-77 q0 -21 -16 -26v-3q8 -2 13 -8.5t5 -20.5v-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 199,
    d: "M5 0zM23 -11l120 688h34l-121 -688h-33zM84 410q0 -43 -39 -43q-15 0 -27.5 8.5t-12.5 33.5v38h29v-40q0 -12 10 -12q11 0 11 12v116q0 12 -10 12q-8 0 -11 -9h-28l4 138h69v-27h-43l-3 -85q6 8 22 8q11 0 20 -7t9 -27v-116zM153 269q-10 0 -10 -14v-81q0 -14 10 -14 q9 0 9 14v81q0 14 -9 14zM153 -2q-20 0 -30 11t-10 31v70q0 14 4 23t15 14v3q-16 4 -16 30v78q0 16 8.5 27t28.5 11t29 -11t9 -27v-78q0 -26 -17 -30v-3q19 -8 19 -37v-70q0 -20 -10 -31t-30 -11zM153 26q11 0 11 12v81q0 16 -11 16q-10 0 -10 -16v-81q0 -12 10 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 199,
    d: "M11 0zM11 -11l120 688h34l-121 -688h-33zM145 269q-10 0 -10 -14v-81q0 -14 10 -14q9 0 9 14v81q0 14 -9 14zM145 -2q-20 0 -30 11t-10 31v70q0 14 4 23t15 14v3q-16 4 -16 30v78q0 16 8.5 27t28.5 11t29 -11t9 -27v-78q0 -26 -17 -30v-3q19 -8 19 -37v-70q0 -20 -10 -31 t-30 -11zM145 26q11 0 11 12v81q0 16 -11 16q-10 0 -10 -16v-81q0 -12 10 -12zM24 369q0 65 8.5 135t21.5 132h-41v28h67v-24q-17 -69 -22 -137.5t-5 -133.5h-29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 154,
    d: "M100 359q-7 25 -26 25q-21 0 -21 -26v-294q0 -25 24 -25q23 0 23 25v295zM12 358q0 67 48 67q24 0 37 -19h2v129q0 50 -9 70t-28 20q-7 0 -16 -3t-16 -10l-12 38q8 8 21 12.5t27 4.5q39 0 57.5 -31.5t18.5 -99.5v-469q0 -70 -67 -70q-63 0 -63 64v297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 151,
    d: "M97 -182v804h-44v-804h-41v846h127v-846h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 144,
    d: "M13 -182v39l51 383l-51 385v39h116v-42h-75l48 -382l-48 -380h75v-42h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 171,
    d: "M12 313v42h147v-42h-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 158,
    d: "M44 0l-22 327h-19v41h56l12 -277h4l40 573h40l-53 -664h-58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 251,
    d: "M112 331q-15 57 -40 57q-26 0 -26 -55t26 -55q24 0 40 53zM125 293q-11 -26 -27 -42.5t-37 -16.5q-49 0 -49 99q0 100 49 100q21 0 37 -16.5t27 -42.5q14 29 29.5 44t35.5 15q49 0 49 -100q0 -99 -49 -99q-37 0 -65 59zM139 331q16 -53 39 -53q26 0 26 55t-25 55t-40 -57 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 127,
    d: "M12 -233v42h17q13 0 13 18v786q0 51 50 51h23v-42h-16q-15 0 -15 -19v-785q0 -51 -49 -51h-23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 171,
    d: "M12 252zM118 257q-20 0 -35 6.5t-32 6.5q-21 0 -39 -18v45q6 6 15.5 10.5t24.5 4.5q20 0 35 -6.5t32 -6.5q11 0 21.5 4t18.5 13v-44q-17 -15 -41 -15zM118 356q-20 0 -35 6.5t-32 6.5q-21 0 -39 -18v45q6 6 15.5 10.5t24.5 4.5q20 0 35 -6.5t32 -6.5q11 0 21.5 4t18.5 13 v-44q-17 -15 -41 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 171,
    d: "M10 -20l44 265h-42v41h49l15 92h-64v42h71l44 264h34l-44 -264h42v-42h-49l-16 -92h65v-41h-72l-44 -265h-33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 171,
    d: "M12 141zM12 310v44l147 70v-48l-100 -42v-4l100 -43v-46zM12 141v42h147v-42h-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 171,
    d: "M12 141zM12 141v42h147v-42h-147zM12 241v46l100 43v4l-100 42v48l147 -70v-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotmath",
    unicode: "\u22C5",
    horizAdvX: 78,
    d: "M12 292zM12 292v83h54v-83h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 169,
    d: "M63 0l-51 331l51 333h45l48 -333l-48 -331h-45zM87 522h-5l-28 -191l28 -187h6l28 187z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE000",
    unicode: "\uE000",
    d: "M269 -157q0 -76 -76 -76q-77 0 -77 76v177h-3q-6 -9 -15 -16t-28 -7q-32 0 -45 22.5t-13 62.5v498q0 42 20 64.5t58 22.5q39 0 59 -23t20 -65v-120h-53v125q0 31 -25 31q-24 0 -24 -30v-507q0 -30 24 -30q22 0 25 27v209h-28v50h81v-491q0 -28 25 -28q24 0 24 28v130h51 v-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE001",
    unicode: "\uE001",
    d: "M114 -233v259h-3q-7 -16 -17.5 -22.5t-27.5 -6.5q-29 0 -41 17t-12 52v361q0 29 14 45.5t40 16.5q18 0 29 -8.5t19 -26.5h3l2 32h47v-719h-53zM67 72q0 -29 23 -29q12 0 17.5 7.5t8.5 24.5v337q-4 16 -9.5 23t-16.5 7q-23 0 -23 -28v-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE002",
    unicode: "\uE002",
    horizAdvX: 165,
    d: "M78 310l35 -36l-26 -28l-85 84l85 84l26 -27l-35 -35h79v-42h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE003",
    unicode: "\uE003",
    horizAdvX: 165,
    d: "M82 353l-35 36l26 27l85 -83l-85 -84l-26 26l35 36h-80v42h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE004",
    unicode: "\uE004",
    horizAdvX: 315,
    d: "M262 -162q0 -36 -18 -53.5t-57 -17.5q-71 0 -71 71v182h-3q-6 -9 -15 -16t-28 -7q-32 0 -45 22.5t-13 62.5v498q0 42 20 64.5t58 22.5q39 0 59 -23t20 -65v-120h-53v125q0 31 -25 31q-24 0 -24 -30v-507q0 -30 24 -30q25 0 25 27v209h-28v50h81v-496q0 -23 19 -23 q18 0 18 23v135h56v-135zM206 0v613h-34v51h137v-51h-47v-613h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE005",
    unicode: "\uE005",
    horizAdvX: 184,
    d: "M12 0v51h11q16 0 23 6.5t10 25.5l8 57l-61 524h54l35 -344h4l31 344h54l-69 -594q-5 -42 -26.5 -56t-62.5 -14h-11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE006",
    unicode: "\uE006",
    horizAdvX: 142,
    d: "M135 438h-48v-371q0 -20 17 -20h26v-47h-26q-71 0 -71 67v371h-26v48h26v128h54v-128h48v-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "psi",
    horizAdvX: 254,
    d: "M101 -233v233h-38q-23 0 -36.5 15.5t-13.5 42.5v428h49v-417q0 -25 20 -25h19v628h52v-628h19q20 0 20 25v417h50v-428q0 -27 -14 -42.5t-37 -15.5h-38v-233h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflexhook",
    horizAdvX: 0,
    d: "M-49 507l-45 62l-45 -62l-23 18l44 75h48l44 -75zM-38 561q0 11 4.5 17.5t10 11t10 8.5t4.5 12q0 12 -14 12q-15 0 -25 -10l-10 28q8 8 19.5 11t20.5 3q17 0 28 -11t11 -28q0 -13 -5 -20t-11.5 -12.5t-11.5 -10t-5 -11.5h-26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breveacute",
    horizAdvX: 0,
    d: "M-92 506q-31 0 -50 19t-19 61h38q2 -50 31 -50t29 50h40q0 -42 -19.5 -61t-49.5 -19zM-99 566l-20 21l63 73l27 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevetilde",
    horizAdvX: 0,
    d: "M-92 506q-31 0 -50 19t-19 61h38q2 -50 31 -50q28 0 30 50h39q0 -42 -19.5 -61t-49.5 -19zM-24 639q-9 -36 -37 -36q-17 0 -30.5 10.5t-28.5 10.5q-6 0 -12 -4t-8 -13l-23 13q5 18 15 27t23 9q17 0 30.5 -10t27.5 -10q15 0 21 17z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevehook",
    horizAdvX: 0,
    d: "M-92 506q-31 0 -50 19t-19 61h38q2 -50 31 -50q28 0 30 50h39q0 -42 -19.5 -61t-49.5 -19zM-111 571q0 11 4.5 17t9.5 10.5t9.5 8.5t4.5 11q0 12 -14 12q-12 0 -25 -10l-8 27q7 7 18.5 10t20.5 3q17 0 27.5 -10t10.5 -27q0 -12 -5 -19t-11.5 -12t-11.5 -9.5t-5 -11.5h-25 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflexacute",
    horizAdvX: 0,
    d: "M-47 507l-44 62l-46 -62l-23 18l44 75h48l44 -75zM-33 575l-20 21l60 71l28 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecircumflex",
    horizAdvX: 0,
    d: "M-47 507l-44 62l-46 -62l-23 18l44 75h48l44 -75zM-75 636l27 31l60 -71l-20 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevegrave",
    horizAdvX: 0,
    d: "M-91 506q-32 0 -51 19t-19 61h39q2 -50 31 -50t29 50h39q0 -42 -19 -61t-49 -19zM-155 624l27 31l63 -68l-20 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "carontilde",
    horizAdvX: 0,
    d: "M-47 507l-44 54l-46 -54l-23 18l44 67h48l44 -67zM-21 636q-5 -17 -15 -25t-23 -8q-17 0 -30 8t-28 8q-7 0 -11.5 -2.5t-7.5 -12.5l-24 13q5 18 14.5 26t23.5 8q17 0 30 -8t28 -8q6 0 11 2.5t8 12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".ttfautohint",
    horizAdvX: 0,
    d: "M0 0z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAC",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAA",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E92",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E85",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E84",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E83",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E82",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E81",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E80",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E6C",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04B2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04A0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0496",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u042A",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0416",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u040B",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0402",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u03B3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u039B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0394",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u017D",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u017B",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0179",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0178",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0176",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0175",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0174",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0164",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0162",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0104",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0102",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0100",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xDD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "w",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "Z",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "Y",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "W",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "T",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0237",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "j",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012F",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0427",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u03C0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "f",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "6",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\uE005",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u042F",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u0427",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "J",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "5",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "4",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "&",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0427",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u03C0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "f",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "6",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "psi",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE004",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE001",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE000",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2014",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2013",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF7",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EEF",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EED",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EEB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDD",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDC",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDA",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECD",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECC",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBF",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBD",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAC",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E93",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E85",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E83",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E81",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E63",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E62",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E5B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E4B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E45",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E13",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E0D",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0512",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04EF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04E9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04E8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04C8",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04C4",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04AB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04AA",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04A3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04A1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u049B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0498",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0497",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0491",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045C",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0454",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0453",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044C",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044A",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0449",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0448",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0446",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0442",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043C",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0439",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0438",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0436",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0433",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0432",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u041B",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0414",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0409",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0404",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03CD",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03CC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C5",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03BA",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B7",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AE",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AD",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u039B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0398",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0394",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0272",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01E7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01E6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01DD",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01B0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01A1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01A0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017C",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0177",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0175",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0173",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0171",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0169",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0161",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0160",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015B",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0159",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0157",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0155",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0153",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0152",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0151",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0150",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014D",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014B",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0148",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0146",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0144",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0123",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0122",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0121",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0120",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011B",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0119",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0117",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0115",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0113",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0111",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010D",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010B",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0107",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0106",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0105",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0104",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0103",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0102",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0101",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0100",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFC",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFB",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFA",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF9",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEA",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "z",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "y",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "x",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "w",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "u",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "s",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "r",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "q",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "p",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "o",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "n",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "m",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "g",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "e",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "d",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "c",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "a",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "Q",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "O",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "G",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "-",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "f",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "J",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u2026",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ".",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ",",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2014",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2013",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "-",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "7",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "4",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u2026",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EB0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EAE",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EAC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EAA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1EA0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u1E6C",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0513",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u04B2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u04A0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0496",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0459",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u043B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0434",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u042A",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0416",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u040B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0402",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u039B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0394",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0164",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0162",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0104",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0102",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u0100",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xC1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "X",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "T",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ".",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ",",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2026",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201D",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201C",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2019",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2018",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2014",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2013",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: ".",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "-",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: ",",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "'",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\"",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2026",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201E",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201A",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ".",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ",",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "'",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\"",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u2026",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201E",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201A",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ".",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ",",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "7",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2026",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201E",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2014",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2013",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "-",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "8",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "1",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2026",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ".",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ",",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u2026",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ".",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ",",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0237",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "j",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0427",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u03BB",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u03A6",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "/",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "psi",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uE001",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201E",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2014",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2013",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EEF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EED",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EEB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAE",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAA",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA8",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E93",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E85",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E83",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E81",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E63",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E5B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E4B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E45",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E13",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E0D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04EF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04E9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04C8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04B3",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04AB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04A3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u049B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0497",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0491",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0454",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0453",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0449",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0448",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0446",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0439",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0438",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0436",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0433",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0432",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03CD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03CC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03BA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u039B",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0394",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0272",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01E7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01DD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01B0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017E",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017C",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0177",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0175",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0173",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0171",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0169",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0161",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0159",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0157",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0155",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0151",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0148",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0146",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0144",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0123",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0121",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0117",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0115",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0113",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0111",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0105",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0103",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0101",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "z",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "y",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "w",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "n",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "m",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "-",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "?",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "&",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u03A6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "f",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "J",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "?",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\uE001",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201E",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201A",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2014",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2013",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EF6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EF2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EE3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EE1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EDF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EDD",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EDB",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ED1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ECF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1ECD",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EC1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EBF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EBD",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EBB",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB7",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAE",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAD",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAC",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAB",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAA",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA9",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA8",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA7",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E92",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E84",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E82",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E80",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E63",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E62",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E5B",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E4B",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E45",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E13",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E0D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0513",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0512",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04E9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04C8",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04C4",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04B2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04AB",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04A3",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u049B",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0491",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045F",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045D",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045C",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u045A",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0459",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0454",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0453",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u044E",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u044C",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u044B",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0449",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0448",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0446",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043F",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043D",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043C",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u043B",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0439",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0438",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0434",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0433",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0432",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u041B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0414",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0409",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03CC",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03BA",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B7",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03AE",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03AD",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03AC",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u039B",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0394",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0272",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01F9",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01F5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01E7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01DD",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01A1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u017D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u017B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0179",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0178",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0176",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0174",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0161",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0160",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015E",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015A",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0159",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0157",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0155",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0153",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0151",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014B",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0148",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0146",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0144",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0123",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0121",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0119",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0117",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0115",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0113",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0111",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0107",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0105",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0103",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0101",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF1",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEB",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEA",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE6",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE4",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xDD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "s",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "r",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "q",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "p",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "n",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "m",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Z",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Y",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "W",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "S",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "-",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03BB",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "&",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\uE005",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "f",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "?",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03C1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03B8",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03B6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03A9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03A6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "J",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "?",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "/",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "psi",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE004",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE003",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE002",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE001",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE000",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u203A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2039",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2014",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2013",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EEF",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EED",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EEB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE5",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDE",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECE",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAF",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAD",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAC",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E93",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E85",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E83",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E81",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E63",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E62",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E5B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E4B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E45",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E13",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E0D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04EF",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04E9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04E8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04C8",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04C4",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04B3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04AB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04AA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04A3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u049B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0497",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0491",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045E",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045C",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045A",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0454",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0453",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044E",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044C",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0449",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0448",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0446",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043C",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0439",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0438",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0436",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0433",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0432",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0404",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03CD",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03CC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C5",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03BA",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u039B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0398",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0394",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0272",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01E7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01E6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01DD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01B0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01A1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01A0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017E",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0177",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0175",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0173",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0171",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0169",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0161",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0160",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015E",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015A",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0157",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0155",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0152",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0151",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0150",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0148",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0146",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0144",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0123",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0122",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0121",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0120",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0119",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0117",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0115",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0113",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0111",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010F",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010D",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010B",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0107",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0106",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0105",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0104",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0103",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0102",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0101",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0100",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xBB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "z",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "w",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "s",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "n",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "g",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "d",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "S",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "f",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "?",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "J",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "?",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "&",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03C7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03B8",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03B6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03A8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03A6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03C1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03A9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "J",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "?",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "&",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0237",
    k: -85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "j",
    k: -85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u012F",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u03C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u0237",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u012F",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "?",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0237",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "j",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u012F",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "\u0237",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "j",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0237",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u03BB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "f",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "&",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u03BB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "f",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03C1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03C1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u0237",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "j",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u012F",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0237",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "j",
    k: -84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u012F",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "J",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0427",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "J",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD9",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDA",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDB",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDC",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03C1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03A9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "J",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u03C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "\u0237",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "\u03C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "\u03C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "\u03C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "\u0237",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "\u012F",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u03A6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "f",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "J",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "?",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "\u0237",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0142",
    u2: "\u0142",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "\u03BB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "\u03BB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u03BB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\uE005",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "f",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "?",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "f",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "&",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\uE005",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "f",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "?",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "f",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "&",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\uE005",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "f",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "?",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "f",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "&",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03C1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03B8",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03B6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03A9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03A6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "J",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "?",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "/",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "\u03BB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "f",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03C1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03B8",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03B6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03A9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03A6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "J",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "?",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "/",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "\u03BB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "f",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0168",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016A",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016C",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u016E",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0170",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0172",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "\u0237",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "J",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "?",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "&",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03C1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03C1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03A9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "J",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03C1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03A9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "J",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "J",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "?",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "&",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "J",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "?",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "&",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "J",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "?",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "&",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01E6",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F9",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F9",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0237",
    u2: "\u012F",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u024C",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0272",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0272",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03C1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03A9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "J",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EB0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EAE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EAC",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EAA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u1EA0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0513",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0512",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0459",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u043B",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0434",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u041B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0414",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0409",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03CA",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03B9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03AF",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u039B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0394",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0104",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0102",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0100",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\xC1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03A6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EB0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EAE",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EAC",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EAA",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA8",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1EA0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1E6C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0513",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0512",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u04B2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u04A0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0496",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0459",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u043B",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0434",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u042A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u041B",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0414",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u040B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0409",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0402",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u039B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0394",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0164",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0162",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0104",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0102",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0100",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC4",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\xC1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "T",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\uE001",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EE3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EE1",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EDF",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EDD",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EDB",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED9",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ED1",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ECF",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1ECD",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EC1",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EBF",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EBD",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EBB",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB9",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAA",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1E13",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1E0D",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u04E9",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u04B2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u04AB",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0496",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0454",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0416",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03CE",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03CC",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C9",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C6",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C2",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03B5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03B1",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03AD",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03AC",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u039B",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0394",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u01DD",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u01A1",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0153",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0151",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u014F",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u014D",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u011B",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0119",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0117",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0115",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0113",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0111",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u010F",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u010D",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u010B",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0107",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0104",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0102",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0100",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF6",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF5",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF4",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF3",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF2",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xF0",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xEB",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xEA",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xE9",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xE8",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xE7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "q",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "o",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "e",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "d",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "c",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C1",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AC",
    u2: "\u03C7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "\u03C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AF",
    u2: "\u03C7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B1",
    u2: "\u03C7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03C1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "\u03C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    g2: "psi",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\uE001",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EF1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EEF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EED",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EEB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ECF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ECD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EB9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E5B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E4B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E45",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E13",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E0D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04E9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04C8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04C4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04AB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04A3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04A1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u049B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0454",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0453",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0449",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0448",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0446",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0442",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0439",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0438",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0433",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0432",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CE",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CD",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C4",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03BA",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0272",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01F9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01DD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01B0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01A1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0173",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0171",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0169",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0159",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0157",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0155",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0153",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0151",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0148",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0146",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0144",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u011B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0119",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0117",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0115",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0113",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0111",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0107",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFC",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFA",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF9",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xEB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xEA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "u",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "r",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "q",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "p",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "o",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "n",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "m",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "e",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "d",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "c",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u1E6C",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u04A0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u042A",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u040B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u0402",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u0164",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "\u0162",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B7",
    u2: "T",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B9",
    u2: "\u03C7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    g2: "psi",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\uE001",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u201D",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u201C",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u2019",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u2018",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EF1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EEF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EED",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EEB",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE9",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE7",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDD",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED9",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ECF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ECD",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBD",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EB9",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E85",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E83",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E81",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E13",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E0D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04E9",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04AB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04A1",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0454",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u044A",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0442",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CE",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CD",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C4",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03AD",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03AC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01DD",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01B0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01A1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0175",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0173",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0171",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016B",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0169",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0153",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0151",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u014F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u014D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u011B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0119",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0117",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0115",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0113",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0111",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0107",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFC",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFB",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFA",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF9",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xEB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xEA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE9",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "w",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "u",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "q",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "o",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "e",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "d",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "c",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "'",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\"",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\uE001",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EE3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EE1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EDF",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EDD",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EDB",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ED1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ECF",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1ECD",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EC1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EBF",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EBD",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EBB",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1EB9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1E13",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u1E0D",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u04E9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u04AB",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0454",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03CC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03C6",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03C3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03C2",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03B5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03B1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03AD",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u03AC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u01DD",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u01A1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0153",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0151",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u014F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u014D",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u011B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0119",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0117",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0115",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0113",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0111",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u010F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u010D",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u010B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u0107",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF6",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF4",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF2",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xEB",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xEA",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xE9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xE8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xE7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "q",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "o",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "e",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "d",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "c",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    g2: "psi",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\uE001",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u2026",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u201E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u201A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EF1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EEF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EED",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EEB",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EE1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EDF",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EDD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EDB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED7",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ED1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ECF",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1ECD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC7",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EC1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EBF",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EBD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EBB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1EB9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E85",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E83",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E81",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E13",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E0D",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u04E9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u04AB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u04A1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0454",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u044A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0442",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CD",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CC",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03CA",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C6",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03C2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03AF",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03AD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03AC",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u01DD",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u01B0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u01A1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0175",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0173",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0171",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u016F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u016D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u016B",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0169",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0153",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0151",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u014F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u014D",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u011B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0119",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0117",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0115",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0113",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0111",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u010F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u010D",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u010B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0107",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xFC",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xFB",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xFA",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF8",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF6",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF4",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xF0",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xEB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xEA",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xE9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xE8",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\xE7",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "w",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "u",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "q",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "o",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "e",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "d",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "c",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: ".",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: ",",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\uE001",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EE3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EE1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDD",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ECF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ECD",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBD",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EB9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1E13",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1E0D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u04E9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u04AB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0454",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03CC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03B5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03AD",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03AC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u01DD",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u01A1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0153",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0151",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u014F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u014D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u011B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0119",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0117",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0115",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0113",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0111",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0107",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xEB",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xEA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE8",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "q",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "o",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "e",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "d",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "c",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\uE001",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EE3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EE1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDD",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDB",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ECF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ECD",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBD",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBB",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EB9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1E13",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1E0D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u04E9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u04AB",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0454",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03CC",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C6",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03B5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03B1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03AD",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03AC",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u01DD",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u01A1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0153",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0151",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u014F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u014D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u011B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0119",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0117",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0115",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0113",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0111",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0107",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF8",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF6",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF4",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xEB",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xEA",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE8",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "q",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "o",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "e",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "d",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "c",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\uE001",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EE3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EE1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ECF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ECD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EB9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1E13",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1E0D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u04E9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u04AB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0499",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u044D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0437",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CE",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CA",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AF",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u01DD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u01A1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0153",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0151",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u014F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u014D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u011B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0119",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0117",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0115",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0113",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0111",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0107",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xEB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xEA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "o",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "e",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C9",
    u2: "\u03C7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C9",
    u2: "\u03BB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CA",
    u2: "\u03C7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CE",
    u2: "\u03C7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CE",
    u2: "\u03BB",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0427",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "/",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0427",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "/",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\u03A6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "f",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "J",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "?",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040E",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB6",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB4",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EB0",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EAE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EAC",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EAA",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA8",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA6",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA4",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1EA0",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1E6C",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0513",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04A0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0496",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0459",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u043B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0434",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0416",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u039B",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0394",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0164",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0162",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0104",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0102",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0100",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC6",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC4",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\xC1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "X",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "T",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "A",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0427",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u03A6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "J",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03C7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03B8",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03B6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03A8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03A6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0423",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0427",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u03A6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "J",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0427",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u03A6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "J",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "/",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\uE005",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "/",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0513",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u043B",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u201D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u201C",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u2019",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u2018",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u1E85",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u1E83",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u1E81",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0513",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04A1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0497",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u044A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u043B",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0434",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u03C4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u03B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0175",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "'",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\"",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0447",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u03C1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u03BB",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0447",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u03C1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u03BB",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0447",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0447",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u03C1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u03BB",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u03C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u03C1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u03BB",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0427",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u03A6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "J",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0447",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0427",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u03A6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "J",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0447",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "\u03A6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "f",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "J",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "?",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u0427",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u03A6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "J",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0447",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u03C7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0427",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u03A6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "J",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0447",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u0427",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u03A6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "J",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0447",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04EE",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E25",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E25",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "V",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E45",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E45",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E4B",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E4B",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5B",
    u2: "\u03BB",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5B",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\uE005",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0427",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "f",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "V",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "?",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "f",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "&",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03C1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03B8",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03B6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03A9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03A6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "J",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "?",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "/",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "\u03BB",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "f",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "J",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "?",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "&",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03C1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "J",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "?",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "&",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03C1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "J",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "?",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "&",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03C1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "J",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "?",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "&",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u201D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u201C",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u2019",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u2018",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EF6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EF2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAA",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA8",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E84",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E82",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E80",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E6C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u04B2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u04A0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0496",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u042A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0416",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u040B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0402",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u039B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0394",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0178",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0176",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0174",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0164",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0162",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0104",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0102",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0100",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xDD",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC6",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "Y",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "W",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "T",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "'",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\"",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA1",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA1",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA3",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA3",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA5",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA5",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA7",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA7",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA9",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA9",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAB",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAB",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAD",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAD",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAF",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAF",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB1",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB1",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB3",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB3",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB5",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB5",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u0427",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03C0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03A8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03A6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "f",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "V",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "&",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB7",
    u2: "f",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB7",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\uE005",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\u03BB",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "f",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "?",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE4",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EE6",
    u2: "/",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03C1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03A9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "J",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03C1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03B8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03A9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "J",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "&",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\uE005",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u042F",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u0427",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "J",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "5",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "4",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "&",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\uE005",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u042F",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u0427",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "f",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "V",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "J",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "5",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "4",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "3",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "/",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "&",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0427",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u03C0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "f",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "6",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0427",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u03C0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "f",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "6",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u0427",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u03C0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "f",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "V",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "J",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "6",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "J",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0427",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "J",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE002",
    u2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE002",
    u2: "J",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "\u0427",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "J",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u042F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03C7",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03C1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03BB",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03B8",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03B6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03A9",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03A6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "f",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "J",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "?",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "/",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "&",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    g2: "psi",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE004",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE001",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE000",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2026",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u201E",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u201A",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2014",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2013",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EEF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EED",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EEB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDE",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECE",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAE",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAC",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAA",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA8",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E93",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E85",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E83",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E81",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E63",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E62",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E5B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E4B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E45",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E13",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E0D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0512",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04EF",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04E9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04E8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04C8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04C4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04AB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04AA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04A3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04A1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u049B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0498",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0497",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0491",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045A",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0454",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0453",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0449",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0448",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0446",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0439",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0438",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0436",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0433",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0432",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u042D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u041B",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0414",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0409",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0404",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03CD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03CC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03BA",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u039B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0398",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0394",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0272",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01E7",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01E6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01DD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01B0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01A1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01A0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u018F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0177",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0175",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0173",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0171",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0169",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0161",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0160",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0159",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0157",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0155",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0153",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0152",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0151",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0150",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0148",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0146",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0144",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0123",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0121",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0120",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0119",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0117",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0115",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0113",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0111",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0107",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0106",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0104",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0102",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0100",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFD",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFA",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xEB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xEA",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "y",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "u",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "s",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "r",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "q",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "p",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "o",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "n",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "m",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "g",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "e",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "d",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "c",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "S",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "Q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "O",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "G",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "A",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: ".",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "-",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: ",",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u042F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "f",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "J",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "hyphen,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "uni042D,uni0498",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "iotatonos,iota,iotadieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "omega,omegatonos",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "Alphatonos,Epsilontonos,Etatonos,Iotatonos,Omicrontonos,Upsilontonos,Omegatonos",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "hyphen,endash,emdash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "uni042D,uni0498",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "iotatonos,iota,iotadieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "hyphen,endash,emdash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,D,O,Q,Ccedilla,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Cacute,Cdotaccent,Ccaron,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni0404,uni042D,uni042E,uni04AA,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "j,dotlessj",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "hyphen,endash,emdash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni042D,uni0498",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "iotatonos,iota,iotadieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "omega,omegatonos",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "j,dotlessj",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "hyphen,endash,emdash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "uni042D,uni0498",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "iotatonos,iota,iotadieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "omega,omegatonos",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "hyphen,endash,emdash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni042D,uni0498",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "iotatonos,iota,iotadieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "omega,omegatonos",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni0437,uni044D,uni0499",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "hyphen,endash,emdash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "iotatonos,iota,iotadieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "omega,omegatonos",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "uni0437,uni044D,uni0499",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "hyphen,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "j,dotlessj",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j,ij,dotlessj",
    g2: "j,dotlessj",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "hyphen,endash,emdash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "j,dotlessj",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "uni0437,uni044D,uni0499",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "j,dotlessj",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "hyphen,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "hyphen,endash,emdash",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "hyphen,endash,emdash",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "hyphen,endash,emdash",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "omega,omegatonos",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "hyphen,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "omega,omegatonos",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "uni0437,uni044D,uni0499",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "hyphen,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "hyphen,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "uni042D,uni0498",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "j,dotlessj",
    k: -85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "uni0437,uni044D,uni0499",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437,uni0499",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437,uni0499",
    g2: "uni0437,uni044D,uni0499",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Omegatonos,Omega",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Omegatonos,Omega",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "hyphen,endash,emdash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "omega,omegatonos",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "iotatonos,iota,iotadieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "j,dotlessj",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni042D,uni0498",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Alphatonos,Epsilontonos,Etatonos,Iotatonos,Omicrontonos,Upsilontonos,Omegatonos",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "j,dotlessj",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "hyphen,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1,psi",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "uni042D,uni0498",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "j,dotlessj",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "j,dotlessj",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "uni042D,uni0498",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolveticaCrammedRgRegular);
export default __webpack_public_path__ + "static/media/CoolveticaCrammedRg-Regular.90db7b5bbc1d7d773eb0ac4a74164d2d.svg";
export { ForwardRef as ReactComponent };